export const potok = [
  {
    id: "62ba0c283ca1f692853ebe97",
    like: false,
    name: "Dance Wave Retro!",
    url: "http://retro.dancewave.online/retrodance.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebe98",
    like: false,
    name: "Dance Wave!",
    url: "http://dancewave.online/dance.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebe99",
    like: false,
    name: "Deep Melon radio",
    url: "http://stream.melonradio.com/deep",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebe9d",
    like: false,
    name: "Dorognoe frontovaya",
    url: "http://dorognoe.hostingradio.ru:8000/dorognoe1945.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebea1",
    like: false,
    name: "Fresh FM Sosnovy Bor 105.0 Mhz",
    url: "http://a2.radioheart.ru:8007/live",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebea9",
    like: false,
    name: "House Melon radio",
    url: "http://stream.melonradio.com/house",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebeab",
    like: false,
    name: "Jazz FM.ru - Instrumental Jazz",
    url: "http://jfm1.hostingradio.ru:14536/ijstream.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebeac",
    like: false,
    name: "Jazz FM.ru - Jazz Legends",
    url: "http://jfm1.hostingradio.ru:14536/jlstream.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebeaf",
    like: false,
    name: "Lounge Melon radio",
    url: "http://stream.melonradio.com/lounge",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ebedd",
    like: false,
    name: "Radio DRIVE www.radiogora.ru",
    url: "http://listen.radiogora.ru:8000/drive128",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebede",
    like: false,
    name: "Radio ELECTRO www.radiogora.ru",
    url: "http://listen.radiogora.ru:8000/electro32",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ebee0",
    like: false,
    name: "Radio ET CETERA www.radiogora.ru",
    url: "http://listen.radiogora.ru:8000/etc320",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ebee4",
    like: false,
    name: "Radio HIPHOP www.radiogora.ru",
    url: "http://listen.radiogora.ru:8000/hiphop128",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebee5",
    like: false,
    name: "Radio HITMIX www.radiogora.ru",
    url: "http://listen.radiogora.ru:8000/hitmix128",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ebee7",
    like: false,
    name: "Radio Lyantor 100.3 FM",
    url: "http://a2.radioheart.ru:8015/admin",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ebeea",
    like: false,
    name: "Radio Mixa Dance FM",
    url: "https://stream.mixadance.fm/mixadance",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ebeed",
    like: false,
    name: "Radio OLDIES www.radiogora.ru",
    url: "http://listen.radiogora.ru:8000/oldies128",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebeee",
    like: false,
    name: "Radio Podsolnuh 102.9 FM",
    url: "http://live.podsolnuh.media:8000/radio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ebef0",
    like: false,
    name: "Radio REDNOISE www.radiogora.ru",
    url: "http://listen.radiogora.ru:8000/rednoise128",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ebef9",
    like: false,
    name: "Radio-Remix",
    url: "http://radio-remix.ru:8000/radio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebefd",
    like: false,
    name: "Radiokrylya",
    url: "https://myradio24.org/rkradio_256.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebf0b",
    like: false,
    name: "Soulful Melon radio",
    url: "http://stream.melonradio.com/soulful",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebf15",
    like: false,
    name: "Tipichnoe FM Щелково",
    url: "http://myradio24.org/9696",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebf1a",
    like: false,
    name: "Yum FM",
    url: "http://yumfm.hostingradio.ru:8020/yumfm128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ebf30",
    like: false,
    name: "Радио Буу!",
    url: "http://buu.hostingradio.ru:8005/radio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebf31",
    like: false,
    name: "Радио Книга 105.0  MSK",
    url: "http://bookradio.hostingradio.ru:8069/fm",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebf33",
    like: false,
    name: "Радио Меридиан",
    url: "http://stream.gtf.club:8030/stream",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebf38",
    like: false,
    name: "Радио Родных Дорог",
    url: "http://stream1.radiord.ru:8000/live96.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ebfc5",
    like: false,
    name: "Europa Plus",
    url: "http://ep256.hostingradio.ru:8052/europaplus256.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ebfc7",
    like: false,
    name: "Fresh FM",
    url: "http://a2.radioheart.ru:8007/live",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebfc8",
    like: false,
    name: "G-Drive Radio",
    url: "http://m4m128.hostingradio.ru:8074/m4m128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ebfd2",
    like: false,
    name: "Kamchatka Live-Chill",
    url: "http://radio.kamchatkalive.ru:8100/chillout",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebfd3",
    like: false,
    name: "Kamchatka Live-Dance",
    url: "http://radio.kamchatkalive.ru:8100/dance",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebfd4",
    like: false,
    name: "Kamchatka Live-Rock",
    url: "http://radio.kamchatkalive.ru:8100/rock",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ebfde",
    like: false,
    name: "Mixadance FM-Main",
    url: "https://stream.mixadance.fm/mixadance128",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ebfe9",
    like: false,
    name: "Radio Gora-ATD",
    url: "http://listen.radiogora.ru:8000/atd128",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebfea",
    like: false,
    name: "Radio Gora-Drive",
    url: "http://listen.radiogora.ru:8000/drive128",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebfeb",
    like: false,
    name: "Radio Gora-Electro",
    url: "http://listen.radiogora.ru:8000/electro128",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebfec",
    like: false,
    name: "Radio Gora-Et Cetera",
    url: "http://listen.radiogora.ru:8000/etc128",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebfed",
    like: false,
    name: "Radio Gora-Freaky Funky",
    url: "http://listen.radiogora.ru:8000/freakyfunky320",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebfee",
    like: false,
    name: "Radio Gora-Groove Cafe",
    url: "http://listen.radiogora.ru:8000/groovecafe320",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ebff2",
    like: false,
    name: "Rock FM-00",
    url: "http://jfm1.hostingradio.ru:14536/rock00.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebff3",
    like: false,
    name: "Rock FM-70",
    url: "http://jfm1.hostingradio.ru:14536/rock70.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebff4",
    like: false,
    name: "Rock FM-80",
    url: "http://jfm1.hostingradio.ru:14536/rock80.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebff5",
    like: false,
    name: "Rock FM-90",
    url: "http://jfm1.hostingradio.ru:14536/rock90.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebff6",
    like: false,
    name: "Rock FM-Heavy",
    url: "http://jfm1.hostingradio.ru:14536/metal.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebff7",
    like: false,
    name: "Rock FM-Prog",
    url: "http://jfm1.hostingradio.ru:14536/prog.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ebff8",
    like: false,
    name: "Rock FM",
    url: "https://nashe1.hostingradio.ru:18000/rock-256",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec013",
    like: false,
    name: "Yum FM",
    url: "http://yumfm.hostingradio.ru:8020/yumfm128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec014",
    like: false,
    name: "Zaycev.fm-K-Pop",
    url: "https://zaycevfm.cdnvideo.ru/ZaycevFM_kpop_128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec016",
    like: false,
    name: "Бизнес FM",
    url: "http://bfm.hostingradio.ru:8004/fm",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec01e",
    like: false,
    name: "ВЭБ Радио",
    url: "http://m5m128.hostingradio.ru:8074/m5m128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec01f",
    like: false,
    name: "Говорит Майкоп",
    url: "http://voicemaikop.hostingradio.ru:8003/voicemaikop128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec025",
    like: false,
    name: "Дорожное Радио СПб",
    url: "http://dorognoe.hostingradio.ru:8000/radio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec02b",
    like: false,
    name: "Кавказ Хит",
    url: "http://kavkazhit.hostingradio.ru:8017/kavkazhit96.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec02d",
    like: false,
    name: "Классное Радио",
    url: "http://schoolradio.hostingradio.ru:8026/schoolradio128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec038",
    like: false,
    name: "Наше 2.0",
    url: "https://nashe1.hostingradio.ru:18000/nashe20-256",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec039",
    like: false,
    name: "Наше Радио Классик-рок",
    url: "https://nashe1.hostingradio.ru:18000/nasheclassic.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec03a",
    like: false,
    name: "Наше Радио Панки-хой!",
    url: "https://nashe1.hostingradio.ru:18000/nashepunks.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec03b",
    like: false,
    name: "Наше Радио Щас-спою",
    url: "https://nashe1.hostingradio.ru:18000/nashesongs.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec03c",
    like: false,
    name: "Наше Радио",
    url: "https://nashe1.hostingradio.ru:18000/nashe-256",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec03d",
    like: false,
    name: "Нефтерадио",
    url: "http://m10m128.hostingradio.ru:8074/m10m128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec04b",
    like: false,
    name: "Радио Best",
    url: "https://nashe1.hostingradio.ru:18000/best-256",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec04e",
    like: false,
    name: "Радио Jazz-Classic",
    url: "http://jfm1.hostingradio.ru:14536/ijstream.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec04f",
    like: false,
    name: "Радио Jazz-Jazz Legends",
    url: "http://jfm1.hostingradio.ru:14536/jlstream.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec050",
    like: false,
    name: "Радио Jazz-Smooth Jazz",
    url: "http://jfm1.hostingradio.ru:14536/sjstream.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec051",
    like: false,
    name: "Радио Ultra",
    url: "https://nashe1.hostingradio.ru:18000/ultra-256",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec05b",
    like: false,
    name: "Радио Буу",
    url: "http://buu.hostingradio.ru:8005/radio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec05c",
    like: false,
    name: "Радио Вера-Вера и время",
    url: "http://radiovera.hostingradio.ru:8007/radioveragorod128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec05d",
    like: false,
    name: "Радио Вера-Классик",
    url: "http://radiovera.hostingradio.ru:8007/radioverausadba128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec05f",
    like: false,
    name: "Радио Вера-О людях и смыслах",
    url: "http://radiovera.hostingradio.ru:8007/radioverasvetliyvecher128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec060",
    like: false,
    name: "Радио Вера",
    url: "http://radiovera.hostingradio.ru:8007/radiovera_128",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec062",
    like: false,
    name: "Радио Гамаюн",
    url: "http://gamaun.online:8010/radio",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec066",
    like: false,
    name: "Радио Искатель",
    url: "http://iskatel.hostingradio.ru:8015/iskatel-128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec070",
    like: false,
    name: "Радио Книга",
    url: "http://bookradio.hostingradio.ru:8069/fm",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec07d",
    like: false,
    name: "Радио Нестандарт",
    url: "http://listen.radionestandart.ru:8200/128.mp3",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec18d",
    like: false,
    name: "0N 70s",
    url: "https://str.pcradio.ru/zeron_70s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec18e",
    like: false,
    name: "0N 80s",
    url: "https://str.pcradio.ru/zeron_80s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec18f",
    like: false,
    name: "0N 90s",
    url: "https://str.pcradio.ru/zeron_90s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec190",
    like: false,
    name: "0N Charts",
    url: "https://str.pcradio.ru/zeron_charts-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec191",
    like: false,
    name: "0N Dance",
    url: "https://str.pcradio.ru/zeron_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec192",
    like: false,
    name: "0N Disco",
    url: "https://str.pcradio.ru/zeron_disco-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec193",
    like: false,
    name: "0N Electro",
    url: "https://str.pcradio.ru/zeron_electro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec194",
    like: false,
    name: "0N Gay",
    url: "https://str.pcradio.ru/zeron_lgbt-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec195",
    like: false,
    name: "0N Schlager",
    url: "https://str.pcradio.ru/zeron_schlager-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec196",
    like: false,
    name: "1 Oldies",
    url: "https://str.pcradio.ru/oldies_1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec197",
    like: false,
    name: "1.FM A 80s",
    url: "https://str.pcradio.ru/one_list80s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec198",
    like: false,
    name: "1.FM Absolute 70s",
    url: "https://str.pcradio.ru/one_70spop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec199",
    like: false,
    name: "1.FM Absolute 90s",
    url: "https://str.pcradio.ru/one_absolute90s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec19a",
    like: false,
    name: "1.FM Absolute 90s Party Zone",
    url: "https://str.pcradio.ru/one_absolute90party-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec19b",
    like: false,
    name: "1.FM Absolute Country Hits",
    url: "https://str.pcradio.ru/one_absolute_country-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec19c",
    like: false,
    name: "1.FM Absolute Pop Latino",
    url: "https://str.pcradio.ru/one_abs_latino-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec19d",
    like: false,
    name: "1.FM Absolute Top 40",
    url: "https://str.pcradio.ru/one_absolute40-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec19e",
    like: false,
    name: "1.FM Absolute Trance (Euro)",
    url: "https://str.pcradio.ru/one_abs_tranceeuro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec19f",
    like: false,
    name: "1.FM Acapella",
    url: "https://str.pcradio.ru/one_acapella-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1a0",
    like: false,
    name: "1.FM Adore Jazz",
    url: "https://str.pcradio.ru/one_adore_jazz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1a1",
    like: false,
    name: "1.FM Adult Urban Hits",
    url: "https://str.pcradio.ru/one_urbanhits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1a2",
    like: false,
    name: "1.FM Afterbeat Electronica",
    url: "https://str.pcradio.ru/one_afterelectro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1a3",
    like: false,
    name: "1.FM All Euro 80s",
    url: "https://str.pcradio.ru/one_euro80-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1a4",
    like: false,
    name: "1.FM All Times and Urban Gospel",
    url: "https://str.pcradio.ru/one_urbangospel-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1a5",
    like: false,
    name: "1.FM Alternative Rock X Hits",
    url: "https://str.pcradio.ru/one_rock_x-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1a6",
    like: false,
    name: "1.FM Always Christmas",
    url: "https://str.pcradio.ru/one_xmas-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1a7",
    like: false,
    name: "1.FM America's Best Ballads",
    url: "https://str.pcradio.ru/one_amer_ballads-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1a8",
    like: false,
    name: "1.FM Amsterdam Trance",
    url: "https://str.pcradio.ru/one_amsterdam-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1a9",
    like: false,
    name: "1.FM Back to the 50s and 60s",
    url: "https://str.pcradio.ru/one_50s60s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1aa",
    like: false,
    name: "1.FM Bay Smooth Jazz",
    url: "https://str.pcradio.ru/one_baysmooth-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1ab",
    like: false,
    name: "1.FM Blues",
    url: "https://str.pcradio.ru/one_blues-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1ac",
    like: false,
    name: "1.FM BOM Psytrance",
    url: "https://str.pcradio.ru/one_bom_psy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1ad",
    like: false,
    name: "1.FM Bombay Beats India",
    url: "https://str.pcradio.ru/one_bombaybeats-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1ae",
    like: false,
    name: "1.FM Bossa Nova Hits",
    url: "https://str.pcradio.ru/one_bossa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1af",
    like: false,
    name: "1.FM Cafe",
    url: "https://str.pcradio.ru/one_cafe-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1b0",
    like: false,
    name: "1.FM Chillout Lounge",
    url: "https://str.pcradio.ru/one_chillout-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1b1",
    like: false,
    name: "1.FM Circuit Pride",
    url: "https://str.pcradio.ru/one_circuit_pride-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1b2",
    like: false,
    name: "1.FM Classic Country",
    url: "https://str.pcradio.ru/one_class_country-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1b3",
    like: false,
    name: "1.FM Classic Rock Replay",
    url: "https://str.pcradio.ru/one_rock_replay-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1b4",
    like: false,
    name: "1.FM Club",
    url: "https://str.pcradio.ru/one_club1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1b5",
    like: false,
    name: "1.FM Country One",
    url: "https://str.pcradio.ru/one_country_one-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1b6",
    like: false,
    name: "1.FM Deep House",
    url: "https://str.pcradio.ru/one_deephouse-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1b7",
    like: false,
    name: "1.FM Destination SPA",
    url: "https://str.pcradio.ru/one_destination_spa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1b8",
    like: false,
    name: "1.FM Disco Ball 70s-80s",
    url: "https://str.pcradio.ru/one_discoball-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1b9",
    like: false,
    name: "1.FM Dubstep Forward",
    url: "https://str.pcradio.ru/one_dubstepforw-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1ba",
    like: false,
    name: "1.FM Eternal Praise and Worship",
    url: "https://str.pcradio.ru/one_eternalpraise-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1bb",
    like: false,
    name: "1.FM Funky Express",
    url: "https://str.pcradio.ru/one_funky_exp-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1bc",
    like: false,
    name: "1.FM Gorilla FM",
    url: "https://str.pcradio.ru/one_gorilla-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1bd",
    like: false,
    name: "1.FM High Voltage",
    url: "https://str.pcradio.ru/one_highvolt-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec1bf",
    like: false,
    name: "1.FM Jamz",
    url: "https://str.pcradio.ru/one_jamz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1c0",
    like: false,
    name: "1.FM Kids FM",
    url: "https://str.pcradio.ru/one_kids-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1c1",
    like: false,
    name: "1.FM Love Classics",
    url: "https://str.pcradio.ru/one_loveclass-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1c2",
    like: false,
    name: "1.FM Magic 80s",
    url: "https://str.pcradio.ru/one_magic80s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1c3",
    like: false,
    name: "1.FM MPB Hits",
    url: "https://str.pcradio.ru/one_mpb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1c4",
    like: false,
    name: "1.FM Otto's Baroque Music",
    url: "https://str.pcradio.ru/one_ottobaroque-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1c5",
    like: false,
    name: "1.FM Otto's Classical Music",
    url: "https://str.pcradio.ru/one_ottoclassic-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1c6",
    like: false,
    name: "1.FM Otto's Opera House Music",
    url: "https://str.pcradio.ru/one_ottoopera-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1c7",
    like: false,
    name: "1.FM Polska FM",
    url: "https://str.pcradio.ru/one_polska-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1c8",
    like: false,
    name: "1.FM Radio Gaia",
    url: "https://str.pcradio.ru/one_gaia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1c9",
    like: false,
    name: "1.FM ReggaeTrade",
    url: "https://str.pcradio.ru/one_reggae-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1ca",
    like: false,
    name: "1.FM Rock Classics",
    url: "https://str.pcradio.ru/one_rockclassics-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1cb",
    like: false,
    name: "1.FM Samba Hits Brazil",
    url: "https://str.pcradio.ru/one_sambahits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1cc",
    like: false,
    name: "1.FM Samba Rock",
    url: "https://str.pcradio.ru/one_sambarock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1cd",
    like: false,
    name: "1.FM Sertaneja Hits",
    url: "https://str.pcradio.ru/one_sertaneja-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1ce",
    like: false,
    name: "1.FM Slow Jamz",
    url: "https://str.pcradio.ru/one_slowjamz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1cf",
    like: false,
    name: "1.FM Top Fiesta",
    url: "https://str.pcradio.ru/one_topfiesta-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1d0",
    like: false,
    name: "1.FM Total Hits En Español",
    url: "https://str.pcradio.ru/one_hitsespanol-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1d1",
    like: false,
    name: "1.Kla$ 18+",
    url: "https://str.pcradio.ru/first_klas-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1d2",
    like: false,
    name: "100 XR",
    url: "https://str.pcradio.ru/hundred_xr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1d3",
    like: false,
    name: "100% NL",
    url: "https://str.pcradio.ru/nl100pnl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec1d7",
    like: false,
    name: "100'5 Das Hitradio",
    url: "https://str.pcradio.ru/dashit_1005-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1d8",
    like: false,
    name: "1000 Hits 80s",
    url: "https://str.pcradio.ru/hits1000_80-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1d9",
    like: false,
    name: "1000 Oldies",
    url: "https://str.pcradio.ru/laut_1000oldies-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1da",
    like: false,
    name: "100hitz - Heavy Metal",
    url: "https://str.pcradio.ru/hitz100_metal-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1db",
    like: false,
    name: "101FM - 80er",
    url: "https://str.pcradio.ru/fm101_80er-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1dc",
    like: false,
    name: "102.1 The Edge",
    url: "https://str.pcradio.ru/theedge_1021-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec1de",
    like: false,
    name: "1055 Rock",
    url: "https://str.pcradio.ru/rock_1055_gr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1df",
    like: false,
    name: "12 Port",
    url: "https://str.pcradio.ru/port_12-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1e0",
    like: false,
    name: "140 Ударов в минуту",
    url: "https://str.pcradio.ru/sto40_udarov_v_minutu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1e1",
    like: false,
    name: "161 FM",
    url: "https://str.pcradio.ru/hundred61_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1e2",
    like: false,
    name: "16Bit FM - Cafe",
    url: "https://str.pcradio.ru/bit16_cafe-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1e3",
    like: false,
    name: "16Bit FM - I.D.E.A.",
    url: "https://str.pcradio.ru/bit16_idea-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1e4",
    like: false,
    name: "16Bit FM - ProBeat",
    url: "https://str.pcradio.ru/bit16_probeat-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1e5",
    like: false,
    name: "181 FM - The Beat",
    url: "https://str.pcradio.ru/fm181_thebeat-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1e6",
    like: false,
    name: "181 FM 80's Hairband",
    url: "https://str.pcradio.ru/fm181_80s_hairband-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1e7",
    like: false,
    name: "181 FM Acid Jazz",
    url: "https://str.pcradio.ru/fm181_acidjazz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1e8",
    like: false,
    name: "181 FM Rock",
    url: "https://str.pcradio.ru/fm181_rock181-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec1ea",
    like: false,
    name: "181 FM The Buzz",
    url: "https://str.pcradio.ru/fm181_thebuzz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1eb",
    like: false,
    name: "18 Hits",
    url: "https://str.pcradio.ru/eighteen_hits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1ec",
    like: false,
    name: "1 LIVE",
    url: "https://str.pcradio.ru/one_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1ed",
    like: false,
    name: "1 LIVE diggi",
    url: "https://str.pcradio.ru/wdr_1live_diggi-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec1f0",
    like: false,
    name: "247 Blitz",
    url: "https://str.pcradio.ru/blitz_247-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1f1",
    like: false,
    name: "247 Spice",
    url: "https://str.pcradio.ru/spice_247-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1f2",
    like: false,
    name: "2 Pac",
    url: "https://str.pcradio.ru/pac2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1f3",
    like: false,
    name: "2 PM",
    url: "https://str.pcradio.ru/two_pm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1f4",
    like: false,
    name: "30 Seconds to Mars",
    url: "https://str.pcradio.ru/thirty_Seconds_To_Mars-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec1f6",
    like: false,
    name: "40 Principales",
    url: "https://str.pcradio.ru/principales-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1f7",
    like: false,
    name: "42 FM",
    url: "https://str.pcradio.ru/fm42-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1f8",
    like: false,
    name: "4 Dance Radio",
    url: "https://str.pcradio.ru/for_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1f9",
    like: false,
    name: "4ZZZ - 4 Triple Z",
    url: "https://str.pcradio.ru/four_zzz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1fa",
    like: false,
    name: "50 Cent",
    url: "https://str.pcradio.ru/fifty_Cent-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1fb",
    like: false,
    name: "7Б",
    url: "https://str.pcradio.ru/seven_b-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1fc",
    like: false,
    name: "80s Love",
    url: "https://str.pcradio.ru/eightys80s_love-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1fd",
    like: false,
    name: "80s NDW",
    url: "https://str.pcradio.ru/eightys80s_ndw-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1fe",
    like: false,
    name: "80s Party",
    url: "https://str.pcradio.ru/eightys80s_party-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec1ff",
    like: false,
    name: "80s Radio",
    url: "https://str.pcradio.ru/eightys80s_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec201",
    like: false,
    name: "89.0 RTL Deutsch House",
    url: "https://str.pcradio.ru/rtl_890_dh-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec202",
    like: false,
    name: "89.0 RTL In The Mix",
    url: "https://str.pcradio.ru/rtl_890_itm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec203",
    like: false,
    name: "89.0 RTL Live",
    url: "https://str.pcradio.ru/rtl_890_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec204",
    like: false,
    name: "89.0 RTL Most Wanted",
    url: "https://str.pcradio.ru/rtl_890_mw-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec205",
    like: false,
    name: "89.7 Bay",
    url: "https://str.pcradio.ru/bay_897_malta-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec206",
    like: false,
    name: "9-й район",
    url: "https://str.pcradio.ru/nineth_rayon-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec207",
    like: false,
    name: "90-х",
    url: "https://str.pcradio.ru/xoldpcradio90_2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec208",
    like: false,
    name: "90RU",
    url: "https://str.pcradio.ru/ru90pcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec209",
    like: false,
    name: "90s Eurodance",
    url: "https://str.pcradio.ru/eurodance90s_ucoz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec20a",
    like: false,
    name: "90s Hits",
    url: "https://str.pcradio.ru/shitsradiopcradio90-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec20b",
    like: false,
    name: "90s Radio",
    url: "https://str.pcradio.ru/sradiopcradio90-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec20c",
    like: false,
    name: "90s Boygroups",
    url: "https://str.pcradio.ru/s90s90_boygr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec20d",
    like: false,
    name: "90s Dance",
    url: "https://str.pcradio.ru/dance90s90s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec20e",
    like: false,
    name: "90s Hits",
    url: "https://str.pcradio.ru/s90s90_hits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec20f",
    like: false,
    name: "90s Techno",
    url: "https://str.pcradio.ru/s90s90_techno-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec210",
    like: false,
    name: "90s The Beat",
    url: "https://str.pcradio.ru/s90s90_beat-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec211",
    like: false,
    name: "90е Россия",
    url: "https://str.pcradio.ru/nineties_rus_pcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec212",
    like: false,
    name: "917XFM",
    url: "https://str.pcradio.ru/xfm917-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec214",
    like: false,
    name: "96.3 Jack FM",
    url: "https://str.pcradio.ru/jackfm_963-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec215",
    like: false,
    name: "98.8 Kiss FM Clubsets",
    url: "https://str.pcradio.ru/kiss_fmBerlin_clubsets-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec216",
    like: false,
    name: "98.8 Kiss FM Live",
    url: "https://str.pcradio.ru/kiss_fmBerlin_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec217",
    like: false,
    name: "98.8 Kiss FM R'n'B",
    url: "https://str.pcradio.ru/kiss_fmBerlin_rnb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec218",
    like: false,
    name: "98.8 Kiss FM Urban Beats",
    url: "https://str.pcradio.ru/kiss_fmBerlin_urban-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec21c",
    like: false,
    name: "AAH Radio - Baroque Classical",
    url: "https://str.pcradio.ru/aah_baroque-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec21d",
    like: false,
    name: "AAH Radio - Harp Classical",
    url: "https://str.pcradio.ru/aah_harp-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec21e",
    like: false,
    name: "AAH Radio - Violin Classical",
    url: "https://str.pcradio.ru/aah_violin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec223",
    like: false,
    name: "ABBA",
    url: "https://str.pcradio.ru/Abba-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec224",
    like: false,
    name: "ABC Lounge Music",
    url: "https://str.pcradio.ru/abc_lounge_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec227",
    like: false,
    name: "ABN Radio",
    url: "https://str.pcradio.ru/abn_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec229",
    like: false,
    name: "Absolut relax",
    url: "https://str.pcradio.ru/absolutrelax_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec231",
    like: false,
    name: "Accept",
    url: "https://str.pcradio.ru/accept-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec232",
    like: false,
    name: "Accra24",
    url: "https://str.pcradio.ru/accra_24-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec237",
    like: false,
    name: "Acid Jazz",
    url: "https://str.pcradio.ru/Acid_Jazz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec238",
    like: false,
    name: "Activa FM",
    url: "https://str.pcradio.ru/wwwactivafm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec239",
    like: false,
    name: "Adele",
    url: "https://str.pcradio.ru/Adele-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec23a",
    like: false,
    name: "Adriano Celentano",
    url: "https://str.pcradio.ru/Chelentano-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec23c",
    like: false,
    name: "AFK M94.5",
    url: "https://str.pcradio.ru/afk_m945-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec23d",
    like: false,
    name: "After Party",
    url: "https://str.pcradio.ru/After_Party-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec23e",
    like: false,
    name: "After Party 2",
    url: "https://str.pcradio.ru/After_Party_2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec23f",
    like: false,
    name: "Afterhours FM",
    url: "https://str.pcradio.ru/afterhours-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec241",
    like: false,
    name: "Aktív Rádió",
    url: "https://str.pcradio.ru/aktivradio_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec243",
    like: false,
    name: "Alem FM 89.2",
    url: "https://str.pcradio.ru/alem_fm892-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec246",
    like: false,
    name: "Alexander Bard Projects",
    url: "https://str.pcradio.ru/Alexander_Bard_Projects-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec247",
    like: false,
    name: "AlexFM",
    url: "https://str.pcradio.ru/alexfmradio_tk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec248",
    like: false,
    name: "Alice Cooper",
    url: "https://str.pcradio.ru/alice_cooper-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec249",
    like: false,
    name: "Alizee",
    url: "https://str.pcradio.ru/alizee-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec24a",
    like: false,
    name: "Allsound Radio",
    url: "https://str.pcradio.ru/allsound_nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec24d",
    like: false,
    name: "Alpha Rádió",
    url: "https://str.pcradio.ru/alpha_889-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec24e",
    like: false,
    name: "AlternativeFM",
    url: "https://str.pcradio.ru/alternativefm_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec24f",
    like: false,
    name: "AlternativeWorld",
    url: "https://str.pcradio.ru/alter_world_laut-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec250",
    like: false,
    name: "Ambiento Radio",
    url: "https://str.pcradio.ru/ambiento_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec252",
    like: false,
    name: "América Dance 90's",
    url: "https://str.pcradio.ru/ame_90s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec253",
    like: false,
    name: "Anastacia",
    url: "https://str.pcradio.ru/anastacia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec254",
    like: false,
    name: "Ancient FM",
    url: "https://str.pcradio.ru/ancientfm_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec255",
    like: false,
    name: "Andy's 80s",
    url: "https://str.pcradio.ru/andys_80s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec256",
    like: false,
    name: "Angel Radio",
    url: "https://str.pcradio.ru/angelradio_couk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec257",
    like: false,
    name: "Animu FM",
    url: "https://str.pcradio.ru/animu_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec258",
    like: false,
    name: "Anison FM",
    url: "https://str.pcradio.ru/ansion_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec259",
    like: false,
    name: "Anna Vissi",
    url: "https://str.pcradio.ru/Anna_Vissi-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec25b",
    like: false,
    name: "Antena 1",
    url: "https://str.pcradio.ru/antena1_combr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec25c",
    like: false,
    name: "Antena 1 Rio 103.7",
    url: "https://str.pcradio.ru/antena1_rio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec25d",
    like: false,
    name: "Antena 3 (RTP)",
    url: "https://str.pcradio.ru/antena3_rtp-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec25e",
    like: false,
    name: "Antena Minho",
    url: "https://str.pcradio.ru/antena_minho-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec25f",
    like: false,
    name: "Antenne 1",
    url: "https://str.pcradio.ru/antenne1_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec260",
    like: false,
    name: "Antenne 1 Neckarburg",
    url: "https://str.pcradio.ru/antenne1_neckar-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec261",
    like: false,
    name: "Antenne Bad Kreuznach",
    url: "https://str.pcradio.ru/antenne_badkreuz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec262",
    like: false,
    name: "Antenne Bayern - 80er Kulthits",
    url: "https://str.pcradio.ru/bayern_80er-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec263",
    like: false,
    name: "Antenne Bayern - 90er Hits",
    url: "https://str.pcradio.ru/bayern_90er-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec264",
    like: false,
    name: "Antenne Bayern - Black Beatz",
    url: "https://str.pcradio.ru/bayern_blackbeatz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec265",
    like: false,
    name: "Antenne Bayern - Chillout",
    url: "https://str.pcradio.ru/antenne_chillout-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec266",
    like: false,
    name: "Antenne Bayern - Classic Rock",
    url: "https://str.pcradio.ru/antenne_classic_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec267",
    like: false,
    name: "Antenne Bayern - Event",
    url: "https://str.pcradio.ru/bayern_event-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec268",
    like: false,
    name: "Antenne Bayern - Fresh4you",
    url: "https://str.pcradio.ru/bayern_fresh4u-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec269",
    like: false,
    name: "Antenne Bayern - Hitmix",
    url: "https://str.pcradio.ru/bayern_hitmix-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec26a",
    like: false,
    name: "Antenne Bayern - Hits fuer Kids",
    url: "https://str.pcradio.ru/bayern_hitskids-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec26b",
    like: false,
    name: "Antenne Bayern - Lovesongs",
    url: "https://str.pcradio.ru/bayern_lovesongs-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec26c",
    like: false,
    name: "Antenne Bayern - Oldies but Goldies",
    url: "https://str.pcradio.ru/bayern_oldies-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec26d",
    like: false,
    name: "Antenne Bayern - Schlagersahne",
    url: "https://str.pcradio.ru/bayern_schlagersahne-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec26e",
    like: false,
    name: "Antenne Bayern - Top40",
    url: "https://str.pcradio.ru/antenne_top40-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec26f",
    like: false,
    name: "Antenne Bayern - Weihnachts Hits",
    url: "https://str.pcradio.ru/bayern_weihnachts-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec270",
    like: false,
    name: "Antenne Bayern - Workout Hits",
    url: "https://str.pcradio.ru/bayern_workout-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec271",
    like: false,
    name: "3 FM",
    url: "https://str.pcradio.ru/antenne_1013-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec273",
    like: false,
    name: "Antenne Düsseldorf",
    url: "https://str.pcradio.ru/antenne_ddorf-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec275",
    like: false,
    name: "Antenne Kärnten",
    url: "https://str.pcradio.ru/antenne_kaernten-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec276",
    like: false,
    name: "Antenne Niedersachsen",
    url: "https://str.pcradio.ru/antenne_nds_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec277",
    like: false,
    name: "Antenne Saar",
    url: "https://str.pcradio.ru/antenne_saar-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec278",
    like: false,
    name: "Antenne Salzburg",
    url: "https://str.pcradio.ru/antenne_salzburg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec279",
    like: false,
    name: "Antenne Steiermark",
    url: "https://str.pcradio.ru/antenne_steiermark-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec27a",
    like: false,
    name: "Antenne Thüringen - 80er",
    url: "https://str.pcradio.ru/antenne_tue_80er-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec27b",
    like: false,
    name: "Antenne Thüringen - 90er",
    url: "https://str.pcradio.ru/antenne_tue_90er-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec27c",
    like: false,
    name: "Antenne Thüringen - Charts",
    url: "https://str.pcradio.ru/antenne_tue_charts-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec27d",
    like: false,
    name: "Antenne Thüringen - Deutsch Pop",
    url: "https://str.pcradio.ru/antenne_tue_deupop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec27e",
    like: false,
    name: "Antenne Thüringen - Lounge",
    url: "https://str.pcradio.ru/antenne_tue_lounge-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec27f",
    like: false,
    name: "Antenne Thüringen - Yesterhits",
    url: "https://str.pcradio.ru/antenne_tue_yester-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec280",
    like: false,
    name: "Antenne Thüringen Live",
    url: "https://str.pcradio.ru/antenne_tue_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec281",
    like: false,
    name: "Antenne Tirol",
    url: "https://str.pcradio.ru/antenne_tirol-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec283",
    like: false,
    name: "Antyradio",
    url: "https://str.pcradio.ru/antyradio_pl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec284",
    like: false,
    name: "Antyradio Hard",
    url: "https://str.pcradio.ru/antyradio_hard-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec285",
    like: false,
    name: "Anuryzm",
    url: "https://str.pcradio.ru/Anuryzm_uae-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec286",
    like: false,
    name: "Aphrodite",
    url: "https://str.pcradio.ru/aphrodite-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec287",
    like: false,
    name: "Apocalyptica",
    url: "https://str.pcradio.ru/apocalyptica-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec288",
    like: false,
    name: "Aqua",
    url: "https://str.pcradio.ru/Aqua-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec28b",
    like: false,
    name: "Arabella Herzflimmern",
    url: "https://str.pcradio.ru/arabella_de_herz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec28d",
    like: false,
    name: "Arabella Live",
    url: "https://str.pcradio.ru/arabella_de_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec291",
    like: false,
    name: "Arabella Wiesn-Party",
    url: "https://str.pcradio.ru/arabella_de_party-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec293",
    like: false,
    name: "Arizsanta FM Stereo",
    url: "https://str.pcradio.ru/arizsanta_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec294",
    like: false,
    name: "Armazém",
    url: "https://str.pcradio.ru/armazem_br-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec295",
    like: false,
    name: "Armin van Buuren",
    url: "https://str.pcradio.ru/Armin_van_buuren-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec296",
    like: false,
    name: "ARSU - Anime Radio",
    url: "https://str.pcradio.ru/animeradio_su-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec297",
    like: false,
    name: "Art City Radio",
    url: "https://str.pcradio.ru/artcity-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec298",
    like: false,
    name: "Art RemiX",
    url: "https://str.pcradio.ru/art_remix-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec299",
    like: false,
    name: "Asia Dream - Japan",
    url: "https://str.pcradio.ru/japan_asiadream-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec29a",
    like: false,
    name: "Asia Expat Radio - Singapore",
    url: "https://str.pcradio.ru/axr_singapore-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec29b",
    like: false,
    name: "Asia-Plus",
    url: "https://str.pcradio.ru/asia_plus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec29c",
    like: false,
    name: "Asterios",
    url: "https://str.pcradio.ru/asterious_tm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec29d",
    like: false,
    name: "4",
    url: "https://str.pcradio.ru/astrofm964-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec29e",
    like: false,
    name: "ATB",
    url: "https://str.pcradio.ru/ATB-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec29f",
    like: false,
    name: "Atlantis FM",
    url: "https://str.pcradio.ru/spainatlantis-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2a0",
    like: false,
    name: "Atm.Fm",
    url: "https://str.pcradio.ru/atmfm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2a1",
    like: false,
    name: "Atomik Radio",
    url: "https://str.pcradio.ru/atomik_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2a2",
    like: false,
    name: "Audioboxlive DJ Radio",
    url: "https://str.pcradio.ru/audioboxlive_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2a3",
    like: false,
    name: "Aura Radio",
    url: "https://str.pcradio.ru/aura_radio_pcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2a4",
    like: false,
    name: "Aurum Inutile Radio",
    url: "https://str.pcradio.ru/aurum_inutil-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2a5",
    like: false,
    name: "Avenged Sevenfold",
    url: "https://str.pcradio.ru/avenged_sevenfold-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2a6",
    like: false,
    name: "Avril Lavigne",
    url: "https://str.pcradio.ru/avril_lavigne-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2a7",
    like: false,
    name: "Axel24",
    url: "https://str.pcradio.ru/axel24_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2a8",
    like: false,
    name: "B.B. King",
    url: "https://str.pcradio.ru/BB_King-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2a9",
    like: false,
    name: "B4B Dance Disco Funk",
    url: "https://str.pcradio.ru/b4b_dance_classics-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2aa",
    like: false,
    name: "B4B Deep House",
    url: "https://str.pcradio.ru/b4b_deep_house-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2ab",
    like: false,
    name: "Baby FM",
    url: "https://str.pcradio.ru/baby_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2ac",
    like: false,
    name: "Backstreet Boys",
    url: "https://str.pcradio.ru/Backstreet_Boys-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2ad",
    like: false,
    name: "Bad Balance",
    url: "https://str.pcradio.ru/bad_balance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2ae",
    like: false,
    name: "Bad Boys Blue",
    url: "https://str.pcradio.ru/Bad_Boys_Blue-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2af",
    like: false,
    name: "BadBeatRadio",
    url: "https://str.pcradio.ru/badbeat_16-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2b0",
    like: false,
    name: "baden.fm",
    url: "https://str.pcradio.ru/baden_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2b1",
    like: false,
    name: "Balance Radio",
    url: "https://str.pcradio.ru/balance_radio_electro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2b2",
    like: false,
    name: "Balaton Rádió 88.7 FM",
    url: "https://str.pcradio.ru/balaton_887-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2b3",
    like: false,
    name: "Bananastreet",
    url: "https://str.pcradio.ru/banana_street-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2b4",
    like: false,
    name: "Bar Legend Radio",
    url: "https://str.pcradio.ru/bar_legend-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2b5",
    like: false,
    name: "Bargrooves Radio",
    url: "https://str.pcradio.ru/bargrooves_pcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2b6",
    like: false,
    name: "Bartok Radio (MR3)",
    url: "https://str.pcradio.ru/bartok_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2b7",
    like: false,
    name: "Bass-Clubbers",
    url: "https://str.pcradio.ru/bass_clubbers-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2b8",
    like: false,
    name: "Bassdrive",
    url: "https://str.pcradio.ru/bassdrive-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2b9",
    like: false,
    name: "Bates FM - Hard Rock",
    url: "https://str.pcradio.ru/batesfm_hardrock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2ba",
    like: false,
    name: "Bay Radio (Хавеа)",
    url: "https://str.pcradio.ru/bayradionorth-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2bb",
    like: false,
    name: "Bayern 1",
    url: "https://str.pcradio.ru/bayern_1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2bc",
    like: false,
    name: "Bayern 3",
    url: "https://str.pcradio.ru/bayern3-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2bd",
    like: false,
    name: "BB Radio",
    url: "https://str.pcradio.ru/bbradio_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2be",
    like: false,
    name: "BB-Radio",
    url: "https://str.pcradio.ru/bbnews_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2bf",
    like: false,
    name: "BBC 1",
    url: "https://str.pcradio.ru/bbc_1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2c0",
    like: false,
    name: "BBN (English)",
    url: "https://str.pcradio.ru/bbn_english-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2c1",
    like: false,
    name: "BDSM Radio",
    url: "https://str.pcradio.ru/Bdsmradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2c2",
    like: false,
    name: "Beach Boys",
    url: "https://str.pcradio.ru/The_Beach_Boys-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2c3",
    like: false,
    name: "BeachChill Radio",
    url: "https://str.pcradio.ru/beachchill_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2c4",
    like: false,
    name: "BeachGrooves Radio",
    url: "https://str.pcradio.ru/beachgrooves_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2c5",
    like: false,
    name: "Beatdownx",
    url: "https://str.pcradio.ru/laut_beatdownx-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2c6",
    like: false,
    name: "Beautiful Instrumentals",
    url: "https://str.pcradio.ru/beautiful_instrumentals-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2c7",
    like: false,
    name: "BebeNautas",
    url: "https://str.pcradio.ru/radiobebenautas_cl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2c8",
    like: false,
    name: "Beirut Nights",
    url: "https://str.pcradio.ru/beirut_nights-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2c9",
    like: false,
    name: "Benassi Bros.",
    url: "https://str.pcradio.ru/benassi-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2ca",
    like: false,
    name: "Berliner Rundfunk 91.4",
    url: "https://str.pcradio.ru/berlin_rund914-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2cb",
    like: false,
    name: "Bermuda Funk",
    url: "https://str.pcradio.ru/bermudafunk_org-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2cc",
    like: false,
    name: "Best FM (Дебрецен)",
    url: "https://str.pcradio.ru/bestfm_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2cd",
    like: false,
    name: "Best FM (Стамбул)",
    url: "https://str.pcradio.ru/best_fm_tr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2ce",
    like: false,
    name: "Best Hit",
    url: "https://str.pcradio.ru/Best_Hit-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2cf",
    like: false,
    name: "Best Smooth Jazz",
    url: "https://str.pcradio.ru/best_smoothjazz_uk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2d0",
    like: false,
    name: "Beyonce",
    url: "https://str.pcradio.ru/Beyonce-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec2d2",
    like: false,
    name: "BHeins – Meine Hitgarantie",
    url: "https://str.pcradio.ru/bheins_meinehit-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2d3",
    like: false,
    name: "Big Noise",
    url: "https://str.pcradio.ru/bignoise_club-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2d4",
    like: false,
    name: "Big R Radio - The Wave",
    url: "https://str.pcradio.ru/bigrradio_thewave-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2d5",
    like: false,
    name: "bigFM",
    url: "https://str.pcradio.ru/bigfm_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2d6",
    like: false,
    name: "bigFM Balkan",
    url: "https://str.pcradio.ru/bigfm_balk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2d7",
    like: false,
    name: "bigFM Charts",
    url: "https://str.pcradio.ru/bigfm_charts-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2d8",
    like: false,
    name: "bigFM Dance",
    url: "https://str.pcradio.ru/bigfm_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2d9",
    like: false,
    name: "bigFM Deep and Tech House",
    url: "https://str.pcradio.ru/bigfm_deep-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2da",
    like: false,
    name: "bigFM Deutscher Hip-Hop Charts",
    url: "https://str.pcradio.ru/bigfm_hipdeutsch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2db",
    like: false,
    name: "bigFM Deutschrap",
    url: "https://str.pcradio.ru/bigfm_deu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2dc",
    like: false,
    name: "bigFM EDM and Progressive",
    url: "https://str.pcradio.ru/bigfm_edm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2dd",
    like: false,
    name: "bigFM Groove Night",
    url: "https://str.pcradio.ru/bigfm_groove-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2de",
    like: false,
    name: "bigFM HipHop",
    url: "https://str.pcradio.ru/bigfm_hiphop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2df",
    like: false,
    name: "bigFM Latin Beats",
    url: "https://str.pcradio.ru/bigfm_latin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2e0",
    like: false,
    name: "bigFM Mashup",
    url: "https://str.pcradio.ru/bigfm_mash-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2e1",
    like: false,
    name: "bigFM Oldschool Rap and Hip-Hop",
    url: "https://str.pcradio.ru/bigfm_oldhip-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2e2",
    like: false,
    name: "bigFM Reggae Vibez",
    url: "https://str.pcradio.ru/bigfm_regg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2e3",
    like: false,
    name: "bigFM RnB",
    url: "https://str.pcradio.ru/bigfm_rnb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2e4",
    like: false,
    name: "bigFM Rock am Ring",
    url: "https://str.pcradio.ru/bigfm_amring-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2e5",
    like: false,
    name: "bigFM Russia",
    url: "https://str.pcradio.ru/bigfm_de_rus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2e6",
    like: false,
    name: "bigFM SES",
    url: "https://str.pcradio.ru/bigfm_ses-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2e7",
    like: false,
    name: "bigFM Sunset Lounge",
    url: "https://str.pcradio.ru/bigfm_lou-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2e8",
    like: false,
    name: "bigFM Urban Club Beats",
    url: "https://str.pcradio.ru/bigfm_urban-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2e9",
    like: false,
    name: "bigFM US Rap and Hip-Hop",
    url: "https://str.pcradio.ru/bigfm_usrap-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2ea",
    like: false,
    name: "bigFM World Beats",
    url: "https://str.pcradio.ru/bigfm_wbeats-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2eb",
    like: false,
    name: "BigTunes Radio - Bass",
    url: "https://str.pcradio.ru/bigtunes_bass-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2ec",
    like: false,
    name: "BigTunes Radio - House",
    url: "https://str.pcradio.ru/bigtunes_house-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2ed",
    like: false,
    name: "BigTunes Radio - Oldschool",
    url: "https://str.pcradio.ru/bigtunes_oldschool-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2ee",
    like: false,
    name: "BigTunes Radio - Trance",
    url: "https://str.pcradio.ru/bigtunes_trance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2ef",
    like: false,
    name: "Biker FM",
    url: "https://str.pcradio.ru/biker_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2f0",
    like: false,
    name: "Billy’s Band",
    url: "https://str.pcradio.ru/billys_band-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2f1",
    like: false,
    name: "Bingo FM",
    url: "https://str.pcradio.ru/bingofm_nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2f2",
    like: false,
    name: "Birdsong FM",
    url: "https://str.pcradio.ru/birdsong_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2f3",
    like: false,
    name: "Biz Webradio",
    url: "https://str.pcradio.ru/bizwebradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2f4",
    like: false,
    name: "Bloger FM",
    url: "https://str.pcradio.ru/bloger_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2f5",
    like: false,
    name: "Bloodstream",
    url: "https://str.pcradio.ru/blood_stream-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2f6",
    like: false,
    name: "Blue System",
    url: "https://str.pcradio.ru/blue_system-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2f7",
    like: false,
    name: "BluesMen Channel - Gold",
    url: "https://str.pcradio.ru/bluesmen_gold-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2f8",
    like: false,
    name: "BluesMen Channel - Hits",
    url: "https://str.pcradio.ru/bluesmen_hits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2f9",
    like: false,
    name: "BNR Horizont",
    url: "https://str.pcradio.ru/bnr_bg_hori-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2fa",
    like: false,
    name: "BNR Hristo Botev",
    url: "https://str.pcradio.ru/bnr_bg_hrist-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2fb",
    like: false,
    name: "BNR Nieuws Radio",
    url: "https://str.pcradio.ru/bnrnl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2fc",
    like: false,
    name: "BNR Radio Sofia",
    url: "https://str.pcradio.ru/bnr_sofia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2fd",
    like: false,
    name: "Bob Marley",
    url: "https://str.pcradio.ru/bob_marley-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2fe",
    like: false,
    name: "Bollocks Rock and Metal Radio",
    url: "https://str.pcradio.ru/bollocks_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec2ff",
    like: false,
    name: "Bollywood Radio",
    url: "https://str.pcradio.ru/Bollywood-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec300",
    like: false,
    name: "Bollywood Radio and Beyond",
    url: "https://str.pcradio.ru/bolly_beyond-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec301",
    like: false,
    name: "Boney M.",
    url: "https://str.pcradio.ru/BoneyM-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec302",
    like: false,
    name: "Bonton",
    url: "https://str.pcradio.ru/radiobonton_cz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec303",
    like: false,
    name: "Boomstation",
    url: "https://str.pcradio.ru/boomstation_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec304",
    like: false,
    name: "Bossa Nova Brazil",
    url: "https://str.pcradio.ru/bossanova_vip-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec305",
    like: false,
    name: "Bosson",
    url: "https://str.pcradio.ru/bosson-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec306",
    like: false,
    name: "Boystown Live Dance Radio",
    url: "https://str.pcradio.ru/boys_town_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec307",
    like: false,
    name: "BR Heimat",
    url: "https://str.pcradio.ru/br_heimat-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec308",
    like: false,
    name: "BR-Klassik",
    url: "https://str.pcradio.ru/br_klassik-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec309",
    like: false,
    name: "Brainstorm (Латвия)",
    url: "https://str.pcradio.ru/brainstorm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec30a",
    like: false,
    name: "Brandon Stone",
    url: "https://str.pcradio.ru/Brandon_Stone-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec30b",
    like: false,
    name: "Breaking Orbit",
    url: "https://str.pcradio.ru/Breaking_orbit_aus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec30c",
    like: false,
    name: "Bremen Eins",
    url: "https://str.pcradio.ru/bremen_eins-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec30d",
    like: false,
    name: "Bremen NEXT",
    url: "https://str.pcradio.ru/bremen_next-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec30e",
    like: false,
    name: "Bremen Vier",
    url: "https://str.pcradio.ru/bremen_vier-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec30f",
    like: false,
    name: "Bremen Zwei",
    url: "https://str.pcradio.ru/bremen_zwei-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec310",
    like: false,
    name: "Bretagne 5",
    url: "https://str.pcradio.ru/bretagne5-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec311",
    like: false,
    name: "BRF1",
    url: "https://str.pcradio.ru/brf1_be-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec312",
    like: false,
    name: "BRF2",
    url: "https://str.pcradio.ru/brf2_be-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec313",
    like: false,
    name: "Britney Spears",
    url: "https://str.pcradio.ru/Britney_Spears-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec314",
    like: false,
    name: "Brony Radio Germany - DayDJ",
    url: "https://str.pcradio.ru/brony_germany_day-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec315",
    like: false,
    name: "Brony Radio Germany - NightDJ",
    url: "https://str.pcradio.ru/brony_germany_ni-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec316",
    like: false,
    name: "BRSS Radio",
    url: "https://str.pcradio.ru/brsswami_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec317",
    like: false,
    name: "Bruno Mars",
    url: "https://str.pcradio.ru/Bruno_Mars-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec318",
    like: false,
    name: "Bryan Adams",
    url: "https://str.pcradio.ru/bryan_adams-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec319",
    like: false,
    name: "bTuner's station",
    url: "https://str.pcradio.ru/btuners-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec31a",
    like: false,
    name: "Buddha Beach",
    url: "https://str.pcradio.ru/buddha_beach-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec31b",
    like: false,
    name: "Buddha FM",
    url: "https://str.pcradio.ru/buddha_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec31c",
    like: false,
    name: "BumbleBee",
    url: "https://str.pcradio.ru/bumblebeefm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec31d",
    like: false,
    name: "BurnFM",
    url: "https://str.pcradio.ru/burn_fm_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec31e",
    like: false,
    name: "Buryad FM",
    url: "https://str.pcradio.ru/buryad_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec31f",
    like: false,
    name: "Business FM",
    url: "https://str.pcradio.ru/business_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec320",
    like: false,
    name: "ByteFM",
    url: "https://str.pcradio.ru/byte_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec321",
    like: false,
    name: "C. C. Catch",
    url: "https://str.pcradio.ru/C_C_Catch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec322",
    like: false,
    name: "C89.5",
    url: "https://str.pcradio.ru/c89_org-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec323",
    like: false,
    name: "Cadena 100",
    url: "https://str.pcradio.ru/wwwcadena100es-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec324",
    like: false,
    name: "Cadena Cope (Мадрид)",
    url: "https://str.pcradio.ru/wwwcopees-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec325",
    like: false,
    name: "Cadena SER - Madrid",
    url: "https://str.pcradio.ru/cadenaser_madrid-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec326",
    like: false,
    name: "Cadena SER - Málaga",
    url: "https://str.pcradio.ru/cadenaser_malaga-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec327",
    like: false,
    name: "Cafe 80s FM",
    url: "https://str.pcradio.ru/cafe80s_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec328",
    like: false,
    name: "Café del Mar",
    url: "https://str.pcradio.ru/cafedelmar_ga-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec329",
    like: false,
    name: "Callisto Radio",
    url: "https://str.pcradio.ru/callisto_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec32a",
    like: false,
    name: "Canal B 94.0 FM",
    url: "https://str.pcradio.ru/canalb_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec32b",
    like: false,
    name: "Canal Extremadura Radio",
    url: "https://str.pcradio.ru/canal_extramadura-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec32c",
    like: false,
    name: "Canal Sur Radio Andalucía",
    url: "https://str.pcradio.ru/canalsur_sevi-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec32d",
    like: false,
    name: "Capital FM (Moscow FM)",
    url: "https://str.pcradio.ru/capitalfm_moscow-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec32e",
    like: false,
    name: "Capital FM (Лондон)",
    url: "https://str.pcradio.ru/capital_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec330",
    like: false,
    name: "Cardigans",
    url: "https://str.pcradio.ru/The_Cardigans-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec331",
    like: false,
    name: "Cardiowave",
    url: "https://str.pcradio.ru/cardiowave_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec332",
    like: false,
    name: "CBC Music",
    url: "https://str.pcradio.ru/cbc_music-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec333",
    like: false,
    name: "CBC Radio One (Эдмонтон)",
    url: "https://str.pcradio.ru/cbcone_edm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec334",
    like: false,
    name: "CC Radio",
    url: "https://str.pcradio.ru/cc_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec335",
    like: false,
    name: "CD FM",
    url: "https://str.pcradio.ru/cd_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec336",
    like: false,
    name: "Celine Dion",
    url: "https://str.pcradio.ru/Celine_Dion-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec337",
    like: false,
    name: "Celtic Sounds",
    url: "https://str.pcradio.ru/celtic_sounds-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec338",
    like: false,
    name: "Celtic-Rock",
    url: "https://str.pcradio.ru/celtic_rock_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec339",
    like: false,
    name: "Centr",
    url: "https://str.pcradio.ru/centr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec33a",
    like: false,
    name: "CentreForce Radio 88.3",
    url: "https://str.pcradio.ru/centreforce-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec33b",
    like: false,
    name: "Cesky Impuls AM 981",
    url: "https://str.pcradio.ru/cesky_impuls-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec33c",
    like: false,
    name: "Charivari 98.6",
    url: "https://str.pcradio.ru/charivari_986-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec33d",
    like: false,
    name: "ChartHitz",
    url: "https://str.pcradio.ru/laut_charthitz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec33e",
    like: false,
    name: "Cher",
    url: "https://str.pcradio.ru/cher-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec33f",
    like: false,
    name: "Chill Out Zone",
    url: "https://str.pcradio.ru/chillout_zone-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec340",
    like: false,
    name: "Chillizet",
    url: "https://str.pcradio.ru/chillizet_pl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec341",
    like: false,
    name: "ChilloutFM",
    url: "https://str.pcradio.ru/chilloutfm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec342",
    like: false,
    name: "ChillTrax",
    url: "https://str.pcradio.ru/chilltrax_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec343",
    like: false,
    name: "Chilz.Me",
    url: "https://str.pcradio.ru/chilz_me-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec344",
    like: false,
    name: "Chocolate FM",
    url: "https://str.pcradio.ru/Chocolat_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec345",
    like: false,
    name: "Christian Lais",
    url: "https://str.pcradio.ru/Christian_Lais-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec346",
    like: false,
    name: "Christliches Radio München",
    url: "https://str.pcradio.ru/christlichesradio_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec347",
    like: false,
    name: "Chromanova - Chillout",
    url: "https://str.pcradio.ru/chromanova_chill-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec348",
    like: false,
    name: "Chuck Berry",
    url: "https://str.pcradio.ru/chuck_berry-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec349",
    like: false,
    name: "Chérie",
    url: "https://str.pcradio.ru/cheriefm_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec34a",
    like: false,
    name: "City Fm 106.0",
    url: "https://str.pcradio.ru/fm106_am-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec34b",
    like: false,
    name: "City Radio 106.4 FM",
    url: "https://str.pcradio.ru/cityradio_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec34c",
    like: false,
    name: "Civil Rádió FM 98",
    url: "https://str.pcradio.ru/civilradio_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec34d",
    like: false,
    name: "Civil Rádió FM98",
    url: "https://str.pcradio.ru/civilradio_fm98-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec34e",
    like: false,
    name: "CJLO 1690 (Монреаль)",
    url: "https://str.pcradio.ru/cjlo_1690-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec34f",
    like: false,
    name: "CJSW 90.9 FM",
    url: "https://str.pcradio.ru/cjsw_909-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec350",
    like: false,
    name: "CKUT 90.3 FM",
    url: "https://str.pcradio.ru/ckut_903-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec351",
    like: false,
    name: " Астана)",
    url: "https://str.pcradio.ru/classicfm_kz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec352",
    like: false,
    name: "Classic FM (Лондон)",
    url: "https://str.pcradio.ru/classicfm_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec353",
    like: false,
    name: "Classic FM (София)",
    url: "https://str.pcradio.ru/classicfm_bg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec354",
    like: false,
    name: "Classic Rock Florida",
    url: "https://str.pcradio.ru/classic_rock_flo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec355",
    like: false,
    name: "Classical Network",
    url: "https://str.pcradio.ru/classical_network-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec356",
    like: false,
    name: "Club Radio (Прага)",
    url: "https://str.pcradio.ru/club_prague-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec357",
    like: false,
    name: "ClubTime FM",
    url: "https://str.pcradio.ru/clubtime_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec358",
    like: false,
    name: "CnR Radio",
    url: "https://str.pcradio.ru/cnr_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec359",
    like: false,
    name: "Coast FM Tenerife",
    url: "https://str.pcradio.ru/coastfm_tenerife-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec35a",
    like: false,
    name: "Coast Two",
    url: "https://str.pcradio.ru/coast_two-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec35b",
    like: false,
    name: "Coffee FM",
    url: "https://str.pcradio.ru/Vintazh_kafe-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec35c",
    like: false,
    name: "Comedy radio",
    url: "https://str.pcradio.ru/comedy_club-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec35d",
    like: false,
    name: "Conny",
    url: "https://str.pcradio.ru/conny_laut-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec35e",
    like: false,
    name: "Cool FM",
    url: "https://str.pcradio.ru/coolfm_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec35f",
    like: false,
    name: "Cool FM - Goldie'S",
    url: "https://str.pcradio.ru/goldies_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec360",
    like: false,
    name: "Cool FM - kultX",
    url: "https://str.pcradio.ru/kultx_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec361",
    like: false,
    name: "Cool FM - Xbeat",
    url: "https://str.pcradio.ru/xbeat_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec362",
    like: false,
    name: "Cooltura FM",
    url: "https://str.pcradio.ru/cooltura_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec363",
    like: false,
    name: "Core Radio!",
    url: "https://str.pcradio.ru/coreradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec364",
    like: false,
    name: "Core-Mix",
    url: "https://str.pcradio.ru/laut_core_mix-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec365",
    like: false,
    name: "Cork's 96FM",
    url: "https://str.pcradio.ru/corks_96fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec366",
    like: false,
    name: "Corroded",
    url: "https://str.pcradio.ru/Corroded_swe-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec367",
    like: false,
    name: "Cosmic Waves",
    url: "https://str.pcradio.ru/cosmicwaves_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec368",
    like: false,
    name: "Cosmic Waves - Chill",
    url: "https://str.pcradio.ru/cosmicwaves_chill-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec369",
    like: false,
    name: "Cosmic Waves - Progressive",
    url: "https://str.pcradio.ru/cosmicwa_progress-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec36a",
    like: false,
    name: "8",
    url: "https://str.pcradio.ru/cosmosfm1038-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec36b",
    like: false,
    name: "Costa Del Mar - Chillout",
    url: "https://str.pcradio.ru/costadelmarradiocom-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec36c",
    like: false,
    name: "Costa Del Mar - Dance",
    url: "https://str.pcradio.ru/cdm_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec36d",
    like: false,
    name: "Costa Del Mar - Deep House",
    url: "https://str.pcradio.ru/cdm_deephouse-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec36e",
    like: false,
    name: "Costa Del Mar - Funky",
    url: "https://str.pcradio.ru/cdm_funky-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec36f",
    like: false,
    name: "Costa Del Mar - Zen",
    url: "https://str.pcradio.ru/cdm_zen-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec370",
    like: false,
    name: "Country 105",
    url: "https://str.pcradio.ru/country_105-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec371",
    like: false,
    name: "Creedence",
    url: "https://str.pcradio.ru/Creedence-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec372",
    like: false,
    name: "CRo (Оломоуц)",
    url: "https://str.pcradio.ru/rozhlas_cz_olo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec373",
    like: false,
    name: "CRo (Острава)",
    url: "https://str.pcradio.ru/rozhlas_cz_ost-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec374",
    like: false,
    name: "CRo (Ческе-Будеёвице)",
    url: "https://str.pcradio.ru/rozhlas_cz_cb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec375",
    like: false,
    name: "CRo D-dur",
    url: "https://str.pcradio.ru/cro_ddur-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec376",
    like: false,
    name: "CRo Dvojka",
    url: "https://str.pcradio.ru/cro_dvojka-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec377",
    like: false,
    name: "CRo Jazz",
    url: "https://str.pcradio.ru/cro_jazz_cz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec378",
    like: false,
    name: "CRo Plus",
    url: "https://str.pcradio.ru/cro_plus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec379",
    like: false,
    name: "CRo Radio Junior",
    url: "https://str.pcradio.ru/cro_radiojunior_cz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec37a",
    like: false,
    name: "CRo Radio Wave",
    url: "https://str.pcradio.ru/cro_radiowave-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec37b",
    like: false,
    name: "CRo Radiožurnál",
    url: "https://str.pcradio.ru/cro_radiozurnal-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec37c",
    like: false,
    name: "CRo Vltava",
    url: "https://str.pcradio.ru/cro_vltava-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec37d",
    like: false,
    name: "Crocus City Hall Radio",
    url: "https://str.pcradio.ru/crocus_city-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec37e",
    like: false,
    name: "Crooner Radio",
    url: "https://str.pcradio.ru/crooner_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec37f",
    like: false,
    name: "Crooner Radio - Barbra Streisand",
    url: "https://str.pcradio.ru/crooner_barstr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec380",
    like: false,
    name: "Crooner Radio - Celine Dion",
    url: "https://str.pcradio.ru/crooner_celdi-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec381",
    like: false,
    name: "Crooner Radio - Dean Martin",
    url: "https://str.pcradio.ru/crooner_deanm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec382",
    like: false,
    name: "Crooner Radio - Elvis Presley",
    url: "https://str.pcradio.ru/crooner_elvpres-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec383",
    like: false,
    name: "Crooner Radio - Frank Sinatra",
    url: "https://str.pcradio.ru/crooner_frsin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec384",
    like: false,
    name: "Crooner Radio - Gentlemen Drivers",
    url: "https://str.pcradio.ru/crooner_gentdr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec385",
    like: false,
    name: "Crooner Radio - In Private",
    url: "https://str.pcradio.ru/crooner_inpri-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec386",
    like: false,
    name: "Crooner Radio - Julio Iglesias",
    url: "https://str.pcradio.ru/crooner_juligl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec387",
    like: false,
    name: "Crooner Radio - Legends",
    url: "https://str.pcradio.ru/crooner_legends-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec388",
    like: false,
    name: "Crooner Radio - Michael Buble",
    url: "https://str.pcradio.ru/crooner_mibu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec389",
    like: false,
    name: "Crooner Radio - Premium",
    url: "https://str.pcradio.ru/crooner_prem-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec38a",
    like: false,
    name: "Crucial Velocity",
    url: "https://str.pcradio.ru/crucial_velocity-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec38b",
    like: false,
    name: "CruiseOne",
    url: "https://str.pcradio.ru/cruiseone_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec38c",
    like: false,
    name: "Cruisin' Oldies",
    url: "https://str.pcradio.ru/cruisin_oldies_laut-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec38d",
    like: false,
    name: "Crystal Radiostation",
    url: "https://str.pcradio.ru/crystal_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec38e",
    like: false,
    name: "CT das Radio 96.9 FM",
    url: "https://str.pcradio.ru/ct_dasradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec38f",
    like: false,
    name: "Cyber Vybez Radio",
    url: "https://str.pcradio.ru/cyber_vybez-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec391",
    like: false,
    name: "Dance 100 Parar",
    url: "https://str.pcradio.ru/dance100parar-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec392",
    like: false,
    name: "Dance Boom",
    url: "https://str.pcradio.ru/dance_boom-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec393",
    like: false,
    name: "Dance FM Romania",
    url: "https://str.pcradio.ru/dancefm_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec394",
    like: false,
    name: "Dance Radio (Амстердам)",
    url: "https://str.pcradio.ru/danceradio_in-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec395",
    like: false,
    name: "Dance Radio (Прага)",
    url: "https://str.pcradio.ru/danceradio_cz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec396",
    like: false,
    name: "Dance Wave Retro!",
    url: "https://str.pcradio.ru/dance_wave_retro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec397",
    like: false,
    name: "Dance Wave!",
    url: "https://str.pcradio.ru/dance_wave-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec398",
    like: false,
    name: "Dancefloor Radio",
    url: "https://str.pcradio.ru/dancefloor_vip-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec399",
    like: false,
    name: "Danko Radio (MR6)",
    url: "https://str.pcradio.ru/danko_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec39a",
    like: false,
    name: "Darik Radio",
    url: "https://str.pcradio.ru/darikradio_bg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec39b",
    like: false,
    name: "Dark Edge Radio",
    url: "https://str.pcradio.ru/darkedge_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec39c",
    like: false,
    name: "Dark Radio",
    url: "https://str.pcradio.ru/darkradio_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec39d",
    like: false,
    name: "DarkClubRadio",
    url: "https://str.pcradio.ru/dark_club_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec39e",
    like: false,
    name: "Darren Hayes",
    url: "https://str.pcradio.ru/Darren_Hayes-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec39f",
    like: false,
    name: "Das Durchgeknallte Radio",
    url: "https://str.pcradio.ru/durchgeknallte_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3a0",
    like: false,
    name: "Das Inselradio Mallorca 95.8 FM",
    url: "https://str.pcradio.ru/das_inselradio_958-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3a1",
    like: false,
    name: "Das Radio der von Neil Young Getöteten",
    url: "https://str.pcradio.ru/dasradio_nyoung-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3a2",
    like: false,
    name: "DASDING",
    url: "https://str.pcradio.ru/dasding_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3a3",
    like: false,
    name: "David Guetta",
    url: "https://str.pcradio.ru/David_Guetta-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3a4",
    like: false,
    name: "Davidzon Radio",
    url: "https://str.pcradio.ru/davidzon-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3a5",
    like: false,
    name: "db962",
    url: "https://str.pcradio.ru/db962_nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3a6",
    like: false,
    name: "DDBY",
    url: "https://str.pcradio.ru/DDBY-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3a7",
    like: false,
    name: "Deadmau5",
    url: "https://str.pcradio.ru/deadmau5-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3a8",
    like: false,
    name: "Dean Martin",
    url: "https://str.pcradio.ru/Dean_Martin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3a9",
    like: false,
    name: "Death FM",
    url: "https://str.pcradio.ru/death_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3aa",
    like: false,
    name: "Deathstars",
    url: "https://str.pcradio.ru/Deathstars_swe-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3ab",
    like: false,
    name: "DeeGay 1 Pop and Dance",
    url: "https://str.pcradio.ru/deegay_popd-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3ac",
    like: false,
    name: "DeeGay 2 Classic",
    url: "https://str.pcradio.ru/deegay_classic-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3ad",
    like: false,
    name: "DeeGay 3 Club",
    url: "https://str.pcradio.ru/deegay_club-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3ae",
    like: false,
    name: "Deep Box",
    url: "https://str.pcradio.ru/deep_box-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3af",
    like: false,
    name: "Deep Forest",
    url: "https://str.pcradio.ru/Deep_forest-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3b0",
    like: false,
    name: "Deep House",
    url: "https://str.pcradio.ru/deep_house-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3b1",
    like: false,
    name: "Deep House Ibiza",
    url: "https://str.pcradio.ru/deephouse_ibiza-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3b2",
    like: false,
    name: "Deep Mix Moscow Radio",
    url: "https://str.pcradio.ru/deepmix_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3b3",
    like: false,
    name: "Deep Purple",
    url: "https://str.pcradio.ru/Deep_purple-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3b4",
    like: false,
    name: "Deep Radio",
    url: "https://str.pcradio.ru/deep_radioo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3b5",
    like: false,
    name: "Deep Stream",
    url: "https://str.pcradio.ru/deep_stream-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3b6",
    like: false,
    name: "Deep Vocal House",
    url: "https://str.pcradio.ru/deep_voc_house-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3b7",
    like: false,
    name: "Deepa.Net FM",
    url: "https://str.pcradio.ru/deepanet_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3b8",
    like: false,
    name: "DeepFM",
    url: "https://str.pcradio.ru/deepfm_nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3b9",
    like: false,
    name: "DeepPort",
    url: "https://str.pcradio.ru/deepport_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3ba",
    like: false,
    name: "Defjay",
    url: "https://str.pcradio.ru/defjay_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3bb",
    like: false,
    name: "Deform",
    url: "https://str.pcradio.ru/deform-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3bc",
    like: false,
    name: "Delta Radio - Alternative",
    url: "https://str.pcradio.ru/deltaradio_alternative-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3bd",
    like: false,
    name: "Delta Radio - Der beste RockPop reloaded",
    url: "https://str.pcradio.ru/delta_bestrockpop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3be",
    like: false,
    name: "Delta Radio - Deutsch",
    url: "https://str.pcradio.ru/delta_deutsch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3bf",
    like: false,
    name: "Delta Radio - Grunge",
    url: "https://str.pcradio.ru/deltaradio_grunge-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3c0",
    like: false,
    name: "Delta Radio - Hard Rock / Heavy Metal",
    url: "https://str.pcradio.ru/deltaradio_hard-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3c1",
    like: false,
    name: "Delta Radio - Hip Hop",
    url: "https://str.pcradio.ru/delta_hiphop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3c2",
    like: false,
    name: "Delta Radio - Indie",
    url: "https://str.pcradio.ru/deltaradio_indie-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3c3",
    like: false,
    name: "Delta Radio - Top 100 Deutsch Rap",
    url: "https://str.pcradio.ru/delta_deu100rap-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3c4",
    like: false,
    name: "Delta Radio - Unplugged",
    url: "https://str.pcradio.ru/delta_unplugged-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3c5",
    like: false,
    name: "Delta Radio Live",
    url: "https://str.pcradio.ru/deltaradio_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3c6",
    like: false,
    name: "Demi Lovato",
    url: "https://str.pcradio.ru/Demi_Lovato-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3c7",
    like: false,
    name: "Demon Hunter",
    url: "https://str.pcradio.ru/Demon_hunter_usa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3c8",
    like: false,
    name: "Den Tunge Radio",
    url: "https://str.pcradio.ru/den_tunge_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3c9",
    like: false,
    name: "Dendy-Collection",
    url: "https://str.pcradio.ru/dendy_collection-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3ca",
    like: false,
    name: "Depeche Mode",
    url: "https://str.pcradio.ru/Depeche_Mode-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3cb",
    like: false,
    name: "detektor.fm - Musik-Stream",
    url: "https://str.pcradio.ru/detektor_musik-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3cc",
    like: false,
    name: "detektor.fm - Wort-Stream",
    url: "https://str.pcradio.ru/detektor_wort-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3cd",
    like: false,
    name: "Deutsche Welle (English)",
    url: "https://str.pcradio.ru/deutsche_welle_eng-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3ce",
    like: false,
    name: "Deutschlandfunk",
    url: "https://str.pcradio.ru/deutschlandfunk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3cf",
    like: false,
    name: "Deutschlandfunk Nova (DRadio Wissen)",
    url: "https://str.pcradio.ru/dradio_wissen-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3d0",
    like: false,
    name: "Deutschlandradio Kultur",
    url: "https://str.pcradio.ru/deutschlandradio_kultur-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3d1",
    like: false,
    name: "Deutschrock-Plus",
    url: "https://str.pcradio.ru/deutschrockplus_laut-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3d2",
    like: false,
    name: "Deutschrock-Zentrale",
    url: "https://str.pcradio.ru/deurock_zentr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3d3",
    like: false,
    name: "DFM 101.2 (Москва)",
    url: "https://str.pcradio.ru/dfm_moscow-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3d4",
    like: false,
    name: "1 FM (Орск)",
    url: "https://str.pcradio.ru/dfm_orsk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3d5",
    like: false,
    name: "DFM 104.7 (Казань)",
    url: "https://str.pcradio.ru/dfm_kazan-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3d6",
    like: false,
    name: "DFM 106.0 FM (Краснодар)",
    url: "https://str.pcradio.ru/dfm_krasnodar-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3d7",
    like: false,
    name: "2 (Таллинн)",
    url: "https://str.pcradio.ru/dfm_tallinn-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3d8",
    like: false,
    name: "DFM Club",
    url: "https://str.pcradio.ru/dfm_club-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3d9",
    like: false,
    name: "DFM Deep",
    url: "https://str.pcradio.ru/dfm_deep-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3da",
    like: false,
    name: "DFM Russian Dance",
    url: "https://str.pcradio.ru/dfm_russian_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3db",
    like: false,
    name: "DFM Trap",
    url: "https://str.pcradio.ru/dfm_trap-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3dc",
    like: false,
    name: "DFM Дискач 90-х",
    url: "https://str.pcradio.ru/dfm_diskach90s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3dd",
    like: false,
    name: "Dhol Radio",
    url: "https://str.pcradio.ru/dhol_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3de",
    like: false,
    name: "Diabolus",
    url: "https://str.pcradio.ru/radio_diabolus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3df",
    like: false,
    name: "Dido",
    url: "https://str.pcradio.ru/Dido-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3e0",
    like: false,
    name: "Die Antenne - Südtirols",
    url: "https://str.pcradio.ru/antenne_suedtir-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3e1",
    like: false,
    name: "Die Antwoord",
    url: "https://str.pcradio.ru/die_antwoord-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3e2",
    like: false,
    name: "Die Neue 107.7 - 80er",
    url: "https://str.pcradio.ru/dieneue_1077_80er-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3e3",
    like: false,
    name: "Die Neue 107.7 - Bester Rock und Pop",
    url: "https://str.pcradio.ru/dieneue_1077-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3e4",
    like: false,
    name: "Die Neue 107.7 - Oldies",
    url: "https://str.pcradio.ru/dieneue_1077_oldies-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3e5",
    like: false,
    name: "Die Neue 107.7 - Rock",
    url: "https://str.pcradio.ru/dieneue_1077_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3e6",
    like: false,
    name: "Die Neue 107.7 - Spass",
    url: "https://str.pcradio.ru/dieneue_1077_spass-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3e7",
    like: false,
    name: "Die neue Welle",
    url: "https://str.pcradio.ru/die_neue_welle-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3e8",
    like: false,
    name: "Diesel FM - Techno",
    url: "https://str.pcradio.ru/dieselfm_techno-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3e9",
    like: false,
    name: "Diesel FM - Trance and Progressive",
    url: "https://str.pcradio.ru/dieselfm_trprogr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3ea",
    like: false,
    name: "Different Drumz DnB Radio",
    url: "https://str.pcradio.ru/different_drumz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3eb",
    like: false,
    name: "Different Radio 747 AM",
    url: "https://str.pcradio.ru/different_747-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3ec",
    like: false,
    name: "Digi FM",
    url: "https://str.pcradio.ru/digifm_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3ed",
    like: false,
    name: "Digital Impulse (DI) - Ambient and Chillout",
    url: "https://str.pcradio.ru/di_radio_ambch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3ee",
    like: false,
    name: "Digital Impulse (DI) - Ambient Fantasy",
    url: "https://str.pcradio.ru/di_radio_ambfa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3ef",
    like: false,
    name: "Digital Impulse (DI) - Astra Trance",
    url: "https://str.pcradio.ru/di_radio_astratr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3f0",
    like: false,
    name: "Digital Impulse (DI) - Emacore Trance",
    url: "https://str.pcradio.ru/di_radio_emacoretr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3f1",
    like: false,
    name: "Digital Impulse (DI) - Global Trance",
    url: "https://str.pcradio.ru/di_radio_glotrance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3f2",
    like: false,
    name: "Digital Impulse (DI) - Ori Uplift Trance",
    url: "https://str.pcradio.ru/di_radio_oriuplift-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3f3",
    like: false,
    name: "Digital Impulse (DI) - Psychedelic Tribe",
    url: "https://str.pcradio.ru/di_radio_psytrtr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3f4",
    like: false,
    name: "diis Radio",
    url: "https://str.pcradio.ru/diisradio_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3f5",
    like: false,
    name: "DilemaRadio",
    url: "https://str.pcradio.ru/dilema_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3f6",
    like: false,
    name: "Dimensione Relax",
    url: "https://str.pcradio.ru/dimensione_relax-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3f7",
    like: false,
    name: "Dinamo FM Caffe",
    url: "https://str.pcradio.ru/dinamo_fm_caffe-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3f8",
    like: false,
    name: "Dinamo FM Deep",
    url: "https://str.pcradio.ru/dinamo_fm_deep-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3f9",
    like: false,
    name: "Dinamo FM Discotheque",
    url: "https://str.pcradio.ru/dinamo_fm_disco-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3fa",
    like: false,
    name: "Dinamo FM Legacy",
    url: "https://str.pcradio.ru/dinamo_fm_legacy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3fb",
    like: false,
    name: "Dinamo FM Locodyno",
    url: "https://str.pcradio.ru/dinamo_fm_loco-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3fc",
    like: false,
    name: "Dinamo FM Sleep",
    url: "https://str.pcradio.ru/dinamo_fm_sleep-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3fd",
    like: false,
    name: "Dinamo FM Smog",
    url: "https://str.pcradio.ru/dinamo_fm_smog-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3fe",
    like: false,
    name: "Dinom Dánom mulatós rádió",
    url: "https://str.pcradio.ru/dinom_danom-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec3ff",
    like: false,
    name: "Dio",
    url: "https://str.pcradio.ru/dio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec400",
    like: false,
    name: "Dire Straits",
    url: "https://str.pcradio.ru/dire_straits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec401",
    like: false,
    name: "Disco Power",
    url: "https://str.pcradio.ru/disco_power-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec402",
    like: false,
    name: "Discomania Radio",
    url: "https://str.pcradio.ru/discomaniaradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec403",
    like: false,
    name: "Discoradio",
    url: "https://str.pcradio.ru/discoradio_it-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec404",
    like: false,
    name: "Discover Trance",
    url: "https://str.pcradio.ru/discovertrance_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec406",
    like: false,
    name: "DJ BoBo",
    url: "https://str.pcradio.ru/DJ_BoBo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec407",
    like: false,
    name: "DJ Shaggy Venezuela",
    url: "https://str.pcradio.ru/djshaggy_ve-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec408",
    like: false,
    name: "DJFM",
    url: "https://str.pcradio.ru/djfm_ua-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec409",
    like: false,
    name: "DMX",
    url: "https://str.pcradio.ru/DMX-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec40a",
    like: false,
    name: "DNB FM",
    url: "https://str.pcradio.ru/dnbfm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec40b",
    like: false,
    name: "DNBRadio - Darkstep",
    url: "https://str.pcradio.ru/dnbradio_darkstep-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec40c",
    like: false,
    name: "DNC Radio",
    url: "https://str.pcradio.ru/dnc_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec40d",
    like: false,
    name: "Dobré rádio",
    url: "https://str.pcradio.ru/dobreradio_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec40e",
    like: false,
    name: "Doc Show Coast 2 Coast",
    url: "https://str.pcradio.ru/doc_2_show-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec40f",
    like: false,
    name: "Dokumente und Debatten",
    url: "https://str.pcradio.ru/deutsch_dok_debatten-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec410",
    like: false,
    name: "Dolfijn FM",
    url: "https://str.pcradio.ru/dolfijn_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec411",
    like: false,
    name: "Domradio",
    url: "https://str.pcradio.ru/domradio_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec412",
    like: false,
    name: "Donat FM - Зарубежные хиты",
    url: "https://str.pcradio.ru/donat_whits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec413",
    like: false,
    name: "Donat FM - Музыка СССР",
    url: "https://str.pcradio.ru/donat_ussr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec414",
    like: false,
    name: "Donat FM - Русская поп-музыка",
    url: "https://str.pcradio.ru/donat_rupop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec415",
    like: false,
    name: "Donat FM - Русский Рок",
    url: "https://str.pcradio.ru/donat_rusrock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec416",
    like: false,
    name: "Donat FM - Шансон",
    url: "https://str.pcradio.ru/donat_shanson-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec417",
    like: false,
    name: "Donau 3 FM",
    url: "https://str.pcradio.ru/donau_3fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec418",
    like: false,
    name: "Dost FM",
    url: "https://str.pcradio.ru/dostfm_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec419",
    like: false,
    name: "Downtown Radio",
    url: "https://str.pcradio.ru/downtown_uk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec41a",
    like: false,
    name: "DR P1",
    url: "https://str.pcradio.ru/dr_dk_p1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec41b",
    like: false,
    name: "DR P2",
    url: "https://str.pcradio.ru/dr_dk_p2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec41c",
    like: false,
    name: "DR P3",
    url: "https://str.pcradio.ru/dr_dk_p3-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec41d",
    like: false,
    name: "DR P4 Копенгаген",
    url: "https://str.pcradio.ru/dr_dk_p4kbh-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec41e",
    like: false,
    name: "DR P5",
    url: "https://str.pcradio.ru/dr_dk_p5-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec41f",
    like: false,
    name: "DR P6 Beat",
    url: "https://str.pcradio.ru/dr_dk_p6beat-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec420",
    like: false,
    name: "DR P8 Jazz",
    url: "https://str.pcradio.ru/dr_dk_p8jazz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec421",
    like: false,
    name: "Dr. Alban",
    url: "https://str.pcradio.ru/Dr_Alban-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec422",
    like: false,
    name: "Dragon Ash",
    url: "https://str.pcradio.ru/Dragon_Ash-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec423",
    like: false,
    name: "Dream Радио",
    url: "https://str.pcradio.ru/Dream-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec424",
    like: false,
    name: "8 FM",
    url: "https://str.pcradio.ru/dromosfm_gr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec425",
    like: false,
    name: "Drop The Bass",
    url: "https://str.pcradio.ru/drop_the_bass-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec426",
    like: false,
    name: "Drum'n'Bass",
    url: "https://str.pcradio.ru/Drum_n_Bass-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec427",
    like: false,
    name: "DrumandBass FM",
    url: "https://str.pcradio.ru/drumandbass_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec428",
    like: false,
    name: "Drums.ro Radio",
    url: "https://str.pcradio.ru/drums_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec429",
    like: false,
    name: "Dubbase FM",
    url: "https://str.pcradio.ru/dubbase_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec42a",
    like: false,
    name: "Dubstep Light Radio",
    url: "https://str.pcradio.ru/dubstep_light-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec42b",
    like: false,
    name: "Duk FM",
    url: "https://str.pcradio.ru/duk_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec42c",
    like: false,
    name: "Duna World Radio (MR)",
    url: "https://str.pcradio.ru/duna_world-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec42d",
    like: false,
    name: "Dupleks",
    url: "https://str.pcradio.ru/Dupleks-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec42e",
    like: false,
    name: "Duplex Pop FM",
    url: "https://str.pcradio.ru/Duplex_pop_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec42f",
    like: false,
    name: "DWG Радио Слово",
    url: "https://str.pcradio.ru/dwg_radioslovo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec430",
    like: false,
    name: "DXFM Radio",
    url: "https://str.pcradio.ru/dxfm_com_ua-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec431",
    like: false,
    name: "Eagle Eye Cherry",
    url: "https://str.pcradio.ru/Eagle_Eye_Cherry-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec432",
    like: false,
    name: "Easy Hits Florida",
    url: "https://str.pcradio.ru/easy_hits_flo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec433",
    like: false,
    name: "Eco 99 FM",
    url: "https://str.pcradio.ru/eco99_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec434",
    like: false,
    name: "Edem UKV",
    url: "https://str.pcradio.ru/edem_ukv-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec435",
    like: false,
    name: "Edenex",
    url: "https://str.pcradio.ru/edenex_es-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec436",
    like: false,
    name: "EDM Radio",
    url: "https://str.pcradio.ru/edmradioru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec437",
    like: false,
    name: "egoFLASH",
    url: "https://str.pcradio.ru/egofm_flash-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec438",
    like: false,
    name: "egoFM 50fresh",
    url: "https://str.pcradio.ru/egofm_50fresh-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec439",
    like: false,
    name: "egoFM 50fresh Elektro",
    url: "https://str.pcradio.ru/egofm_50elektro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec43a",
    like: false,
    name: "egoFM 50fresh RAP",
    url: "https://str.pcradio.ru/egofm_50rap-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec43b",
    like: false,
    name: "egoFM Live",
    url: "https://str.pcradio.ru/egofm_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec43c",
    like: false,
    name: "egoFM SEEWALD",
    url: "https://str.pcradio.ru/egofm_seewald-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec43d",
    like: false,
    name: "egoPURE",
    url: "https://str.pcradio.ru/egofm_pure-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec43e",
    like: false,
    name: "egoRAP",
    url: "https://str.pcradio.ru/egofm_rap-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec43f",
    like: false,
    name: "egoRIFF",
    url: "https://str.pcradio.ru/egofm_riff-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec440",
    like: false,
    name: "egoSOUL",
    url: "https://str.pcradio.ru/egofm_soul-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec441",
    like: false,
    name: "Eingdoi Radio Thailand",
    url: "https://str.pcradio.ru/eingdoi_thai-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec442",
    like: false,
    name: "Electro Dreams",
    url: "https://str.pcradio.ru/Electrodreams-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec443",
    like: false,
    name: "Electro Radio",
    url: "https://str.pcradio.ru/electroradio_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec444",
    like: false,
    name: "Electro Swing Revolution Radio",
    url: "https://str.pcradio.ru/electroswingradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec445",
    like: false,
    name: "Electromusic Radio",
    url: "https://str.pcradio.ru/electromusic_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec446",
    like: false,
    name: "Electrozombies",
    url: "https://str.pcradio.ru/electrozombies_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec447",
    like: false,
    name: "Elton John",
    url: "https://str.pcradio.ru/Elton_John-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec448",
    like: false,
    name: "Elvis Presley",
    url: "https://str.pcradio.ru/Elvis_Presley-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec449",
    like: false,
    name: "Emergency FM DNB",
    url: "https://str.pcradio.ru/emergencyfm_dnb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec44a",
    like: false,
    name: "Eminem",
    url: "https://str.pcradio.ru/Eminem-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec44b",
    like: false,
    name: "Emma Shapplin",
    url: "https://str.pcradio.ru/Emma_Shapplin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec44c",
    like: false,
    name: "EndTime Prayer Radio",
    url: "https://str.pcradio.ru/endtime_prayer-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec44d",
    like: false,
    name: "Energy 98",
    url: "https://str.pcradio.ru/energy981com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec44e",
    like: false,
    name: "Energy Acoustic",
    url: "https://str.pcradio.ru/nrj_de_acoustic-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec44f",
    like: false,
    name: "Energy Berlin",
    url: "https://str.pcradio.ru/nrj_berlin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec450",
    like: false,
    name: "Energy Bremen",
    url: "https://str.pcradio.ru/nrj_bremen-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec451",
    like: false,
    name: "Energy Classic Rap US",
    url: "https://str.pcradio.ru/nrj_classrap_us-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec452",
    like: false,
    name: "Energy Clubbin'",
    url: "https://str.pcradio.ru/nrj_de_clubbin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec453",
    like: false,
    name: "Energy Dance",
    url: "https://str.pcradio.ru/nrj_de_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec454",
    like: false,
    name: "Energy Fitness",
    url: "https://str.pcradio.ru/nrj_de_fitness-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec455",
    like: false,
    name: "Energy FM",
    url: "https://str.pcradio.ru/energyfm_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec456",
    like: false,
    name: "Energy FM 100.4",
    url: "https://str.pcradio.ru/energy1004_by-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec457",
    like: false,
    name: "Energy FM 102.2",
    url: "https://str.pcradio.ru/energyfmkz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec458",
    like: false,
    name: "Energy FM Australia",
    url: "https://str.pcradio.ru/energyfm_com_au-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec459",
    like: false,
    name: "Energy Hamburg",
    url: "https://str.pcradio.ru/nrj_hamburg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec45a",
    like: false,
    name: "Energy Hits",
    url: "https://str.pcradio.ru/nrj_de_hits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec45b",
    like: false,
    name: "Energy Latino",
    url: "https://str.pcradio.ru/nrj_de_latino-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec45c",
    like: false,
    name: "Energy Lounge",
    url: "https://str.pcradio.ru/nrj_de_lounge-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec45d",
    like: false,
    name: "Energy Love",
    url: "https://str.pcradio.ru/nrj_de_love-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec45e",
    like: false,
    name: "Energy Mastermix",
    url: "https://str.pcradio.ru/nrj_de_mastermix-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec45f",
    like: false,
    name: "Energy München",
    url: "https://str.pcradio.ru/nrj_munchen-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec460",
    like: false,
    name: "Energy Nürnberg",
    url: "https://str.pcradio.ru/nrj_nurnberg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec461",
    like: false,
    name: "Energy Party Hits",
    url: "https://str.pcradio.ru/nrj_de_party-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec462",
    like: false,
    name: "Energy Pop",
    url: "https://str.pcradio.ru/nrj_de_pop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec463",
    like: false,
    name: "Energy Rap US",
    url: "https://str.pcradio.ru/nrj_de_rapus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec464",
    like: false,
    name: "Energy Relax",
    url: "https://str.pcradio.ru/nrj_de_relax-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec465",
    like: false,
    name: "Energy RnB",
    url: "https://str.pcradio.ru/nrj_de_rnb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec466",
    like: false,
    name: "Energy Rock",
    url: "https://str.pcradio.ru/nrj_de_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec467",
    like: false,
    name: "Energy Romantic",
    url: "https://str.pcradio.ru/nrj_de_romantic-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec468",
    like: false,
    name: "Energy Sachsen",
    url: "https://str.pcradio.ru/nrj_sachsen-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec469",
    like: false,
    name: "Energy Stuttgart",
    url: "https://str.pcradio.ru/nrj_stutgart-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec46a",
    like: false,
    name: "Energy Urban",
    url: "https://str.pcradio.ru/nrj_de_urban-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec46b",
    like: false,
    name: "Energy Web Radio",
    url: "https://str.pcradio.ru/energywebradio_it-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec46c",
    like: false,
    name: "Enigma",
    url: "https://str.pcradio.ru/Enigma-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec46d",
    like: false,
    name: "Enigmatic station I",
    url: "https://str.pcradio.ru/enigmatic_su1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec46e",
    like: false,
    name: "Enigmatic station III",
    url: "https://str.pcradio.ru/enigmatic_su3-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec46f",
    like: false,
    name: "Ennio Morricone",
    url: "https://str.pcradio.ru/Ennio_Morricone-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec470",
    like: false,
    name: "Enrique Iglesias",
    url: "https://str.pcradio.ru/Enrique_Iglesias-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec471",
    like: false,
    name: "Enya",
    url: "https://str.pcradio.ru/enya-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec472",
    like: false,
    name: "Epic Rock Radio (ERR)",
    url: "https://str.pcradio.ru/epic_rock_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec473",
    like: false,
    name: "Era",
    url: "https://str.pcradio.ru/Era-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec474",
    like: false,
    name: "ERA 3 Trito (Τριτο προγραμμα)",
    url: "https://str.pcradio.ru/trito_programa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec475",
    like: false,
    name: "ERA Deftero (Δευτερο προγραμμα)",
    url: "https://str.pcradio.ru/deftero_programa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec476",
    like: false,
    name: "ERA Proto (Πρωτο προγραμμα)",
    url: "https://str.pcradio.ru/proto_programa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec477",
    like: false,
    name: "Erasure",
    url: "https://str.pcradio.ru/erasure-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec478",
    like: false,
    name: "Erdély FM",
    url: "https://str.pcradio.ru/erdelyfm_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec479",
    like: false,
    name: "ERF Plus",
    url: "https://str.pcradio.ru/erf_plus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec47a",
    like: false,
    name: "ERF Pop",
    url: "https://str.pcradio.ru/erf_pop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec47b",
    like: false,
    name: "ERR Klassikaraadio",
    url: "https://str.pcradio.ru/err_klassika-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec47c",
    like: false,
    name: "ERR Raadio 2",
    url: "https://str.pcradio.ru/err_raadio2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec47d",
    like: false,
    name: "ERR Raadio 4",
    url: "https://str.pcradio.ru/raadio_4_ee-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec47e",
    like: false,
    name: "ERR Raadio Tallinn",
    url: "https://str.pcradio.ru/err_tallinn-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec47f",
    like: false,
    name: "ERR Vikerraadio",
    url: "https://str.pcradio.ru/err_vikerraadio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec480",
    like: false,
    name: "esRadio (Мадрид)",
    url: "https://str.pcradio.ru/esradio_madrid-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec481",
    like: false,
    name: "ETN.FM Trance",
    url: "https://str.pcradio.ru/etnfm_trance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec482",
    like: false,
    name: "Eurodance 90’s - Dance anos 90",
    url: "https://str.pcradio.ru/danceanos90_br-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec483",
    like: false,
    name: "EuroDance Hit",
    url: "https://str.pcradio.ru/EuroDance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec484",
    like: false,
    name: "Europa 2",
    url: "https://str.pcradio.ru/europa2_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec485",
    like: false,
    name: "Europa FM (Бухарест)",
    url: "https://str.pcradio.ru/europafm_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec486",
    like: false,
    name: "EuropaRussia",
    url: "https://str.pcradio.ru/europarussia_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec487",
    like: false,
    name: "Europe 1",
    url: "https://str.pcradio.ru/europe1_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec488",
    like: false,
    name: "European Hit Radio (EHR)",
    url: "https://str.pcradio.ru/ehr_riga-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec489",
    like: false,
    name: "Euroradio FM - Alternative",
    url: "https://str.pcradio.ru/euroradio_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec48a",
    like: false,
    name: "Euroradio FM - Soft Rock",
    url: "https://str.pcradio.ru/euroradio_soro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec48c",
    like: false,
    name: "Eurovision Radio",
    url: "https://str.pcradio.ru/Eurovision-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec48d",
    like: false,
    name: "Evanescence",
    url: "https://str.pcradio.ru/Evanescence-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec48e",
    like: false,
    name: "Evosonic Radio",
    url: "https://str.pcradio.ru/evo_sonic-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec48f",
    like: false,
    name: "Evropa 2 (Прага)",
    url: "https://str.pcradio.ru/evropa2_praga-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec490",
    like: false,
    name: "EWTN Radio",
    url: "https://str.pcradio.ru/ewtn_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec491",
    like: false,
    name: "Excite Bit",
    url: "https://str.pcradio.ru/excitebit_vgm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec492",
    like: false,
    name: "Extra-Radio 88.0",
    url: "https://str.pcradio.ru/extra_880-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec493",
    like: false,
    name: "Ez az a nap!",
    url: "https://str.pcradio.ru/ezazanap_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec494",
    like: false,
    name: "Faaz",
    url: "https://str.pcradio.ru/faaz_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec495",
    like: false,
    name: "Faithless",
    url: "https://str.pcradio.ru/faithless-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec496",
    like: false,
    name: "Fajn Rádio",
    url: "https://str.pcradio.ru/fajnradio_cz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec497",
    like: false,
    name: "Fantasy Bayern",
    url: "https://str.pcradio.ru/fantasy_bayern-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec498",
    like: false,
    name: "Fantasy Radio",
    url: "https://str.pcradio.ru/fantasy_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec499",
    like: false,
    name: "Fashion Радио",
    url: "https://str.pcradio.ru/Fashion-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec49a",
    like: false,
    name: "Fatboy Slim",
    url: "https://str.pcradio.ru/Fatboy_Slim-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec49b",
    like: false,
    name: "Felix Radio",
    url: "https://str.pcradio.ru/felix_myrh-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec49c",
    like: false,
    name: "Fenomen Maksimum Hit Muzik",
    url: "https://str.pcradio.ru/fenomenturk_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec49d",
    like: false,
    name: "FFH BrandNeu",
    url: "https://str.pcradio.ru/ffh_brand_neu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec49e",
    like: false,
    name: "FFH Die 80er",
    url: "https://str.pcradio.ru/ffh_80er-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec49f",
    like: false,
    name: "FFH Eurodance",
    url: "https://str.pcradio.ru/ffh_eurodance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4a0",
    like: false,
    name: "FFH Hit Radio",
    url: "https://str.pcradio.ru/ffh_hit_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4a1",
    like: false,
    name: "FFH iTunes Top40",
    url: "https://str.pcradio.ru/ffh_itunes_top40-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4a2",
    like: false,
    name: "FFH Just 90s",
    url: "https://str.pcradio.ru/ffh_90s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4a3",
    like: false,
    name: "FFH Leider Geil",
    url: "https://str.pcradio.ru/ffh_leider_geil-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4a4",
    like: false,
    name: "FFH Lounge",
    url: "https://str.pcradio.ru/ffh_lounge-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4a5",
    like: false,
    name: "FFH Party",
    url: "https://str.pcradio.ru/ffh_party-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4a6",
    like: false,
    name: "FFH Rock",
    url: "https://str.pcradio.ru/ffh_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4a7",
    like: false,
    name: "FFH SchlagerKult",
    url: "https://str.pcradio.ru/ffh_kult_schlager-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4a8",
    like: false,
    name: "FFH Soundtrack",
    url: "https://str.pcradio.ru/ffh_soundtrack-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4a9",
    like: false,
    name: "FFH WeihnachtsRadio",
    url: "https://str.pcradio.ru/ffh_xmas-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4aa",
    like: false,
    name: "Fiction Junction",
    url: "https://str.pcradio.ru/Fiction_Junction-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4ab",
    like: false,
    name: "Fiesta FM 87.6 (Мальорка)",
    url: "https://str.pcradio.ru/fiesta_mallorca-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4ac",
    like: false,
    name: "Fip",
    url: "https://str.pcradio.ru/fip_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4ad",
    like: false,
    name: "Fip autour du Groove",
    url: "https://str.pcradio.ru/fip_groove-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4ae",
    like: false,
    name: "Fip autour du Jazz",
    url: "https://str.pcradio.ru/fip_jazz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4af",
    like: false,
    name: "Fip autour du Monde",
    url: "https://str.pcradio.ru/fip_world-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4b0",
    like: false,
    name: "Fip autour du Rock",
    url: "https://str.pcradio.ru/fip_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4b1",
    like: false,
    name: "Fip Reggae",
    url: "https://str.pcradio.ru/fip_reggae-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4b2",
    like: false,
    name: "Fip Tout nouveau",
    url: "https://str.pcradio.ru/fip_new-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4b3",
    like: false,
    name: "FitDance",
    url: "https://str.pcradio.ru/fit_dance_pcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4b4",
    like: false,
    name: "Five Finger Death Punch",
    url: "https://str.pcradio.ru/five_finger_death_punch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4b5",
    like: false,
    name: "Flaix FM",
    url: "https://str.pcradio.ru/flaixfm_cat-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4b6",
    like: false,
    name: "Flashback 91.9 FM",
    url: "https://str.pcradio.ru/flashback_919-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4b7",
    like: false,
    name: "Fly FM",
    url: "https://str.pcradio.ru/flyfm_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4b8",
    like: false,
    name: "FM 4 us",
    url: "https://str.pcradio.ru/fm_4us-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4b9",
    like: false,
    name: "FM Klassics",
    url: "https://str.pcradio.ru/fm_klassics-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4ba",
    like: false,
    name: "FM Галичина",
    url: "https://str.pcradio.ru/fm_galychyna-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4bb",
    like: false,
    name: "FM1 Nord",
    url: "https://str.pcradio.ru/fm1_nord-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4bc",
    like: false,
    name: "FM1 Sued",
    url: "https://str.pcradio.ru/fm1_sued-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4bd",
    like: false,
    name: "FM957",
    url: "https://str.pcradio.ru/fm957_is-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4be",
    like: false,
    name: "Fomenko Fake Radio",
    url: "https://str.pcradio.ru/fomenko_fake-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4bf",
    like: false,
    name: "Foreigner",
    url: "https://str.pcradio.ru/Foreigner-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4c0",
    like: false,
    name: "Foroactivo Polymarchs Radio",
    url: "https://str.pcradio.ru/foro_polymarch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4c1",
    like: false,
    name: "Fox 91.4 FM",
    url: "https://str.pcradio.ru/fox_914-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4c2",
    like: false,
    name: "Fox Radio 97.9 FM",
    url: "https://str.pcradio.ru/foxradio_rs-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4c3",
    like: false,
    name: "France Bleu Elsass",
    url: "https://str.pcradio.ru/francebleu_els-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4c4",
    like: false,
    name: "France Culture",
    url: "https://str.pcradio.ru/franceculture_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4c5",
    like: false,
    name: "France Inter",
    url: "https://str.pcradio.ru/france_inter-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4c6",
    like: false,
    name: "France Musique",
    url: "https://str.pcradio.ru/francemusique_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4c7",
    like: false,
    name: "Franceinfo",
    url: "https://str.pcradio.ru/franceinfo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4c8",
    like: false,
    name: "Frank Duval",
    url: "https://str.pcradio.ru/Frank_Duval-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4c9",
    like: false,
    name: "Frank Sinatra",
    url: "https://str.pcradio.ru/frank_sinatra-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4ca",
    like: false,
    name: "Fraszka UJK",
    url: "https://str.pcradio.ru/fraszka_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4cb",
    like: false,
    name: "Freak Radio 18+",
    url: "https://str.pcradio.ru/freak_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4cc",
    like: false,
    name: "Freak31",
    url: "https://str.pcradio.ru/freak31_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4cd",
    like: false,
    name: "Free Americana",
    url: "https://str.pcradio.ru/freeamericana_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4ce",
    like: false,
    name: "Free FM (Коломбо)",
    url: "https://str.pcradio.ru/freefm_lk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4cf",
    like: false,
    name: "Free Spirit",
    url: "https://str.pcradio.ru/Free_spirit_fin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4d0",
    like: false,
    name: "Free Time Radio",
    url: "https://str.pcradio.ru/free_time_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4d1",
    like: false,
    name: "Freedom",
    url: "https://str.pcradio.ru/freedom_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4d2",
    like: false,
    name: "Freelance FM",
    url: "https://str.pcradio.ru/freelance_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4d3",
    like: false,
    name: "Freies Radio Freudenstadt",
    url: "https://str.pcradio.ru/freies_freudenstadt-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4d4",
    like: false,
    name: "Freies Radio für Stuttgart (FRS)",
    url: "https://str.pcradio.ru/freies_stuttgart-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4d5",
    like: false,
    name: "Freies Radio Wiesental",
    url: "https://str.pcradio.ru/freies_wiesental-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4d6",
    like: false,
    name: "Frekvence 1",
    url: "https://str.pcradio.ru/frekvence_1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4d7",
    like: false,
    name: "Fresh 92.7",
    url: "https://str.pcradio.ru/fresh_927-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4d8",
    like: false,
    name: "Fresh FM 105.0",
    url: "https://str.pcradio.ru/fresh_fm_sosna-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4d9",
    like: false,
    name: "Fresh Radio",
    url: "https://str.pcradio.ru/freshradio_es-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4da",
    like: false,
    name: "Fresh Rock",
    url: "https://str.pcradio.ru/freshrock_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4db",
    like: false,
    name: "Frisky Chill",
    url: "https://str.pcradio.ru/frisky_chill-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4dc",
    like: false,
    name: "Frisky Radio",
    url: "https://str.pcradio.ru/frisky_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4dd",
    like: false,
    name: "Fritz",
    url: "https://str.pcradio.ru/fritz_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4de",
    like: false,
    name: "Frontinus",
    url: "https://str.pcradio.ru/frontinus_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4df",
    like: false,
    name: "Fréquence 3",
    url: "https://str.pcradio.ru/frequence3_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4e0",
    like: false,
    name: "Fréquence 3 - Gold",
    url: "https://str.pcradio.ru/frequence3_gold-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4e1",
    like: false,
    name: "Fréquence 3 - Urban 3",
    url: "https://str.pcradio.ru/frequence3_urban-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4e2",
    like: false,
    name: "Fun Radio",
    url: "https://str.pcradio.ru/funradio_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4e3",
    like: false,
    name: "Fun Radio 80s-90s",
    url: "https://str.pcradio.ru/funradio_sk_80s90s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4e4",
    like: false,
    name: "3 FM",
    url: "https://str.pcradio.ru/funradio_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4e5",
    like: false,
    name: "Fun Radio 95.3",
    url: "https://str.pcradio.ru/funradio_953-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4e6",
    like: false,
    name: "Fun Radio CZ-SK",
    url: "https://str.pcradio.ru/funradio_czsk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4e7",
    like: false,
    name: "Fun Radio Dance",
    url: "https://str.pcradio.ru/funradio_sk_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4e8",
    like: false,
    name: "Funk2Disco",
    url: "https://str.pcradio.ru/funk2disco-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4e9",
    like: false,
    name: "Funklust",
    url: "https://str.pcradio.ru/funklust_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4ea",
    like: false,
    name: "FunkURadio (FUR FM)",
    url: "https://str.pcradio.ru/funkuradio_co_uk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4eb",
    like: false,
    name: "Funky Corner Radio",
    url: "https://str.pcradio.ru/funky_corner-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4ec",
    like: false,
    name: "Funky House",
    url: "https://str.pcradio.ru/Funky_House-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4ed",
    like: false,
    name: "Funky Town",
    url: "https://str.pcradio.ru/funky_town-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4ee",
    like: false,
    name: "FUV",
    url: "https://str.pcradio.ru/wfuv_music-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4ef",
    like: false,
    name: "G-Radio",
    url: "https://str.pcradio.ru/gradio_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4f0",
    like: false,
    name: "Galaxy Aschaffenburg",
    url: "https://str.pcradio.ru/galaxy_916-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4f1",
    like: false,
    name: "Galaxy Landshut",
    url: "https://str.pcradio.ru/galaxy_landshut-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4f2",
    like: false,
    name: "Galaxy Mittelfranken",
    url: "https://str.pcradio.ru/galaxy_mittel-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4f3",
    like: false,
    name: "Galaxy Oberfranken",
    url: "https://str.pcradio.ru/galaxy_oberfranken-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4f4",
    like: false,
    name: "Galaxy Passau",
    url: "https://str.pcradio.ru/galaxy_passau-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4f5",
    like: false,
    name: "Galei Tzahal",
    url: "https://str.pcradio.ru/galei_tzahal-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4f6",
    like: false,
    name: "Galey Israel 106.5 FM",
    url: "https://str.pcradio.ru/galey_israel-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4f7",
    like: false,
    name: "Galgalatz",
    url: "https://str.pcradio.ru/galgalatz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4f8",
    like: false,
    name: "Game Play",
    url: "https://str.pcradio.ru/radiogameplay_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4f9",
    like: false,
    name: "Gamma Ray",
    url: "https://str.pcradio.ru/Gamma_Ray-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4fa",
    like: false,
    name: "Gay FM - Pure Dance",
    url: "https://str.pcradio.ru/gayfm_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4fb",
    like: false,
    name: "Gay Moscow Radio 18+",
    url: "https://str.pcradio.ru/gay_moscow-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4fc",
    like: false,
    name: "GDS Radio",
    url: "https://str.pcradio.ru/gds_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4fd",
    like: false,
    name: "Generation Soul Disco Funk",
    url: "https://str.pcradio.ru/generationdiscofunk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4fe",
    like: false,
    name: "Generations Rap US",
    url: "https://str.pcradio.ru/generation_rapus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec4ff",
    like: false,
    name: "Generations Rap US Gold",
    url: "https://str.pcradio.ru/gener_rapusgold-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec500",
    like: false,
    name: "Gensokyo Radio",
    url: "https://str.pcradio.ru/gensokyo_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec501",
    like: false,
    name: "George FM",
    url: "https://str.pcradio.ru/georgefm_nz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec502",
    like: false,
    name: "George Harrison",
    url: "https://str.pcradio.ru/george_harrison-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec503",
    like: false,
    name: "George Michael",
    url: "https://str.pcradio.ru/George_Michael-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec504",
    like: false,
    name: "GhanaPa",
    url: "https://str.pcradio.ru/ghanapa_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec505",
    like: false,
    name: "GiBFM",
    url: "https://str.pcradio.ru/gibfm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec506",
    like: false,
    name: "Giga-Dance",
    url: "https://str.pcradio.ru/Giga_Dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec507",
    like: false,
    name: "Gigant FM",
    url: "https://str.pcradio.ru/gigant_nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec508",
    like: false,
    name: "GIKRadio",
    url: "https://str.pcradio.ru/gikradio_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec509",
    like: false,
    name: "Gimadut Radio",
    url: "https://str.pcradio.ru/gimadut_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec50a",
    like: false,
    name: "Gimadut Radio Book",
    url: "https://str.pcradio.ru/gimadut_book-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec50b",
    like: false,
    name: "Giorgos Mazonakis",
    url: "https://str.pcradio.ru/Giorgos_Mazonakis-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec50c",
    like: false,
    name: "Gipsy Kings",
    url: "https://str.pcradio.ru/Gipsy_Kings-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec50d",
    like: false,
    name: "Global Funk Radio",
    url: "https://str.pcradio.ru/global_funk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec50e",
    like: false,
    name: "Godsmack",
    url: "https://str.pcradio.ru/Godsmack-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec50f",
    like: false,
    name: "Gold FM 93.2",
    url: "https://str.pcradio.ru/goldfm_932-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec510",
    like: false,
    name: "Gold London",
    url: "https://str.pcradio.ru/gold_the_greatest_uk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec511",
    like: false,
    name: "gong fm (Регенсбург)",
    url: "https://str.pcradio.ru/gongfm_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec512",
    like: false,
    name: "Gong Rádió",
    url: "https://str.pcradio.ru/gongradio_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec513",
    like: false,
    name: "Good Times Revival",
    url: "https://str.pcradio.ru/good_times_revival-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec514",
    like: false,
    name: "Gorillaz",
    url: "https://str.pcradio.ru/Gorillaz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec515",
    like: false,
    name: "Gospel Adoradores",
    url: "https://str.pcradio.ru/radiogospeladoradores_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec516",
    like: false,
    name: "Gospel FM 89.3",
    url: "https://str.pcradio.ru/redegospelfm_com_br-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec517",
    like: false,
    name: "Gospel FM 90.1",
    url: "https://str.pcradio.ru/gospelfm_com_br-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec518",
    like: false,
    name: "Gospel Hits",
    url: "https://str.pcradio.ru/tonagospel_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec519",
    like: false,
    name: "Gospel Zooom",
    url: "https://str.pcradio.ru/gospel_zooom-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec51a",
    like: false,
    name: "GotRadio - Celtic Crossing",
    url: "https://str.pcradio.ru/celtic_crossing-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec51b",
    like: false,
    name: "GotRadio - New Age Nuance",
    url: "https://str.pcradio.ru/gotradio_newagenuance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec51c",
    like: false,
    name: "GotRadio Metal Madness",
    url: "https://str.pcradio.ru/gotradio_metalmad-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec51d",
    like: false,
    name: "Graal Radio Club",
    url: "https://str.pcradio.ru/graal_club-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec51e",
    like: false,
    name: "Graal Radio Future",
    url: "https://str.pcradio.ru/graal_future-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec51f",
    like: false,
    name: "Graal Radio Goodtimes",
    url: "https://str.pcradio.ru/graal_goodtimes-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec520",
    like: false,
    name: "Graal Radio Highway",
    url: "https://str.pcradio.ru/graal_highway-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec521",
    like: false,
    name: "Graal Radio Melt",
    url: "https://str.pcradio.ru/graal_melt-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec522",
    like: false,
    name: "Graal Radio Sensual",
    url: "https://str.pcradio.ru/graal_sensual-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec523",
    like: false,
    name: "Graal Radio Space",
    url: "https://str.pcradio.ru/graal_space-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec524",
    like: false,
    name: "GRAZ FM",
    url: "https://str.pcradio.ru/graz_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec525",
    like: false,
    name: "Greatest Hits Radio",
    url: "https://str.pcradio.ru/greatesthits_couk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec526",
    like: false,
    name: "Greatest Songs Radio",
    url: "https://str.pcradio.ru/mjoy_greatest-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec527",
    like: false,
    name: "Green Day",
    url: "https://str.pcradio.ru/green_day-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec528",
    like: false,
    name: "Green Grey",
    url: "https://str.pcradio.ru/green_grey-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec529",
    like: false,
    name: "GreenMusic Radio",
    url: "https://str.pcradio.ru/green_music_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec52a",
    like: false,
    name: "Griaß di' Allgäu Radio",
    url: "https://str.pcradio.ru/rsa_griass_allgau-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec52b",
    like: false,
    name: "Groove Classics",
    url: "https://str.pcradio.ru/groove_classics-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec52c",
    like: false,
    name: "GTI Radio",
    url: "https://str.pcradio.ru/gtiradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec52d",
    like: false,
    name: "GtronicRadio",
    url: "https://str.pcradio.ru/gtronic_us-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec52e",
    like: false,
    name: "GU Blue Радио",
    url: "https://str.pcradio.ru/gu_blue_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec52f",
    like: false,
    name: "GU Green Радио",
    url: "https://str.pcradio.ru/gu_green_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec530",
    like: false,
    name: "GU Red Радио",
    url: "https://str.pcradio.ru/gu_red_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec531",
    like: false,
    name: "Guano Apes",
    url: "https://str.pcradio.ru/guano_apes-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec532",
    like: false,
    name: "Guf",
    url: "https://str.pcradio.ru/Guf-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec533",
    like: false,
    name: "Guldkanalen 60-е",
    url: "https://str.pcradio.ru/guldkanalen_60-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec534",
    like: false,
    name: "Guldkanalen 70-е",
    url: "https://str.pcradio.ru/guldkanalen_70-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec535",
    like: false,
    name: "Guldkanalen 80-е",
    url: "https://str.pcradio.ru/guldkanalen_80-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec536",
    like: false,
    name: "Guldkanalen 90-е",
    url: "https://str.pcradio.ru/guldkanalen_90-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec537",
    like: false,
    name: "Guldkanalen Live",
    url: "https://str.pcradio.ru/guldkanalen_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec538",
    like: false,
    name: "Guns N' Roses",
    url: "https://str.pcradio.ru/guns_n_roses-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec53a",
    like: false,
    name: "Happyday Newage Radio COOOOL",
    url: "https://str.pcradio.ru/happyday_newage_coool-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec53b",
    like: false,
    name: "Happyday Newage Radio EZ",
    url: "https://str.pcradio.ru/happyday_newage_ez-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec53c",
    like: false,
    name: "Hard Rock Hell Radio",
    url: "https://str.pcradio.ru/hardrock_hell-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec53d",
    like: false,
    name: "Harmony FM",
    url: "https://str.pcradio.ru/harmonyfm_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec53e",
    like: false,
    name: "Hashtag Plus",
    url: "https://str.pcradio.ru/hashtagplus_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec53f",
    like: false,
    name: "Healing Music",
    url: "https://str.pcradio.ru/healing_music-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec540",
    like: false,
    name: "Heart FM",
    url: "https://str.pcradio.ru/heartfm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec541",
    like: false,
    name: "Henri Des",
    url: "https://str.pcradio.ru/radio_henrides_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec542",
    like: false,
    name: "Hi-Fi",
    url: "https://str.pcradio.ru/Hi_fi-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec543",
    like: false,
    name: "HipHopBy",
    url: "https://str.pcradio.ru/hiphop_by-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec544",
    like: false,
    name: "Hirschmilch Radio - Chillout",
    url: "https://str.pcradio.ru/hirschmilch_chill-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec545",
    like: false,
    name: "Hirschmilch Radio - Electronic",
    url: "https://str.pcradio.ru/hirschmilch_electronic-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec546",
    like: false,
    name: "Hirschmilch Radio - Prog House",
    url: "https://str.pcradio.ru/hirschmilch_proghouse-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec547",
    like: false,
    name: "Hirschmilch Radio - Progressive",
    url: "https://str.pcradio.ru/hirschmilch_prog-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec548",
    like: false,
    name: "Hirschmilch Radio - Psytrance",
    url: "https://str.pcradio.ru/hirschmilch_psytrance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec549",
    like: false,
    name: "Hiru FM (ABC)",
    url: "https://str.pcradio.ru/hirufm_abc-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec54a",
    like: false,
    name: "Hit 104",
    url: "https://str.pcradio.ru/hit104_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec54b",
    like: false,
    name: "Hit Club Dance",
    url: "https://str.pcradio.ru/hitclub_vip-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec54c",
    like: false,
    name: "7 (Кишинев)",
    url: "https://str.pcradio.ru/hitfm_kishinev-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec54d",
    like: false,
    name: "Hit Radio N1",
    url: "https://str.pcradio.ru/hitradion1_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec54e",
    like: false,
    name: "Hit Rock FM",
    url: "https://str.pcradio.ru/hit_rock_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec54f",
    like: false,
    name: "Hit Rádió (Будапешт)",
    url: "https://str.pcradio.ru/hitradio_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec550",
    like: false,
    name: "Hit West",
    url: "https://str.pcradio.ru/hitwest_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec551",
    like: false,
    name: "Hit Zone FM",
    url: "https://str.pcradio.ru/Hit_zone_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec552",
    like: false,
    name: "Hitradio 915",
    url: "https://str.pcradio.ru/hitradio_915-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec553",
    like: false,
    name: "Hitradio Namibia",
    url: "https://str.pcradio.ru/hitradio_namib-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec554",
    like: false,
    name: "Hitradio Ohr",
    url: "https://str.pcradio.ru/hitradio_ohr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec555",
    like: false,
    name: "HitRadio RT1",
    url: "https://str.pcradio.ru/rt1_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec556",
    like: false,
    name: "Hitradio RTL Sachsen",
    url: "https://str.pcradio.ru/rtl_sachsen-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec557",
    like: false,
    name: "Hitradio Ö3",
    url: "https://str.pcradio.ru/oe3_orf_at-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec558",
    like: false,
    name: "Hits of Bollywood",
    url: "https://str.pcradio.ru/hits_ofbolly-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec559",
    like: false,
    name: "HIts1 Latina",
    url: "https://str.pcradio.ru/hits1radio_latina-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec55a",
    like: false,
    name: "Hitz FM",
    url: "https://str.pcradio.ru/hitz_mala-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec55b",
    like: false,
    name: "Hitz24",
    url: "https://str.pcradio.ru/hitz24_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec55c",
    like: false,
    name: "Hobby Rádió",
    url: "https://str.pcradio.ru/hobbyradio_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec55d",
    like: false,
    name: "Home FM",
    url: "https://str.pcradio.ru/home_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec55e",
    like: false,
    name: "HoRadS (Hochschulradio)",
    url: "https://str.pcradio.ru/horads_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec55f",
    like: false,
    name: "Horeb",
    url: "https://str.pcradio.ru/radio_horeb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec560",
    like: false,
    name: "Hot 108 Jamz",
    url: "https://str.pcradio.ru/hot108_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec561",
    like: false,
    name: "Hot Dance Radio",
    url: "https://str.pcradio.ru/hotdanceradio_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec562",
    like: false,
    name: "Hot Jamz 88.9 FM",
    url: "https://str.pcradio.ru/hotjamz_889-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec563",
    like: false,
    name: "Hotmix Radio - 80s",
    url: "https://str.pcradio.ru/hotmixradio_80-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec564",
    like: false,
    name: "Hotmix Radio - Funky",
    url: "https://str.pcradio.ru/hotmix_funky-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec565",
    like: false,
    name: "Hotmix Radio - Golds",
    url: "https://str.pcradio.ru/hotmix_golds-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec566",
    like: false,
    name: "House Bit",
    url: "https://str.pcradio.ru/house_bit_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec567",
    like: false,
    name: "House Groove",
    url: "https://str.pcradio.ru/housegroove_pcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec568",
    like: false,
    name: "House radio",
    url: "https://str.pcradio.ru/housee_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec569",
    like: false,
    name: "HouseTime FM",
    url: "https://str.pcradio.ru/housetime_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec56a",
    like: false,
    name: "HPR1 - Traditional Classic Country",
    url: "https://str.pcradio.ru/hpr1_tradcountry-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec56b",
    like: false,
    name: "HPR2 - Today's Classic Country",
    url: "https://str.pcradio.ru/hpr2_todaycountry-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec56c",
    like: false,
    name: "HR Radio",
    url: "https://str.pcradio.ru/hrradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec56d",
    like: false,
    name: "hr-iNFO",
    url: "https://str.pcradio.ru/hr_info-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec56e",
    like: false,
    name: "HR1",
    url: "https://str.pcradio.ru/hr1_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec56f",
    like: false,
    name: "HR2 Kultur",
    url: "https://str.pcradio.ru/hr2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec570",
    like: false,
    name: "HR3",
    url: "https://str.pcradio.ru/hr3-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec571",
    like: false,
    name: "HR4",
    url: "https://str.pcradio.ru/hr4_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec572",
    like: false,
    name: "Hua Hin Music Radio",
    url: "https://str.pcradio.ru/huahin_tai-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec573",
    like: false,
    name: "Hxodromio Radio",
    url: "https://str.pcradio.ru/hxodromio_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec574",
    like: false,
    name: "I Love 2 Dance",
    url: "https://str.pcradio.ru/i_love_2dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec575",
    like: false,
    name: "I Love Bass!",
    url: "https://str.pcradio.ru/I_love_bass-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec576",
    like: false,
    name: "I Love Bravo Charts",
    url: "https://str.pcradio.ru/i_love_bravchart-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec577",
    like: false,
    name: "I Love Mashup",
    url: "https://str.pcradio.ru/i_love_mash-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec578",
    like: false,
    name: "I Love Radio",
    url: "https://str.pcradio.ru/i_love_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec579",
    like: false,
    name: "I Love Radio and Chill",
    url: "https://str.pcradio.ru/i_love_chill-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec57a",
    like: false,
    name: "I Love The Battle",
    url: "https://str.pcradio.ru/i_love_battle-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec57b",
    like: false,
    name: "IA",
    url: "https://str.pcradio.ru/IA-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec57c",
    like: false,
    name: "Ibiza Global Radio",
    url: "https://str.pcradio.ru/ibiza_global-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec57d",
    like: false,
    name: "Ibiza Radios - Chill",
    url: "https://str.pcradio.ru/ibizara_chill-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec57e",
    like: false,
    name: "Ibiza Radios - Dance",
    url: "https://str.pcradio.ru/ibizara_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec57f",
    like: false,
    name: "Ibiza Radios - Deep-House",
    url: "https://str.pcradio.ru/ibizara_deepho-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec580",
    like: false,
    name: "Ibiza Radios - Funky",
    url: "https://str.pcradio.ru/ibizara_funky-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec581",
    like: false,
    name: "Ibiza Radios - Hits",
    url: "https://str.pcradio.ru/ibizara_hits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec582",
    like: false,
    name: "Ibiza Radios - Relax",
    url: "https://str.pcradio.ru/ibizara_relax-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec583",
    like: false,
    name: "Ibiza Radios - Smooth Jazz",
    url: "https://str.pcradio.ru/ibizara_smooth-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec584",
    like: false,
    name: "ICI Musique",
    url: "https://str.pcradio.ru/ici_musique-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec585",
    like: false,
    name: "ICI Radio-Canada Première (Монреаль)",
    url: "https://str.pcradio.ru/ici_can_montr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec586",
    like: false,
    name: "Idobi Howl",
    url: "https://str.pcradio.ru/idobi_howl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec587",
    like: false,
    name: "Idobi Radio",
    url: "https://str.pcradio.ru/idobi_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec588",
    like: false,
    name: "Imagination",
    url: "https://str.pcradio.ru/imagination_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec589",
    like: false,
    name: "Indie Select",
    url: "https://str.pcradio.ru/indieselect_laut-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec58a",
    like: false,
    name: " EN)",
    url: "https://str.pcradio.ru/ids_media_en-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec58b",
    like: false,
    name: " RU)",
    url: "https://str.pcradio.ru/ids_media_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec58c",
    like: false,
    name: "InfoVojna",
    url: "https://str.pcradio.ru/infovojna_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec58d",
    like: false,
    name: "Insounds",
    url: "https://str.pcradio.ru/insounds_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec58e",
    like: false,
    name: "Instyle",
    url: "https://str.pcradio.ru/instyleradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec58f",
    like: false,
    name: "Intereconomia",
    url: "https://str.pcradio.ru/intereconomia_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec590",
    like: false,
    name: "Interesting Online",
    url: "https://str.pcradio.ru/interesting_online-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec591",
    like: false,
    name: "IP music",
    url: "https://str.pcradio.ru/ipmusic_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec592",
    like: false,
    name: "IP music slow",
    url: "https://str.pcradio.ru/ipmusic_slow-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec593",
    like: false,
    name: "iRadio",
    url: "https://str.pcradio.ru/iradio_pro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec594",
    like: false,
    name: "Irish Pub Radio",
    url: "https://str.pcradio.ru/irish_pub_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec595",
    like: false,
    name: "Italia Dance Music",
    url: "https://str.pcradio.ru/italia_dance_mus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec596",
    like: false,
    name: "Jam FM 93.6",
    url: "https://str.pcradio.ru/jam_fm_936-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec597",
    like: false,
    name: "Jam FM Black Label",
    url: "https://str.pcradio.ru/jam_fm_black-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec598",
    like: false,
    name: "Jam FM New Music",
    url: "https://str.pcradio.ru/jam_fm_newmusic-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec599",
    like: false,
    name: "James Blunt",
    url: "https://str.pcradio.ru/James_Blunt-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec59a",
    like: false,
    name: "Jamiroquai",
    url: "https://str.pcradio.ru/jamiroquai-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec59b",
    like: false,
    name: "Jamm FM",
    url: "https://str.pcradio.ru/jammfmnl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec59c",
    like: false,
    name: "JamZONE - Для Тех Кому Не По",
    url: "https://str.pcradio.ru/jamzone_dtknp-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec59d",
    like: false,
    name: "JamZONE - КАВЕРадио",
    url: "https://str.pcradio.ru/jamzone_cover-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec59e",
    like: false,
    name: "Janko Hraško",
    url: "https://str.pcradio.ru/jankohrasko-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec59f",
    like: false,
    name: "Japan-A-Radio",
    url: "https://str.pcradio.ru/japan_a_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5a0",
    like: false,
    name: "Javan",
    url: "https://str.pcradio.ru/javan_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5a1",
    like: false,
    name: "Jawhara FM",
    url: "https://str.pcradio.ru/jawhara_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5a2",
    like: false,
    name: "Jazz FM (София)",
    url: "https://str.pcradio.ru/jazzfm_bg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5a3",
    like: false,
    name: "Jazzy 90.9",
    url: "https://str.pcradio.ru/jazzy_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5a4",
    like: false,
    name: "Jean Michel Jarre",
    url: "https://str.pcradio.ru/Jean_Michel_Jarre-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5a5",
    like: false,
    name: "Jenny FM",
    url: "https://str.pcradio.ru/jennyfm_org-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5a6",
    like: false,
    name: "Jerry Lee Lewis",
    url: "https://str.pcradio.ru/jerry_lee_lewis-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5a7",
    like: false,
    name: "Jerusalem 101FM",
    url: "https://str.pcradio.ru/jerusalem_101fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5a8",
    like: false,
    name: "Jessica Jay",
    url: "https://str.pcradio.ru/Jessica_Jay-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5a9",
    like: false,
    name: "Jesus a Vida",
    url: "https://str.pcradio.ru/jesusavida_com_br-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5aa",
    like: false,
    name: "JFSR",
    url: "https://str.pcradio.ru/jfsr_co_uk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5ab",
    like: false,
    name: "Jimi Hendrix",
    url: "https://str.pcradio.ru/jimi_hendrix-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5ac",
    like: false,
    name: "Joe Cocker",
    url: "https://str.pcradio.ru/joe_cocker-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5ad",
    like: false,
    name: "Joe Dassin",
    url: "https://str.pcradio.ru/Joe_Dassin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5ae",
    like: false,
    name: "John Lee Hooker",
    url: "https://str.pcradio.ru/John_Lee_Hooker-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5af",
    like: false,
    name: "Johnny Cash",
    url: "https://str.pcradio.ru/Johnny_CASH-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5b0",
    like: false,
    name: "Joint Beat",
    url: "https://str.pcradio.ru/joint_beat-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5b1",
    like: false,
    name: "Joint Blues",
    url: "https://str.pcradio.ru/joint_blues-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5b2",
    like: false,
    name: "Joint Radio",
    url: "https://str.pcradio.ru/joint_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5b3",
    like: false,
    name: "Josh Groban",
    url: "https://str.pcradio.ru/Josh_Groban-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5b4",
    like: false,
    name: "Jovem Pan FM 100.9",
    url: "https://str.pcradio.ru/jovempan_1009-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5b5",
    like: false,
    name: "Jovem Pan News (Сан-Паулу)",
    url: "https://str.pcradio.ru/jpn_sao_paulo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5b6",
    like: false,
    name: "Joy Hits",
    url: "https://str.pcradio.ru/joyhits_online-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5b7",
    like: false,
    name: "Joy Turk FM",
    url: "https://str.pcradio.ru/karnaval_com_joyturk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5b8",
    like: false,
    name: "JP HiP",
    url: "https://str.pcradio.ru/jp_hip-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5b9",
    like: false,
    name: "Judas Priest",
    url: "https://str.pcradio.ru/judas_priest-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5ba",
    like: false,
    name: "Juize",
    url: "https://str.pcradio.ru/juize-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5bb",
    like: false,
    name: "Julie London",
    url: "https://str.pcradio.ru/julie_london-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5bc",
    like: false,
    name: "Jump (MDR)",
    url: "https://str.pcradio.ru/mdr_jump-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5bd",
    like: false,
    name: "Jus Blues",
    url: "https://str.pcradio.ru/jus_blues_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5be",
    like: false,
    name: "Justin Timberlake",
    url: "https://str.pcradio.ru/Justin_Timberlake-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5bf",
    like: false,
    name: "K100",
    url: "https://str.pcradio.ru/k100_mbl_is-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5c0",
    like: false,
    name: "1 FM",
    url: "https://str.pcradio.ru/kalaweit-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5c1",
    like: false,
    name: "Kamchatka Live - Chill",
    url: "https://str.pcradio.ru/kamchatka_chill-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5c2",
    like: false,
    name: "Kamchatka Live - Dance",
    url: "https://str.pcradio.ru/kamchatka_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5c3",
    like: false,
    name: "Kamchatka Live - Rock",
    url: "https://str.pcradio.ru/kamchatka_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5c4",
    like: false,
    name: "Kan 88",
    url: "https://str.pcradio.ru/kan_88-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5c5",
    like: false,
    name: "Kan Arabic",
    url: "https://str.pcradio.ru/kan_arabic-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5c6",
    like: false,
    name: "Kan Kol Hamusica",
    url: "https://str.pcradio.ru/kan_kol_hamusica-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5c7",
    like: false,
    name: "Kan Reka",
    url: "https://str.pcradio.ru/kan_reka-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5c8",
    like: false,
    name: "Kan Reshet Bet",
    url: "https://str.pcradio.ru/kan_reshet_bet-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5c9",
    like: false,
    name: "Kan Reshet Gimel",
    url: "https://str.pcradio.ru/kan_reshet_gimel-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5ca",
    like: false,
    name: "Kan Reshet Moreshet",
    url: "https://str.pcradio.ru/kan_reshet_moreshet-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5cb",
    like: false,
    name: "Kan Tarbut",
    url: "https://str.pcradio.ru/kan_tarbut-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5cc",
    like: false,
    name: "Karc FM",
    url: "https://str.pcradio.ru/karcfm_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5cd",
    like: false,
    name: "Karnaval - Mydonose",
    url: "https://str.pcradio.ru/karnaval_mydonose-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5ce",
    like: false,
    name: "Karunesh",
    url: "https://str.pcradio.ru/karunesh-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5cf",
    like: false,
    name: "Kate Ryan",
    url: "https://str.pcradio.ru/Kate_Ryan-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5d0",
    like: false,
    name: "KaTeK NET",
    url: "https://str.pcradio.ru/katek_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5d1",
    like: false,
    name: "Katy Perry",
    url: "https://str.pcradio.ru/Katy_Perry-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5d2",
    like: false,
    name: "Kaza Fm 18+",
    url: "https://str.pcradio.ru/kaza_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5d3",
    like: false,
    name: "KBC 1602 AM",
    url: "https://str.pcradio.ru/kbc_1602am-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5d4",
    like: false,
    name: "KCSN 88.5 FM",
    url: "https://str.pcradio.ru/kcsn_885_la-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5d5",
    like: false,
    name: "Kelly Clarkson",
    url: "https://str.pcradio.ru/Kelly_Clarkson-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5d6",
    like: false,
    name: "Kerala Radio",
    url: "https://str.pcradio.ru/kerala_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5d7",
    like: false,
    name: "Kesha",
    url: "https://str.pcradio.ru/Kesha-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5d8",
    like: false,
    name: "KEXXX FM Kiev",
    url: "https://str.pcradio.ru/keksfm_kiev-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5d9",
    like: false,
    name: "KEXXX Rocks",
    url: "https://str.pcradio.ru/kexxx_rocks-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5da",
    like: false,
    name: "KFJC",
    url: "https://str.pcradio.ru/kfjc_org-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5db",
    like: false,
    name: "Kick!FM",
    url: "https://str.pcradio.ru/kickfm_eu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5dc",
    like: false,
    name: "Kiel FM 101.2",
    url: "https://str.pcradio.ru/kielfm_1012-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5dd",
    like: false,
    name: "KIF Cool",
    url: "https://str.pcradio.ru/kif_cool-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5de",
    like: false,
    name: "KIF Hits",
    url: "https://str.pcradio.ru/kif_hits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5df",
    like: false,
    name: "KIF Radio",
    url: "https://str.pcradio.ru/kif_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5e0",
    like: false,
    name: "KIF Rock",
    url: "https://str.pcradio.ru/kif_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5e1",
    like: false,
    name: "Kinderlieder",
    url: "https://str.pcradio.ru/kinderlieder_laut-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5e2",
    like: false,
    name: "Kinderradio",
    url: "https://str.pcradio.ru/lautfm_kinderradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5e3",
    like: false,
    name: "King Crimson",
    url: "https://str.pcradio.ru/King_Crimson-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5e4",
    like: false,
    name: "KINK",
    url: "https://str.pcradio.ru/kink_nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5e5",
    like: false,
    name: "Kiss",
    url: "https://str.pcradio.ru/Kiss-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5e6",
    like: false,
    name: "KISS (Осло)",
    url: "https://str.pcradio.ru/kiss_oslo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5e7",
    like: false,
    name: "Kiss (Хельсинки)",
    url: "https://str.pcradio.ru/kiss_fi-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5e8",
    like: false,
    name: "Kiss FM (Бухарест)",
    url: "https://str.pcradio.ru/kissfm_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5e9",
    like: false,
    name: "Kiss FM (Рейкьявик)",
    url: "https://str.pcradio.ru/kissfm_is-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5ea",
    like: false,
    name: "Kiss FM 2.0 Deep",
    url: "https://str.pcradio.ru/kissfm_deep-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5eb",
    like: false,
    name: "Kiss FM 2.0 Digital",
    url: "https://str.pcradio.ru/kissfm_digital-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5ec",
    like: false,
    name: "Kiss FM Australia",
    url: "https://str.pcradio.ru/kissfm_com_au-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec5ef",
    like: false,
    name: "Kiss FM West Coast",
    url: "https://str.pcradio.ru/kissfmwestcoast-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5f0",
    like: false,
    name: "Klassic Joints Radio",
    url: "https://str.pcradio.ru/klassic_joints-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5f1",
    like: false,
    name: "Klassik Radio - Brazil",
    url: "https://str.pcradio.ru/klassikradio_brazil-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5f2",
    like: false,
    name: "Klassik Radio - Chor",
    url: "https://str.pcradio.ru/klassikradio_chor-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5f3",
    like: false,
    name: "Klassik Radio - Friends at Home",
    url: "https://str.pcradio.ru/klassikradio_friends-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5f4",
    like: false,
    name: "Klassik Radio - Klassik Dreams",
    url: "https://str.pcradio.ru/klassikradio_dreams-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5f5",
    like: false,
    name: "Klassik Radio - Klassik Rock",
    url: "https://str.pcradio.ru/klassikradio_klassrock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5f6",
    like: false,
    name: "Klassik Radio - Lounge",
    url: "https://str.pcradio.ru/klassikradio_lounge-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5f7",
    like: false,
    name: "Klassik Radio - Lounge Beat",
    url: "https://str.pcradio.ru/klassikradio_loungebeat-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5f8",
    like: false,
    name: "Klassik Radio - Movie",
    url: "https://str.pcradio.ru/klassikradio_movie-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5f9",
    like: false,
    name: "Klassik Radio - Opera",
    url: "https://str.pcradio.ru/klassikradio_opera-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5fa",
    like: false,
    name: "Klassik Radio - Smooth",
    url: "https://str.pcradio.ru/klassikradio_smooth-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5fb",
    like: false,
    name: "Klassik Radio Live",
    url: "https://str.pcradio.ru/klassikradio_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5fc",
    like: false,
    name: "Klasszik Rádió",
    url: "https://str.pcradio.ru/klasszikradio_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5fd",
    like: false,
    name: "Klubrádió",
    url: "https://str.pcradio.ru/klubradio_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5fe",
    like: false,
    name: "KN Radio",
    url: "https://str.pcradio.ru/knradio_se-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec5ff",
    like: false,
    name: "KNPR News 88.9",
    url: "https://str.pcradio.ru/knpr_889news-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec600",
    like: false,
    name: "Kola 99.9",
    url: "https://str.pcradio.ru/kola_999-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec601",
    like: false,
    name: "Kolor 103 FM",
    url: "https://str.pcradio.ru/radiokolor_pl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec602",
    like: false,
    name: "Kontinental TV",
    url: "https://str.pcradio.ru/kontinental_tv-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec603",
    like: false,
    name: "Korn",
    url: "https://str.pcradio.ru/korn-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec604",
    like: false,
    name: "KORONAfm100",
    url: "https://str.pcradio.ru/koronafm_100-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec605",
    like: false,
    name: "Kosmos FM",
    url: "https://str.pcradio.ru/kosmos_941-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec606",
    like: false,
    name: "Kossuth Radio (MR1)",
    url: "https://str.pcradio.ru/kossuth-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec607",
    like: false,
    name: "Kral Muzik",
    url: "https://str.pcradio.ru/kral_muzik-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec608",
    like: false,
    name: "Kral Pop",
    url: "https://str.pcradio.ru/kral_pop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec609",
    like: false,
    name: "Krec",
    url: "https://str.pcradio.ru/Krec-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec60a",
    like: false,
    name: "Kredens Cafe Radio",
    url: "https://str.pcradio.ru/mjoy_mmmkred-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec60b",
    like: false,
    name: "Kronehit 90's Dance",
    url: "https://str.pcradio.ru/kronehit_90sdance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec60c",
    like: false,
    name: "Kronehit Black",
    url: "https://str.pcradio.ru/kronehit_black-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec60d",
    like: false,
    name: "Kronehit Charts",
    url: "https://str.pcradio.ru/kronehit_charts-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec60e",
    like: false,
    name: "Kronehit Clubland XXL",
    url: "https://str.pcradio.ru/kronehit_clublandxxl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec60f",
    like: false,
    name: "Kronehit Dance",
    url: "https://str.pcradio.ru/kronehit_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec610",
    like: false,
    name: "Kronehit Digital",
    url: "https://str.pcradio.ru/kronehit_digi-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec611",
    like: false,
    name: "Kronehit Electric",
    url: "https://str.pcradio.ru/kronehit_electric-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec612",
    like: false,
    name: "Kronehit Fresh",
    url: "https://str.pcradio.ru/kronehit_fresh-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec613",
    like: false,
    name: "Kronehit German Hip Hop",
    url: "https://str.pcradio.ru/kronehit_ghiphop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec614",
    like: false,
    name: "Kronehit Latino",
    url: "https://str.pcradio.ru/kronehit_latino-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec615",
    like: false,
    name: "Kronehit Love",
    url: "https://str.pcradio.ru/kronehit_love-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec616",
    like: false,
    name: "Kronehit Workout",
    url: "https://str.pcradio.ru/kronehit_workout-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec617",
    like: false,
    name: "KSLU",
    url: "https://str.pcradio.ru/kslu_org-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec618",
    like: false,
    name: "Kulturradio",
    url: "https://str.pcradio.ru/kulturradio_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec619",
    like: false,
    name: "KX Classics",
    url: "https://str.pcradio.ru/kx_classics-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec61a",
    like: false,
    name: "Kylie Minogue",
    url: "https://str.pcradio.ru/Kylie_Minogue-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec61b",
    like: false,
    name: "9",
    url: "https://str.pcradio.ru/lradio_1049-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec61c",
    like: false,
    name: "L1 Radio (Маастрихт)",
    url: "https://str.pcradio.ru/l1radio_maas-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec61d",
    like: false,
    name: "La Única 94.5",
    url: "https://str.pcradio.ru/launica_945-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec61e",
    like: false,
    name: "Lady Gaga",
    url: "https://str.pcradio.ru/Lady_GaGa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec61f",
    like: false,
    name: "Lana Del Rey",
    url: "https://str.pcradio.ru/Lana_Del_rey-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec620",
    like: false,
    name: "Land FM",
    url: "https://str.pcradio.ru/land_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec621",
    like: false,
    name: "LandesWelle Thüringen",
    url: "https://str.pcradio.ru/landeswelle_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec622",
    like: false,
    name: "Lara Fabian",
    url: "https://str.pcradio.ru/Lara_Fabian-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec623",
    like: false,
    name: "Laser Hot Hits Dance International",
    url: "https://str.pcradio.ru/laser_hothits_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec624",
    like: false,
    name: "Laser Hot Hits International - Listen Again",
    url: "https://str.pcradio.ru/laser_hothits_again-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec625",
    like: false,
    name: "Laserbeat-FM",
    url: "https://str.pcradio.ru/laserbeat_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec626",
    like: false,
    name: "Latina 104",
    url: "https://str.pcradio.ru/latina_104-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec627",
    like: false,
    name: "Latvijas Radio 1 (LR1)",
    url: "https://str.pcradio.ru/latvijas_radio1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec628",
    like: false,
    name: "Latvijas Radio 2 (LR2)",
    url: "https://str.pcradio.ru/latvijas_radio2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec629",
    like: false,
    name: "Latvijas Radio 3 (LR3)",
    url: "https://str.pcradio.ru/latvijas_radio3-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec62a",
    like: false,
    name: "Latvijas Radio 4 (LR4)",
    url: "https://str.pcradio.ru/latvijas_radio4-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec62b",
    like: false,
    name: "Lav Radio",
    url: "https://str.pcradio.ru/lav_radio_arm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec62c",
    like: false,
    name: "Lav Radio Mix",
    url: "https://str.pcradio.ru/lav_radio_mix-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec62d",
    like: false,
    name: "LavRadio 106.9 FM",
    url: "https://str.pcradio.ru/lavradio_1069-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec62e",
    like: false,
    name: "Layzer",
    url: "https://str.pcradio.ru/laserradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec62f",
    like: false,
    name: "Laza Rádió",
    url: "https://str.pcradio.ru/lazaradio_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec630",
    like: false,
    name: "Laza Rádió - Mulatós",
    url: "https://str.pcradio.ru/lazaradio_mulatos-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec631",
    like: false,
    name: "LBC London",
    url: "https://str.pcradio.ru/lbc_london-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec632",
    like: false,
    name: "LBC London News 1152",
    url: "https://str.pcradio.ru/lbc_london1152-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec633",
    like: false,
    name: "LBC National (UK)",
    url: "https://str.pcradio.ru/lbc_national-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec634",
    like: false,
    name: "LE Radio",
    url: "https://str.pcradio.ru/leradio_mex-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec635",
    like: false,
    name: "Le Rapologue Radio",
    url: "https://str.pcradio.ru/le_rapologue-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec636",
    like: false,
    name: "Led Zeppelin",
    url: "https://str.pcradio.ru/Led_Zeppelin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec637",
    like: false,
    name: "Legend FM",
    url: "https://str.pcradio.ru/legend_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec638",
    like: false,
    name: "Legend FM - Game Radio",
    url: "https://str.pcradio.ru/legendfm_game-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec639",
    like: false,
    name: "Lei Ting",
    url: "https://str.pcradio.ru/Lei_Ting-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec63a",
    like: false,
    name: "Lelo Hafsaka 103FM",
    url: "https://str.pcradio.ru/lelo_hafsaka-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec63b",
    like: false,
    name: "Leproradio",
    url: "https://str.pcradio.ru/leproradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec63c",
    like: false,
    name: "LernRadio (Der junge Kulturkanal)",
    url: "https://str.pcradio.ru/lern_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec63d",
    like: false,
    name: "Lev Hamedina 91FM",
    url: "https://str.pcradio.ru/lev_hamedina91-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec63e",
    like: false,
    name: "Li Yi Jun",
    url: "https://str.pcradio.ru/Li_Yi_Jun-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec63f",
    like: false,
    name: "Liberland FM",
    url: "https://str.pcradio.ru/liberland_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec640",
    like: false,
    name: "Life Channel",
    url: "https://str.pcradio.ru/lifech_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec641",
    like: false,
    name: "Life Radio",
    url: "https://str.pcradio.ru/liferadio_at-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec642",
    like: false,
    name: "LightBeat Radio",
    url: "https://str.pcradio.ru/light_beat-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec643",
    like: false,
    name: "Like FM 87.9",
    url: "https://str.pcradio.ru/radiolikefm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec644",
    like: false,
    name: "Lily Allen",
    url: "https://str.pcradio.ru/Lily_Allen-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec645",
    like: false,
    name: "Limp Bizkit",
    url: "https://str.pcradio.ru/limp_bizkit-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec646",
    like: false,
    name: "Linea Radio Savona",
    url: "https://str.pcradio.ru/linea_radio_savona-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec647",
    like: false,
    name: "Linkin Park",
    url: "https://str.pcradio.ru/Linkin_Park-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec648",
    like: false,
    name: "LisFm",
    url: "https://str.pcradio.ru/lisfm_net_ua-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec649",
    like: false,
    name: "Lite87",
    url: "https://str.pcradio.ru/lite87_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec64a",
    like: false,
    name: "Little Richard",
    url: "https://str.pcradio.ru/little_richard-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec64b",
    like: false,
    name: "Live from the Mia",
    url: "https://str.pcradio.ru/live_the_mia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec64c",
    like: false,
    name: "Lo Zoo di 105",
    url: "https://str.pcradio.ru/radio105_zoo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec64d",
    like: false,
    name: "Loca FM",
    url: "https://str.pcradio.ru/locafm_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec64e",
    like: false,
    name: "Lojik",
    url: "https://str.pcradio.ru/radyolojik-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec64f",
    like: false,
    name: "London Persian Radio (LPR)",
    url: "https://str.pcradio.ru/londonpersian-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec650",
    like: false,
    name: "Looktung Eingdoi Station",
    url: "https://str.pcradio.ru/looktung_eing-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec651",
    like: false,
    name: "LORA München",
    url: "https://str.pcradio.ru/lora_924-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec652",
    like: false,
    name: "Louis Armstrong",
    url: "https://str.pcradio.ru/Louis_Armstrong-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec653",
    like: false,
    name: "Louna",
    url: "https://str.pcradio.ru/Louna-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec654",
    like: false,
    name: "Lounge Chill 1",
    url: "https://str.pcradio.ru/lounge_chillout-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec655",
    like: false,
    name: "Lounge Chill 2",
    url: "https://str.pcradio.ru/lounge_chillout2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec65a",
    like: false,
    name: "Lounge FM 96",
    url: "https://str.pcradio.ru/loungefm_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec65b",
    like: false,
    name: "Lounge-radio",
    url: "https://str.pcradio.ru/lounge_basel-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec65c",
    like: false,
    name: "LoungeFM",
    url: "https://str.pcradio.ru/lounge_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec65d",
    like: false,
    name: "LoungeFM 100% Austria",
    url: "https://str.pcradio.ru/lounge_fm_100aus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec65e",
    like: false,
    name: "LoungeFM Digital",
    url: "https://str.pcradio.ru/lounge_fm_digi-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec65f",
    like: false,
    name: "Love Is Radio",
    url: "https://str.pcradio.ru/loveis_by-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec660",
    like: false,
    name: "Love Parade",
    url: "https://str.pcradio.ru/love_parade_pcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec661",
    like: false,
    name: "Lovely Music Radio",
    url: "https://str.pcradio.ru/good_music_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec662",
    like: false,
    name: "5 FM",
    url: "https://str.pcradio.ru/lratvakan_1065-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec663",
    like: false,
    name: "LRT Klasika",
    url: "https://str.pcradio.ru/lrt_klasika-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec664",
    like: false,
    name: "LRT Opus",
    url: "https://str.pcradio.ru/lrt_opus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec665",
    like: false,
    name: "LRT Radijas",
    url: "https://str.pcradio.ru/lrt_radijas-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec666",
    like: false,
    name: "LSFM",
    url: "https://str.pcradio.ru/lsfm_moze-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec667",
    like: false,
    name: "LU Radio CILU 102.7 FM",
    url: "https://str.pcradio.ru/luradio_cilu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec668",
    like: false,
    name: "Luciano Pavarotti",
    url: "https://str.pcradio.ru/pavarotti-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec669",
    like: false,
    name: "LugaRadio",
    url: "https://str.pcradio.ru/luga_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec66a",
    like: false,
    name: "Lulu FM",
    url: "https://str.pcradio.ru/lulu_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec66b",
    like: false,
    name: "Lumix FM",
    url: "https://str.pcradio.ru/lumix_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec66c",
    like: false,
    name: "Luxfunk Blackmix",
    url: "https://str.pcradio.ru/luxfunk_blackmix-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec66d",
    like: false,
    name: "Luxfunk Dance",
    url: "https://str.pcradio.ru/luxfunk_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec66e",
    like: false,
    name: "Luxfunk Radió",
    url: "https://str.pcradio.ru/luxfunk_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec66f",
    like: false,
    name: "LXClassics",
    url: "https://str.pcradio.ru/lxclassics_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec670",
    like: false,
    name: "Lübeck FM",
    url: "https://str.pcradio.ru/luebeck_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec671",
    like: false,
    name: "M Radio",
    url: "https://str.pcradio.ru/mradio_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec672",
    like: false,
    name: "Machine Head",
    url: "https://str.pcradio.ru/machine_head-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec673",
    like: false,
    name: "Made In Zouk",
    url: "https://str.pcradio.ru/madeinzouk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec674",
    like: false,
    name: "Madonna",
    url: "https://str.pcradio.ru/Madonna-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec675",
    like: false,
    name: "Magic Disco Radio",
    url: "https://str.pcradio.ru/magic_disco_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec676",
    like: false,
    name: "Magic FM",
    url: "https://str.pcradio.ru/magicfm_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec677",
    like: false,
    name: "Magyar Katolikus Radio",
    url: "https://str.pcradio.ru/magyar_katolikus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec678",
    like: false,
    name: "Maks Radio",
    url: "https://str.pcradio.ru/maksradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec679",
    like: false,
    name: "2",
    url: "https://str.pcradio.ru/malmokanalen_892-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec67a",
    like: false,
    name: "Mancode Radio",
    url: "https://str.pcradio.ru/mancoderadio_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec67b",
    like: false,
    name: "Manowar",
    url: "https://str.pcradio.ru/Manowar-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec67c",
    like: false,
    name: "Mantra",
    url: "https://str.pcradio.ru/radiomantra_eu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec67d",
    like: false,
    name: "Manx Radio FM",
    url: "https://str.pcradio.ru/manxradio_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec67e",
    like: false,
    name: "Maria Rita",
    url: "https://str.pcradio.ru/Maria_Rita-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec67f",
    like: false,
    name: "Marilyn Manson",
    url: "https://str.pcradio.ru/Marilyn_Manson-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec680",
    like: false,
    name: "MariskalRock",
    url: "https://str.pcradio.ru/mariskalrock_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec681",
    like: false,
    name: "Max FM",
    url: "https://str.pcradio.ru/maxfm_com_tr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec682",
    like: false,
    name: "Maxi France",
    url: "https://str.pcradio.ru/maxi_france-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec683",
    like: false,
    name: "Maximum - 90е",
    url: "https://str.pcradio.ru/maximum_90s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec684",
    like: false,
    name: "Maximum - Rock Hits",
    url: "https://str.pcradio.ru/maximum_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec685",
    like: false,
    name: "Maximum 103.7 FM",
    url: "https://str.pcradio.ru/fm_maximum-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec686",
    like: false,
    name: "Maximum 104.3 FM",
    url: "https://str.pcradio.ru/maximum_pzavod-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec687",
    like: false,
    name: "Maximum 98.8 (Томск)",
    url: "https://str.pcradio.ru/maximum_tomsk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec688",
    like: false,
    name: "Maximum Threshold Radio",
    url: "https://str.pcradio.ru/maximum_thresh-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec689",
    like: false,
    name: "Maxxx Radio",
    url: "https://str.pcradio.ru/maxxx_radio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec68a",
    like: false,
    name: "Mazzy Star",
    url: "https://str.pcradio.ru/Mazzy_Star-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec68b",
    like: false,
    name: "MDR 1 Radio Sachsen",
    url: "https://str.pcradio.ru/mdr_1_sachsen-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec68c",
    like: false,
    name: "MDR Aktuell",
    url: "https://str.pcradio.ru/mdr_aktuell-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec68d",
    like: false,
    name: "MDR Figaro",
    url: "https://str.pcradio.ru/mdr_figaro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec68e",
    like: false,
    name: "MDR Klassik",
    url: "https://str.pcradio.ru/mdr_klassik-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec68f",
    like: false,
    name: "MDR Kultur",
    url: "https://str.pcradio.ru/mdr_kultur-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec690",
    like: false,
    name: "MDR Sachsen-Anhalt",
    url: "https://str.pcradio.ru/mdr_sachsen_anhalt-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec691",
    like: false,
    name: "MDR Schlagerwelt Sachsen",
    url: "https://str.pcradio.ru/mdr_schlagerwelt-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec692",
    like: false,
    name: "MDR Sputnik Black",
    url: "https://str.pcradio.ru/mdr_sputnik_black-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec693",
    like: false,
    name: "MDR Sputnik Club",
    url: "https://str.pcradio.ru/mdr_sputnik_club-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec694",
    like: false,
    name: "MDR Sputnik Live",
    url: "https://str.pcradio.ru/mdr_sputnik-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec695",
    like: false,
    name: "MDR Sputnik Popkult",
    url: "https://str.pcradio.ru/mdr_sputnik_popkult-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec696",
    like: false,
    name: "MDR Sputnik Roboton",
    url: "https://str.pcradio.ru/mdr_sputnik_roboton-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec697",
    like: false,
    name: "MDR Sputnik Rock",
    url: "https://str.pcradio.ru/mdr_sputnik_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec698",
    like: false,
    name: "MDR Sputnik Soundcheck",
    url: "https://str.pcradio.ru/mdr_sputnik_soundcheck-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec699",
    like: false,
    name: "MDR Thüringen",
    url: "https://str.pcradio.ru/mdr_thueringen-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec69a",
    like: false,
    name: "Medi 1 Maghreb",
    url: "https://str.pcradio.ru/medi1_maghreb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec69b",
    like: false,
    name: "Mega Hit FM - Classics",
    url: "https://str.pcradio.ru/megahitfm_classics-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec69c",
    like: false,
    name: "MegaDance Rádió",
    url: "https://str.pcradio.ru/megadanceradio_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec69d",
    like: false,
    name: "Megadeth",
    url: "https://str.pcradio.ru/megadeth-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec69e",
    like: false,
    name: "Megapolis FM 89.5",
    url: "https://str.pcradio.ru/megapolisfm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec69f",
    like: false,
    name: "Megaton Cafe Radio",
    url: "https://str.pcradio.ru/megatoncaferadio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6a0",
    like: false,
    name: "Mekke FM",
    url: "https://str.pcradio.ru/mekkefm_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6a1",
    like: false,
    name: "Menzil Radyo",
    url: "https://str.pcradio.ru/menzil_radyo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6a2",
    like: false,
    name: "Mercy Rádió - Kabaré",
    url: "https://str.pcradio.ru/mercyradio_kabare-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6a3",
    like: false,
    name: "Metal Live Radio",
    url: "https://str.pcradio.ru/metal_live_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6a4",
    like: false,
    name: "Metallica",
    url: "https://str.pcradio.ru/Metallica-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6a5",
    like: false,
    name: "MetalMusicRadio",
    url: "https://str.pcradio.ru/metalmusicradio_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6a6",
    like: false,
    name: "Metro FM",
    url: "https://str.pcradio.ru/metro_fm_es-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6a7",
    like: false,
    name: "Metro FM",
    url: "https://str.pcradio.ru/metro_fm_turk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6a8",
    like: false,
    name: "MFM Music Radio",
    url: "https://str.pcradio.ru/mfm_am-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6a9",
    like: false,
    name: "Miami Beach Radio",
    url: "https://str.pcradio.ru/miamibeach_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6aa",
    like: false,
    name: "Miami SoundSets",
    url: "https://str.pcradio.ru/miami_soundsets-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6ab",
    like: false,
    name: "Michael Jackson",
    url: "https://str.pcradio.ru/Michael_Jackson-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6ac",
    like: false,
    name: "Mika",
    url: "https://str.pcradio.ru/Mika-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6ad",
    like: false,
    name: "Mikrasiatis Radio",
    url: "https://str.pcradio.ru/mikrasiatis_gr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6ae",
    like: false,
    name: "Milano XR",
    url: "https://str.pcradio.ru/milano_xr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6af",
    like: false,
    name: "Minimal Techno",
    url: "https://str.pcradio.ru/minimal_techno_pcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6b0",
    like: false,
    name: "Minsk House",
    url: "https://str.pcradio.ru/minsk_house_by-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6b1",
    like: false,
    name: "Mirchi 91.1 (Шиллонг)",
    url: "https://str.pcradio.ru/mirchi_911-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6b2",
    like: false,
    name: "MiRádiónk",
    url: "https://str.pcradio.ru/miradionk_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec6b4",
    like: false,
    name: "Mix FM (Никосия)",
    url: "https://str.pcradio.ru/mixfmradio_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6b5",
    like: false,
    name: "Mix FM (Хабаровск)",
    url: "https://str.pcradio.ru/mixfmonline_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec6b7",
    like: false,
    name: "Mix Megapol",
    url: "https://str.pcradio.ru/mix_megapol-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6b8",
    like: false,
    name: "Mix Party",
    url: "https://str.pcradio.ru/MixParty-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6b9",
    like: false,
    name: "Mixadance Fm",
    url: "https://str.pcradio.ru/mixadance_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6ba",
    like: false,
    name: "Mixadance Jazz",
    url: "https://str.pcradio.ru/mixadance_jazz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6bb",
    like: false,
    name: "MixCult - Main",
    url: "https://str.pcradio.ru/mixcult_main-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6bc",
    like: false,
    name: "MixCult - Spitzer",
    url: "https://str.pcradio.ru/mixcult_spitzer-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6bd",
    like: false,
    name: "MixRadio - Napjaink Slágerei",
    url: "https://str.pcradio.ru/mixradio_slager-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6be",
    like: false,
    name: "MixRadio - Retro Kedvencek",
    url: "https://str.pcradio.ru/mixradio_retro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6bf",
    like: false,
    name: "Mixset",
    url: "https://str.pcradio.ru/mixset_co_uk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6c0",
    like: false,
    name: "Mmirojv Radio",
    url: "https://str.pcradio.ru/mmirojv_bg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6c1",
    like: false,
    name: "Moby",
    url: "https://str.pcradio.ru/Moby-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6c2",
    like: false,
    name: "Modern Talking",
    url: "https://str.pcradio.ru/Modern_Talking-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6c3",
    like: false,
    name: "Momó Rádió",
    url: "https://str.pcradio.ru/momoradio_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6c4",
    like: false,
    name: "Monkey FM",
    url: "https://str.pcradio.ru/monkey_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6c5",
    like: false,
    name: "Monte Carlo Lounge",
    url: "https://str.pcradio.ru/montecarlo_cf-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6c6",
    like: false,
    name: "Morow",
    url: "https://str.pcradio.ru/morow_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6c7",
    like: false,
    name: "Mortal FM",
    url: "https://str.pcradio.ru/mortalfm_es-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6c8",
    like: false,
    name: "Mosaique FM",
    url: "https://str.pcradio.ru/mosaiquefm_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6c9",
    like: false,
    name: "MotoRadio.Online",
    url: "https://str.pcradio.ru/motoradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6ca",
    like: false,
    name: "Motorbreath",
    url: "https://str.pcradio.ru/laut_motorbreath-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6cb",
    like: false,
    name: "Motorhead",
    url: "https://str.pcradio.ru/motorhead-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6cc",
    like: false,
    name: "Motown Magic Oldies",
    url: "https://str.pcradio.ru/motown_magic_oldies-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6cd",
    like: false,
    name: "MousiRadio",
    url: "https://str.pcradio.ru/mousi_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6ce",
    like: false,
    name: "Mousse Radio",
    url: "https://str.pcradio.ru/mjoy_mousse-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6cf",
    like: false,
    name: "Mouv'",
    url: "https://str.pcradio.ru/mouv_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6d0",
    like: false,
    name: "Mr. Credo",
    url: "https://str.pcradio.ru/mr_CREDO-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6d1",
    like: false,
    name: "MT Радио",
    url: "https://str.pcradio.ru/mt_pcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6d2",
    like: false,
    name: "multicult.fm 91.0",
    url: "https://str.pcradio.ru/multicult_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6d3",
    like: false,
    name: "Music In Paradise",
    url: "https://str.pcradio.ru/musicinparadise_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6d4",
    like: false,
    name: "Musical Decadence",
    url: "https://str.pcradio.ru/musicaldecadence_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6d5",
    like: false,
    name: "Muz FM",
    url: "https://str.pcradio.ru/muzfm_md-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6d6",
    like: false,
    name: "MuzON",
    url: "https://str.pcradio.ru/muzon_es-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6d7",
    like: false,
    name: "Mylene Farmer",
    url: "https://str.pcradio.ru/Mylene_Farmer-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6d8",
    like: false,
    name: "myRock",
    url: "https://str.pcradio.ru/myrock_dk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6d9",
    like: false,
    name: "Mária Rádió",
    url: "https://str.pcradio.ru/mariaradio_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6da",
    like: false,
    name: "N-Joy",
    url: "https://str.pcradio.ru/njoy_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6db",
    like: false,
    name: "N-Joy (София)",
    url: "https://str.pcradio.ru/njoy_bg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6dc",
    like: false,
    name: "Nachum Segal Network",
    url: "https://str.pcradio.ru/nachumsegal-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6dd",
    like: false,
    name: "Nami",
    url: "https://str.pcradio.ru/radio_nami-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6de",
    like: false,
    name: "Namie Amuro",
    url: "https://str.pcradio.ru/Namie_Amuro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6df",
    like: false,
    name: "Nancy Sinatra",
    url: "https://str.pcradio.ru/nancy_sinatra-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6e0",
    like: false,
    name: "Napalm Death",
    url: "https://str.pcradio.ru/napalm_death-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6e1",
    like: false,
    name: "Napoca FM 102.2",
    url: "https://str.pcradio.ru/napoca_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6e2",
    like: false,
    name: "Narodni Radio Goga",
    url: "https://str.pcradio.ru/radio_goga_crt-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6e3",
    like: false,
    name: "Navahang",
    url: "https://str.pcradio.ru/navahang_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6e4",
    like: false,
    name: "Nazareth",
    url: "https://str.pcradio.ru/Nazareth-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6e5",
    like: false,
    name: "NDR 1 Niedersachsen",
    url: "https://str.pcradio.ru/ndr_1niedersachsen-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6e6",
    like: false,
    name: "NDR 1 Radio MV",
    url: "https://str.pcradio.ru/ndr_1radio_mv-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6e7",
    like: false,
    name: "NDR 1 Welle Nord",
    url: "https://str.pcradio.ru/ndr_1welle_nord-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6e8",
    like: false,
    name: "NDR 2",
    url: "https://str.pcradio.ru/ndr2_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6e9",
    like: false,
    name: "NDR 90.3",
    url: "https://str.pcradio.ru/ndr_903-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6ea",
    like: false,
    name: "NDR Blue",
    url: "https://str.pcradio.ru/ndr_blue-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6eb",
    like: false,
    name: "NDR Kultur",
    url: "https://str.pcradio.ru/ndr_kultur-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6ec",
    like: false,
    name: "NDR Plus",
    url: "https://str.pcradio.ru/ndr_plus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6ed",
    like: false,
    name: "Nebula",
    url: "https://str.pcradio.ru/nebulaclub_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6ee",
    like: false,
    name: "Nek",
    url: "https://str.pcradio.ru/Nek-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6ef",
    like: false,
    name: "Nelly Furtado",
    url: "https://str.pcradio.ru/Nelly_Furtado-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6f0",
    like: false,
    name: "Nemzetiségi adások (MR4)",
    url: "https://str.pcradio.ru/nemzetisegi_mr4-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6f1",
    like: false,
    name: "New Age Radio",
    url: "https://str.pcradio.ru/newage_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6f2",
    like: false,
    name: "New Clear Radio",
    url: "https://str.pcradio.ru/ncradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6f3",
    like: false,
    name: "New Hits of Bollywood",
    url: "https://str.pcradio.ru/newhits_ofbolly-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6f4",
    like: false,
    name: "New Model Rádio",
    url: "https://str.pcradio.ru/newmodel_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6f5",
    like: false,
    name: "NG Radio Show",
    url: "https://str.pcradio.ru/ngradioshowrussia_org-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6f6",
    like: false,
    name: "Nickelback",
    url: "https://str.pcradio.ru/nickelback-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6f7",
    like: false,
    name: "Niepoprawne Radio PL",
    url: "https://str.pcradio.ru/niepoprawne_pl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6f8",
    like: false,
    name: "Nightwish",
    url: "https://str.pcradio.ru/Nightwish-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6f9",
    like: false,
    name: "Nirvana",
    url: "https://str.pcradio.ru/Nirvana-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6fa",
    like: false,
    name: "Noise FM",
    url: "https://str.pcradio.ru/noisefmru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6fb",
    like: false,
    name: "Noize MC",
    url: "https://str.pcradio.ru/noize_mc-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6fc",
    like: false,
    name: "Nomercy Radio",
    url: "https://str.pcradio.ru/nomercy_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6fd",
    like: false,
    name: "Nonstop Rádio",
    url: "https://str.pcradio.ru/nonstop_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6fe",
    like: false,
    name: "Nordwestradio",
    url: "https://str.pcradio.ru/nordwestradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec6ff",
    like: false,
    name: "Nostalgia FM 98.6",
    url: "https://str.pcradio.ru/nostalgiafm_986-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec700",
    like: false,
    name: "Nostalgie",
    url: "https://str.pcradio.ru/nostalgie_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec701",
    like: false,
    name: "Novo Tempo",
    url: "https://str.pcradio.ru/novo_tempo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec702",
    like: false,
    name: "NPO 3FM Alternative",
    url: "https://str.pcradio.ru/presents3fmnl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec703",
    like: false,
    name: "NPO 3FM KX radio",
    url: "https://str.pcradio.ru/presents3fmnl_stage-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec704",
    like: false,
    name: "NPO 3FM Serious Radio",
    url: "https://str.pcradio.ru/presents3fmnl_pop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec705",
    like: false,
    name: "NPO FunX Amsterdam",
    url: "https://str.pcradio.ru/funxnl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec706",
    like: false,
    name: "NPO FunX Arab",
    url: "https://str.pcradio.ru/npo_funx_arab-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec707",
    like: false,
    name: "NPO FunX Dance",
    url: "https://str.pcradio.ru/npo_funx_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec708",
    like: false,
    name: "NPO FunX Hip Hop",
    url: "https://str.pcradio.ru/npo_funx_hiphop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec709",
    like: false,
    name: "NPO FunX Latin",
    url: "https://str.pcradio.ru/npo_funx_latin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec70a",
    like: false,
    name: "NPO FunX Reggae",
    url: "https://str.pcradio.ru/npo_funx_reggae-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec70b",
    like: false,
    name: "NPO FunX Slow Jamz",
    url: "https://str.pcradio.ru/npo_funx_slowjamz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec70c",
    like: false,
    name: "NPO Radio 1",
    url: "https://str.pcradio.ru/radio1nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec70d",
    like: false,
    name: "NPO Radio 2",
    url: "https://str.pcradio.ru/radio2nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec70e",
    like: false,
    name: "NPO Radio 4",
    url: "https://str.pcradio.ru/radio4nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec70f",
    like: false,
    name: "NPO Radio 5",
    url: "https://str.pcradio.ru/radio5nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec710",
    like: false,
    name: "NPO Radio 6 Soul & Jazz",
    url: "https://str.pcradio.ru/radio6nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec711",
    like: false,
    name: "NRG 95 FM",
    url: "https://str.pcradio.ru/nrg95_gr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec712",
    like: false,
    name: "NRJ (Хельсинки)",
    url: "https://str.pcradio.ru/nrj_finland-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec713",
    like: false,
    name: "NRJ DnB (Таллинн)",
    url: "https://str.pcradio.ru/nrj_ee_dnb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec714",
    like: false,
    name: "NRJ FM (Energy FM)",
    url: "https://str.pcradio.ru/energyfm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec715",
    like: false,
    name: "NRJ FM (Санкт-Петербург)",
    url: "https://str.pcradio.ru/energy_spb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec716",
    like: false,
    name: "NRJ FM (Таллинн)",
    url: "https://str.pcradio.ru/nrj_ee_beat-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec717",
    like: false,
    name: "NRJ France",
    url: "https://str.pcradio.ru/nrj_france-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec718",
    like: false,
    name: "NRJ Hits (France)",
    url: "https://str.pcradio.ru/nrj_fr_hits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec719",
    like: false,
    name: "NRJ Norge",
    url: "https://str.pcradio.ru/nrj_norge-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec71e",
    like: false,
    name: "NRK Alltid Nyheter",
    url: "https://str.pcradio.ru/nrk_alltid-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec71f",
    like: false,
    name: "NRK Klassisk",
    url: "https://str.pcradio.ru/nrk_klassisk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec720",
    like: false,
    name: "NRK mP3",
    url: "https://str.pcradio.ru/nrk_mp3_no-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec721",
    like: false,
    name: "NRK P1 (Осло)",
    url: "https://str.pcradio.ru/nrk_p1_oslo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec722",
    like: false,
    name: "NRK P13",
    url: "https://str.pcradio.ru/nrk_p13-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec723",
    like: false,
    name: "NRK P2",
    url: "https://str.pcradio.ru/nrk_p2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec724",
    like: false,
    name: "NRK P3",
    url: "https://str.pcradio.ru/nrk_p3_no-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec725",
    like: false,
    name: "NRK Sport",
    url: "https://str.pcradio.ru/nrk_sport-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec726",
    like: false,
    name: "NRK Super",
    url: "https://str.pcradio.ru/nrk_super-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec727",
    like: false,
    name: "NSB Radio",
    url: "https://str.pcradio.ru/breakbeatradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec728",
    like: false,
    name: "NTS 1",
    url: "https://str.pcradio.ru/nts1_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec729",
    like: false,
    name: "NTS 2",
    url: "https://str.pcradio.ru/nts2_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec72a",
    like: false,
    name: "Nu Euphoria Trance Radio",
    url: "https://str.pcradio.ru/nu_euphoria-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec72b",
    like: false,
    name: "NUiRADIO (Ну и радио)",
    url: "https://str.pcradio.ru/nuiradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec72c",
    like: false,
    name: "Nuxalk Radio 91.1 FM",
    url: "https://str.pcradio.ru/nuxalk_911-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec72d",
    like: false,
    name: "Oe1 (Österreich 1)",
    url: "https://str.pcradio.ru/oe1_wien-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec72e",
    like: false,
    name: "Oe2 Radio Tirol",
    url: "https://str.pcradio.ru/tirol_orf_at-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec72f",
    like: false,
    name: "Oest FM (Øst FM)",
    url: "https://str.pcradio.ru/oestfm_dk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec730",
    like: false,
    name: "Office Chillout 1",
    url: "https://str.pcradio.ru/office_chillout1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec731",
    like: false,
    name: "Office Chillout 2",
    url: "https://str.pcradio.ru/office_chillout2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec732",
    like: false,
    name: "OK-радио (Калининград)",
    url: "https://str.pcradio.ru/ok_radio_kal-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec733",
    like: false,
    name: "Okerwelle 104.6",
    url: "https://str.pcradio.ru/okerwelle_1046-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec734",
    like: false,
    name: "OkoloJazza",
    url: "https://str.pcradio.ru/okolojazza_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec735",
    like: false,
    name: "Old Fashioned Radio. Show and Music",
    url: "https://str.pcradio.ru/olr_jazz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec736",
    like: false,
    name: "Oldie Welle Niederbayern",
    url: "https://str.pcradio.ru/oldiwelle_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec737",
    like: false,
    name: "OldTime Radio",
    url: "https://str.pcradio.ru/oldtimeradiopcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec738",
    like: false,
    name: "Oldxit (Олдхит)",
    url: "https://str.pcradio.ru/oldxit_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec739",
    like: false,
    name: "Olegator-FM",
    url: "https://str.pcradio.ru/olegator_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec73a",
    like: false,
    name: "Omar Akram",
    url: "https://str.pcradio.ru/Omar-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec73b",
    like: false,
    name: "Omdaru Visual Neoclassical",
    url: "https://str.pcradio.ru/omdaru_visual_neo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec73c",
    like: false,
    name: "Omega",
    url: "https://str.pcradio.ru/omega-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec73d",
    like: false,
    name: "Onda Cero (Мадрид)",
    url: "https://str.pcradio.ru/ondacero_madrid-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec73e",
    like: false,
    name: "Onda Layetana",
    url: "https://str.pcradio.ru/onda_layetana-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec73f",
    like: false,
    name: "Onda Loja Radio",
    url: "https://str.pcradio.ru/onda_loja-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec740",
    like: false,
    name: "Onda Madrid",
    url: "https://str.pcradio.ru/onda_madrid-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec741",
    like: false,
    name: "Onda Vasca",
    url: "https://str.pcradio.ru/onda_vasca-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec742",
    like: false,
    name: "One",
    url: "https://str.pcradio.ru/one_laut-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec743",
    like: false,
    name: "One Direction",
    url: "https://str.pcradio.ru/One_Direction-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec744",
    like: false,
    name: "One FM (Hot FM)",
    url: "https://str.pcradio.ru/onefm_sg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec745",
    like: false,
    name: "One Love Hip Hop Radio",
    url: "https://str.pcradio.ru/oldschool_hiphop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec746",
    like: false,
    name: "One Love Hip-Hop",
    url: "https://str.pcradio.ru/one_hiphop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec747",
    like: false,
    name: "Oomph!",
    url: "https://str.pcradio.ru/oomph-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec748",
    like: false,
    name: "Opera Radio",
    url: "https://str.pcradio.ru/Opera_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec749",
    like: false,
    name: "Orai Sem Cessar",
    url: "https://str.pcradio.ru/orai_sem_ces-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec74a",
    like: false,
    name: "ORF FM 4",
    url: "https://str.pcradio.ru/fm4_orf_at-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec74b",
    like: false,
    name: "ORF Radio Kärnten",
    url: "https://str.pcradio.ru/kaernten_orf_at-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec74c",
    like: false,
    name: "ORF Radio Steiermark",
    url: "https://str.pcradio.ru/orf_steiermark-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec74d",
    like: false,
    name: "ORF Radio Vorarlberg",
    url: "https://str.pcradio.ru/orf_vorarlberg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec74e",
    like: false,
    name: "ORF Wien",
    url: "https://str.pcradio.ru/orf_wien-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec74f",
    like: false,
    name: "Orgasma",
    url: "https://str.pcradio.ru/orgasma_main-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec750",
    like: false,
    name: "Orgasma Black",
    url: "https://str.pcradio.ru/orgasma_black-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec751",
    like: false,
    name: "Orgasma Late",
    url: "https://str.pcradio.ru/orgasma_late-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec752",
    like: false,
    name: "Origa",
    url: "https://str.pcradio.ru/Origa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec753",
    like: false,
    name: "Ostseewelle Hit-Radio",
    url: "https://str.pcradio.ru/ostseewelle_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec754",
    like: false,
    name: "Our Neighborhood Radio",
    url: "https://str.pcradio.ru/our_neighbor-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec755",
    like: false,
    name: "OZFM",
    url: "https://str.pcradio.ru/ozfm_ca-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec756",
    like: false,
    name: "Ozzy Osbourne",
    url: "https://str.pcradio.ru/ozzy_osbourne-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec757",
    like: false,
    name: "P10 Country",
    url: "https://str.pcradio.ru/p10_country-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec758",
    like: false,
    name: "P11 Bandit",
    url: "https://str.pcradio.ru/bandit_no-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec759",
    like: false,
    name: "P3 Star",
    url: "https://str.pcradio.ru/p3_star-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec75a",
    like: false,
    name: "P4 Norge",
    url: "https://str.pcradio.ru/p4_norge-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec75b",
    like: false,
    name: "P5 Hits Bergen",
    url: "https://str.pcradio.ru/p5_bergen-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec75c",
    like: false,
    name: "P5 Hits Oslo",
    url: "https://str.pcradio.ru/p5_oslo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec75d",
    like: false,
    name: "P5 Nonstop Hits",
    url: "https://str.pcradio.ru/p5_nonstop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec75e",
    like: false,
    name: "P6 Rock",
    url: "https://str.pcradio.ru/p6_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec75f",
    like: false,
    name: "P7 Klem",
    url: "https://str.pcradio.ru/p7_klem-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec760",
    like: false,
    name: "P8 Pop",
    url: "https://str.pcradio.ru/p8_pop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec761",
    like: false,
    name: "P9 Retro",
    url: "https://str.pcradio.ru/p9_retro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec762",
    like: false,
    name: "Paco de Lucia",
    url: "https://str.pcradio.ru/Paco_de_Lucia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec763",
    like: false,
    name: "Pain",
    url: "https://str.pcradio.ru/Pain-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec764",
    like: false,
    name: "Pal FM",
    url: "https://str.pcradio.ru/pal_fm_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec765",
    like: false,
    name: "Pal Nostalji",
    url: "https://str.pcradio.ru/pal_nostalji-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec766",
    like: false,
    name: "Pal Orient",
    url: "https://str.pcradio.ru/pal_orient-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec767",
    like: false,
    name: "Pamplona Colombia Radio",
    url: "https://str.pcradio.ru/pamplona_colombia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec768",
    like: false,
    name: "Pannon Rádió",
    url: "https://str.pcradio.ru/pannon_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec769",
    like: false,
    name: "Panoramix Radio Station",
    url: "https://str.pcradio.ru/panoramix-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec76a",
    like: false,
    name: "Panradio",
    url: "https://str.pcradio.ru/panradio_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec76b",
    like: false,
    name: "Pantera",
    url: "https://str.pcradio.ru/Pantera-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec76c",
    like: false,
    name: "Paprika Rádió 95.1 FM",
    url: "https://str.pcradio.ru/paprika_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec76d",
    like: false,
    name: "Papua Radio",
    url: "https://str.pcradio.ru/PapuaRadio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec76e",
    like: false,
    name: "Paradise FM 103.1 (Curaçao)",
    url: "https://str.pcradio.ru/paradise_1031-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec76f",
    like: false,
    name: "Paranoia Web",
    url: "https://str.pcradio.ru/paranoiaweb_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec770",
    like: false,
    name: "Parlamenti radio (MR5)",
    url: "https://str.pcradio.ru/parlamenti_radio_mr5-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec771",
    like: false,
    name: "Parov Stelar",
    url: "https://str.pcradio.ru/parov_stelar-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec772",
    like: false,
    name: "Party Dance Radio",
    url: "https://str.pcradio.ru/partydance_vip-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec773",
    like: false,
    name: "Party Hit Radio",
    url: "https://str.pcradio.ru/party_hit_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec774",
    like: false,
    name: "Party Maker",
    url: "https://str.pcradio.ru/party_maker_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec775",
    like: false,
    name: "Party Vibe Breakbeat - HipHop",
    url: "https://str.pcradio.ru/partyvibe_break-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec776",
    like: false,
    name: "Party Vibe DnB - Jungle",
    url: "https://str.pcradio.ru/partyvibe_dnb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec777",
    like: false,
    name: "Party Vibe Dubstep - Breakbeat",
    url: "https://str.pcradio.ru/partyvibe_dub-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec778",
    like: false,
    name: "Party Vibe Pop - Indie",
    url: "https://str.pcradio.ru/partyvibe_pop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec779",
    like: false,
    name: "Party Vibe Psy Trance - Goa",
    url: "https://str.pcradio.ru/partyvibe_trance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec77a",
    like: false,
    name: "Party Vibe Rap - HipHop",
    url: "https://str.pcradio.ru/partyvibe_rap-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec77b",
    like: false,
    name: "Party Vibe Reggae - Roots",
    url: "https://str.pcradio.ru/partyvibe_reggae-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec77c",
    like: false,
    name: "Party Vibe Relax",
    url: "https://str.pcradio.ru/partyvibe_ambient-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec77d",
    like: false,
    name: "Party Vibe Rock - Country",
    url: "https://str.pcradio.ru/partyvibe_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec77e",
    like: false,
    name: "Party Vibe Techno - House",
    url: "https://str.pcradio.ru/partyvibe_techno-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec77f",
    like: false,
    name: "Party107",
    url: "https://str.pcradio.ru/party_107-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec780",
    like: false,
    name: "Partyradio24",
    url: "https://str.pcradio.ru/partyradio24_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec781",
    like: false,
    name: "Patricia Kaas",
    url: "https://str.pcradio.ru/Patricia_Kaas-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec782",
    like: false,
    name: "Paul in Rio Radio",
    url: "https://str.pcradio.ru/paul_in_rio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec783",
    like: false,
    name: "Paul Mauriat",
    url: "https://str.pcradio.ru/paul_mauriat-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec784",
    like: false,
    name: "Peli One FM",
    url: "https://str.pcradio.ru/pelione_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec785",
    like: false,
    name: "Pendulum",
    url: "https://str.pcradio.ru/Pendulum-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec786",
    like: false,
    name: "Peng Li Yuan",
    url: "https://str.pcradio.ru/Peng_Li_Yuan-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec787",
    like: false,
    name: "Perfectune FM",
    url: "https://str.pcradio.ru/perfectune_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec788",
    like: false,
    name: "Pesti Kabaré",
    url: "https://str.pcradio.ru/pesti_kabare-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec789",
    like: false,
    name: "Pet Shop Boys",
    url: "https://str.pcradio.ru/pet_shop_boys-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec78a",
    like: false,
    name: "Petofi Radio (MR2)",
    url: "https://str.pcradio.ru/petofi-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec78b",
    like: false,
    name: "Phil Collins",
    url: "https://str.pcradio.ru/phil_collins-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec78c",
    like: false,
    name: "Piano Relax Radio",
    url: "https://str.pcradio.ru/piano_relax_radio_pcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec78d",
    like: false,
    name: "Piano радио",
    url: "https://str.pcradio.ru/piano_radio_pcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec78e",
    like: false,
    name: "Pik 100",
    url: "https://str.pcradio.ru/pik100-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec78f",
    like: false,
    name: "Pilot FM",
    url: "https://str.pcradio.ru/pilotfm_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec790",
    like: false,
    name: "Pink Floyd",
    url: "https://str.pcradio.ru/Pink_Floyd-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec791",
    like: false,
    name: "Pioneer DJ",
    url: "https://str.pcradio.ru/pioneer_dj_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec792",
    like: false,
    name: "Pirate Gong",
    url: "https://str.pcradio.ru/pirate_gong-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec793",
    like: false,
    name: "Placebo",
    url: "https://str.pcradio.ru/placebo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec794",
    like: false,
    name: "Planet Hip Hop (MRG.fm)",
    url: "https://str.pcradio.ru/mrg_planethip-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec795",
    like: false,
    name: "Planet Radio",
    url: "https://str.pcradio.ru/planet_radio_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec796",
    like: false,
    name: "Planet Rock",
    url: "https://str.pcradio.ru/planet_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec797",
    like: false,
    name: "Planetfrequency Radio",
    url: "https://str.pcradio.ru/planetfreq_us-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec798",
    like: false,
    name: "Play Radio Romania",
    url: "https://str.pcradio.ru/playradio_org-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec799",
    like: false,
    name: "Play Star FM",
    url: "https://str.pcradio.ru/play_star_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec79a",
    like: false,
    name: "Plazma",
    url: "https://str.pcradio.ru/plazma-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec79b",
    like: false,
    name: "Plusz FM",
    url: "https://str.pcradio.ru/pluszfm_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec79c",
    like: false,
    name: "PMR",
    url: "https://str.pcradio.ru/pmr_lt-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec79d",
    like: false,
    name: "PN Eins Dance",
    url: "https://str.pcradio.ru/pneins_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec79e",
    like: false,
    name: "PN Eins Urban",
    url: "https://str.pcradio.ru/pneins_urban-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec79f",
    like: false,
    name: "Point Blank FM",
    url: "https://str.pcradio.ru/pointblank_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7a0",
    like: false,
    name: "6 FM",
    url: "https://str.pcradio.ru/polis1026-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7a1",
    like: false,
    name: "Polskie Radio - Radio Dla Ciebie (RDC)",
    url: "https://str.pcradio.ru/rdc_pl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7a2",
    like: false,
    name: "Polskie radio 1 - Jedynka",
    url: "https://str.pcradio.ru/polskie_1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7a3",
    like: false,
    name: "Polskie radio 2 - Dwójka",
    url: "https://str.pcradio.ru/polskie_2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7a4",
    like: false,
    name: "Polskie radio 24",
    url: "https://str.pcradio.ru/polskie_24-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7a5",
    like: false,
    name: "Polskie radio 3 - Trójka",
    url: "https://str.pcradio.ru/polskie_3-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7a6",
    like: false,
    name: "Polskie radio 4 - Czwórka",
    url: "https://str.pcradio.ru/polskie_4-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7a7",
    like: false,
    name: "Polygon.FM",
    url: "https://str.pcradio.ru/polygon_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7a8",
    like: false,
    name: "PonyvilleFM PVFM Free!",
    url: "https://str.pcradio.ru/pvfm_3-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7a9",
    like: false,
    name: "PonyvilleFM PVFM One",
    url: "https://str.pcradio.ru/pvfm_one-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7aa",
    like: false,
    name: "PonyvilleFM PVFM Two",
    url: "https://str.pcradio.ru/pvfm_2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7ab",
    like: false,
    name: "Pop Club",
    url: "https://str.pcradio.ru/Pop_Club-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7ac",
    like: false,
    name: "PopCanRadio",
    url: "https://str.pcradio.ru/popcanradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7ad",
    like: false,
    name: "Popradio Ostfriesland",
    url: "https://str.pcradio.ru/popradio_ost-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7ae",
    like: false,
    name: "Poptarisznya",
    url: "https://str.pcradio.ru/poptarisznya_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7af",
    like: false,
    name: "Positiva Mix",
    url: "https://str.pcradio.ru/positiva_mix-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7b0",
    like: false,
    name: "Positive House",
    url: "https://str.pcradio.ru/positivehouse_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7b1",
    like: false,
    name: "Power Dance",
    url: "https://str.pcradio.ru/power_dance_tr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec7b4",
    like: false,
    name: "Power Hit Radio (Вильнюс)",
    url: "https://str.pcradio.ru/powerhit_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7b5",
    like: false,
    name: "Power Hit Radio (Таллинн)",
    url: "https://str.pcradio.ru/pwr_hit_ee-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7b6",
    like: false,
    name: "Power Pop",
    url: "https://str.pcradio.ru/power_pop_tr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7b7",
    like: false,
    name: "Power Radio",
    url: "https://str.pcradio.ru/powerradio_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7b8",
    like: false,
    name: "Power Turk FM",
    url: "https://str.pcradio.ru/power_turk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7b9",
    like: false,
    name: "Power Хит Радио (Мурманск)",
    url: "https://str.pcradio.ru/power1045-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7ba",
    like: false,
    name: "Powerhitz - Hip Hop",
    url: "https://str.pcradio.ru/powerhitz_hiphop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7bb",
    like: false,
    name: "PRG Radio",
    url: "https://str.pcradio.ru/prgradio_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7bc",
    like: false,
    name: "Primaton",
    url: "https://str.pcradio.ru/primaton_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7bd",
    like: false,
    name: "Primavera24",
    url: "https://str.pcradio.ru/primavera24-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7be",
    like: false,
    name: "ProFM",
    url: "https://str.pcradio.ru/profm_ro_main-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7bf",
    like: false,
    name: "Prog Rock and Metal (PRM)",
    url: "https://str.pcradio.ru/progrock_metal-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7c0",
    like: false,
    name: "Progressive by Psylvain",
    url: "https://str.pcradio.ru/progr_psyl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7c1",
    like: false,
    name: "Progressive FM",
    url: "https://str.pcradio.ru/progressive_fm_pcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7c2",
    like: false,
    name: "Promo DJ - 186mph",
    url: "https://str.pcradio.ru/promo_186mph-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7c3",
    like: false,
    name: "Promo DJ - 300 kmh",
    url: "https://str.pcradio.ru/promo_300kmh-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7c4",
    like: false,
    name: "Promo DJ - Channel 5",
    url: "https://str.pcradio.ru/promo_channel5-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7c5",
    like: false,
    name: "Promo DJ - Deep",
    url: "https://str.pcradio.ru/promo_deep-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7c6",
    like: false,
    name: "Promo DJ - Full Moon",
    url: "https://str.pcradio.ru/promo_full_moon-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7c7",
    like: false,
    name: "Promo DJ - Mini",
    url: "https://str.pcradio.ru/promo_mini-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7c8",
    like: false,
    name: "Promo DJ - Nu",
    url: "https://str.pcradio.ru/promo_nu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7c9",
    like: false,
    name: "Promo DJ - Old-School",
    url: "https://str.pcradio.ru/promo_old_school-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7ca",
    like: false,
    name: "Promo DJ - Pop",
    url: "https://str.pcradio.ru/promo_pop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7cb",
    like: false,
    name: "Promo DJ - Strange",
    url: "https://str.pcradio.ru/promo_strange-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7cc",
    like: false,
    name: "Promo DJ - Too Deep",
    url: "https://str.pcradio.ru/promo_too_deep-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7cd",
    like: false,
    name: "Promo DJ - Too Nu",
    url: "https://str.pcradio.ru/promo_too_nu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7ce",
    like: false,
    name: "Promo DJ - Top 100",
    url: "https://str.pcradio.ru/promo_top100-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7cf",
    like: false,
    name: "Promo DJ - Vata",
    url: "https://str.pcradio.ru/promo_vata-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7d0",
    like: false,
    name: "Promo DJ - Yo",
    url: "https://str.pcradio.ru/promo_yo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7d1",
    like: false,
    name: "Promo DJ - Dubstep",
    url: "https://str.pcradio.ru/promo_dubstep-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7d2",
    like: false,
    name: "Promo DJ - Klubb",
    url: "https://str.pcradio.ru/promo_klubb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7d3",
    like: false,
    name: "Proton Radio",
    url: "https://str.pcradio.ru/protonradio_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7d4",
    like: false,
    name: "Psy Chill Zone",
    url: "https://str.pcradio.ru/psychillout_zone-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7d5",
    like: false,
    name: "PsyRadio Alternative",
    url: "https://str.pcradio.ru/psyradio_fm_altern-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7d6",
    like: false,
    name: "PsyRadio Chillout",
    url: "https://str.pcradio.ru/psyradio_fm_chill-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7d7",
    like: false,
    name: "PsyRadio Progressive",
    url: "https://str.pcradio.ru/psyradio_fm_progr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7d8",
    like: false,
    name: "PsyRadio PsyTrance",
    url: "https://str.pcradio.ru/psyradio_fm_ptran-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7d9",
    like: false,
    name: "PsyStation Classic Goa Psy Trance",
    url: "https://str.pcradio.ru/psystation_classicgoa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7da",
    like: false,
    name: "PsyStation Dark Root Psy Trance",
    url: "https://str.pcradio.ru/psystation_darkroot-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7db",
    like: false,
    name: "Puls (BR)",
    url: "https://str.pcradio.ru/puls_br-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7dc",
    like: false,
    name: "Pulse 87",
    url: "https://str.pcradio.ru/pulse_87-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7dd",
    like: false,
    name: "PulseEDM Dance Music Radio",
    url: "https://str.pcradio.ru/pulse_edm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7de",
    like: false,
    name: "PulsRadio 80s",
    url: "https://str.pcradio.ru/pulsradio_80s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7df",
    like: false,
    name: "PulsRadio 90s",
    url: "https://str.pcradio.ru/pulsradio_90s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7e0",
    like: false,
    name: "PulsRadio Club",
    url: "https://str.pcradio.ru/pulsradio_club-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7e1",
    like: false,
    name: "PulsRadio Dance",
    url: "https://str.pcradio.ru/puls_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7e2",
    like: false,
    name: "PulsRadio Hits",
    url: "https://str.pcradio.ru/pulsradio_hits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7e3",
    like: false,
    name: "PulsRadio Lounge",
    url: "https://str.pcradio.ru/pulsradio_lounge-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7e4",
    like: false,
    name: "PulsRadio Trance",
    url: "https://str.pcradio.ru/pulsradio_trance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec7e6",
    like: false,
    name: "Punkrockers-Radio",
    url: "https://str.pcradio.ru/punkrockers_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7e7",
    like: false,
    name: "Pure 24",
    url: "https://str.pcradio.ru/pure24_nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7e8",
    like: false,
    name: "Pure FM (Сейшелы)",
    url: "https://str.pcradio.ru/purefm_sc-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7e9",
    like: false,
    name: "Pure FM - Berlins Dance Radio",
    url: "https://str.pcradio.ru/purefm_bdr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7ea",
    like: false,
    name: "Pure Radio",
    url: "https://str.pcradio.ru/pureradio_one-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7eb",
    like: false,
    name: "Push FM",
    url: "https://str.pcradio.ru/laut_pushfm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7ec",
    like: false,
    name: "Qfm 94.3 (Тенерифе)",
    url: "https://str.pcradio.ru/qfm943-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7ed",
    like: false,
    name: "Qmusic",
    url: "https://str.pcradio.ru/gmusic_nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7ee",
    like: false,
    name: "Qmusic Nonstop",
    url: "https://str.pcradio.ru/qmusic_nonstop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7ef",
    like: false,
    name: "Queen",
    url: "https://str.pcradio.ru/Queen-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7f0",
    like: false,
    name: "Querfunk",
    url: "https://str.pcradio.ru/querfunk_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7f1",
    like: false,
    name: "Quran Live Radio",
    url: "https://str.pcradio.ru/quran_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7f2",
    like: false,
    name: "R.E.M.",
    url: "https://str.pcradio.ru/R_E_M-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7f3",
    like: false,
    name: "R.SA - Maxis Maximal",
    url: "https://str.pcradio.ru/rsa_maxis-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7f4",
    like: false,
    name: "R.SA Ostrock",
    url: "https://str.pcradio.ru/rsa_ostrock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7f5",
    like: false,
    name: "R.SA Sachsen",
    url: "https://str.pcradio.ru/rsa_sachsen-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7f6",
    like: false,
    name: "RAC105",
    url: "https://str.pcradio.ru/rac105_barc-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7f7",
    like: false,
    name: "Radijas TAU 102.9 FM",
    url: "https://str.pcradio.ru/tau_lt-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7f8",
    like: false,
    name: "Radio 1 FM 93.6",
    url: "https://str.pcradio.ru/radio1_936-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7f9",
    like: false,
    name: "Radio 10",
    url: "https://str.pcradio.ru/radio10goldnl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7fa",
    like: false,
    name: "Radio 100",
    url: "https://str.pcradio.ru/radio100-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7fb",
    like: false,
    name: "Radio 105",
    url: "https://str.pcradio.ru/radio105_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7fc",
    like: false,
    name: "Radio 105 Classics",
    url: "https://str.pcradio.ru/radio105_classics-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7fd",
    like: false,
    name: "Radio 105 Hip Hop and RnB",
    url: "https://str.pcradio.ru/radio105_hiprnb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7fe",
    like: false,
    name: "Radio 105 Hits",
    url: "https://str.pcradio.ru/radio105_hits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec7ff",
    like: false,
    name: "Radio 105 InDaKlubb",
    url: "https://str.pcradio.ru/radio105_indaklubb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec800",
    like: false,
    name: "Radio 105 Miami",
    url: "https://str.pcradio.ru/radio105_miami-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec801",
    like: false,
    name: "Radio 105 Trap",
    url: "https://str.pcradio.ru/radio105_trap-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec802",
    like: false,
    name: "Radio 13",
    url: "https://str.pcradio.ru/radio13_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec803",
    like: false,
    name: "Radio 21 (Rock 'n Pop)",
    url: "https://str.pcradio.ru/radio21_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec804",
    like: false,
    name: "Radio 24 (Цюрих)",
    url: "https://str.pcradio.ru/radio24_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec805",
    like: false,
    name: "Radio 24 - Il Sole 24 ore",
    url: "https://str.pcradio.ru/radio24_ilsole-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec806",
    like: false,
    name: "Radio 2Day",
    url: "https://str.pcradio.ru/radio2_day-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec807",
    like: false,
    name: "Radio 32",
    url: "https://str.pcradio.ru/radio32_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec808",
    like: false,
    name: "Radio 32 - Goldies",
    url: "https://str.pcradio.ru/radio32_goldies-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec809",
    like: false,
    name: "Radio 32 - Hits",
    url: "https://str.pcradio.ru/radio32_hits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec80a",
    like: false,
    name: "Radio 32 - Rock",
    url: "https://str.pcradio.ru/radio32_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec80b",
    like: false,
    name: "Radio 32 - Schlager",
    url: "https://str.pcradio.ru/radio32_schlag-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec80c",
    like: false,
    name: "Radio 412",
    url: "https://str.pcradio.ru/radio_412-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec80d",
    like: false,
    name: "Radio 538",
    url: "https://str.pcradio.ru/RADIO538_nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec80e",
    like: false,
    name: "Radio 538 Hitzone",
    url: "https://str.pcradio.ru/radio538_hitzone-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec80f",
    like: false,
    name: "Radio 538 Nonstop",
    url: "https://str.pcradio.ru/radio538_nonstop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec810",
    like: false,
    name: "Radio 538 Party",
    url: "https://str.pcradio.ru/radio538_party-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec811",
    like: false,
    name: "Radio 538 Top 40",
    url: "https://str.pcradio.ru/radio538_top40-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec812",
    like: false,
    name: "Radio 7 (Ульм)",
    url: "https://str.pcradio.ru/radio7_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec813",
    like: false,
    name: "Radio 7 90er",
    url: "https://str.pcradio.ru/radio7_de_90er-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec814",
    like: false,
    name: "Radio 7 MixShow",
    url: "https://str.pcradio.ru/radio7_de_mixshow-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec815",
    like: false,
    name: "Radio 8",
    url: "https://str.pcradio.ru/radio8_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec816",
    like: false,
    name: "Radio 886",
    url: "https://str.pcradio.ru/radio_886-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec817",
    like: false,
    name: "Radio 90vier",
    url: "https://str.pcradio.ru/radio90vier-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec818",
    like: false,
    name: "Radio ABC",
    url: "https://str.pcradio.ru/radioabc_dk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec819",
    like: false,
    name: "Radio Afsana",
    url: "https://str.pcradio.ru/afsana_ca-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec81a",
    like: false,
    name: "Radio AGORA 105.5",
    url: "https://str.pcradio.ru/agora_at-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec81b",
    like: false,
    name: "Radio Aktiv 106.5",
    url: "https://str.pcradio.ru/aktiv_1065-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec81c",
    like: false,
    name: "Radio Albena",
    url: "https://str.pcradio.ru/albena_md-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec81d",
    like: false,
    name: "Radio ALR",
    url: "https://str.pcradio.ru/alr_radio_dk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec81e",
    like: false,
    name: "Radio AM 750",
    url: "https://str.pcradio.ru/am750_arg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec81f",
    like: false,
    name: "Radio America Latina",
    url: "https://str.pcradio.ru/america_latina-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec820",
    like: false,
    name: "Radio Ankerherz",
    url: "https://str.pcradio.ru/anker_herz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec821",
    like: false,
    name: "Radio Aquarius",
    url: "https://str.pcradio.ru/aquarius_gr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec822",
    like: false,
    name: "Radio ARA",
    url: "https://str.pcradio.ru/ara_lu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec823",
    like: false,
    name: "Radio Arev",
    url: "https://str.pcradio.ru/radio_arev-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec824",
    like: false,
    name: "Radio Argovia",
    url: "https://str.pcradio.ru/argovia_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec825",
    like: false,
    name: "Radio Armenie",
    url: "https://str.pcradio.ru/radioarmenie_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec826",
    like: false,
    name: "Radio Art - Meditation",
    url: "https://str.pcradio.ru/art_radio_meditation-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec827",
    like: false,
    name: "Radio Art - Solo Flute",
    url: "https://str.pcradio.ru/art_radio_soloflute-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec828",
    like: false,
    name: "Radio Art - Solo Harp",
    url: "https://str.pcradio.ru/art_radio_soloharp-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec829",
    like: false,
    name: "Radio Aurora",
    url: "https://str.pcradio.ru/radioaurora_am-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec82a",
    like: false,
    name: "Radio AWN",
    url: "https://str.pcradio.ru/awn_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec82b",
    like: false,
    name: "Radio B2 (Берлин)",
    url: "https://str.pcradio.ru/radiob2_berlin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec82c",
    like: false,
    name: "Radio B2 SchlagerMixx",
    url: "https://str.pcradio.ru/radiob2_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec82d",
    like: false,
    name: "Radio Bamberg",
    url: "https://str.pcradio.ru/bamberg_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec82e",
    like: false,
    name: "Radio Bavaria International",
    url: "https://str.pcradio.ru/bavaria_international-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec82f",
    like: false,
    name: "Radio Beat",
    url: "https://str.pcradio.ru/beat_isr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec830",
    like: false,
    name: "Radio Best FM (Братислава)",
    url: "https://str.pcradio.ru/bestfm_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec831",
    like: false,
    name: "Radio Beta",
    url: "https://str.pcradio.ru/beta_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec832",
    like: false,
    name: "Radio Beta - Hity 80's a 90's",
    url: "https://str.pcradio.ru/beta_8090-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec833",
    like: false,
    name: "Radio Beta - Hráme Jubilantom",
    url: "https://str.pcradio.ru/beta_jubilantom-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec834",
    like: false,
    name: "Radio BOB!",
    url: "https://str.pcradio.ru/radiobob_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec835",
    like: false,
    name: "Radio Bob! Deutschrock",
    url: "https://str.pcradio.ru/radiobob_deurock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec836",
    like: false,
    name: "Radio BOB! Rockabilly",
    url: "https://str.pcradio.ru/radiobob_de_rockabil-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec837",
    like: false,
    name: "Radio Bochum 98.5 FM",
    url: "https://str.pcradio.ru/radiobochum_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec838",
    like: false,
    name: "Radio Bonn/Rhein-Sieg",
    url: "https://str.pcradio.ru/bonn_rheinsieg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec839",
    like: false,
    name: "Radio Brocken",
    url: "https://str.pcradio.ru/brocken_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec83a",
    like: false,
    name: "Radio Caba",
    url: "https://str.pcradio.ru/caba_urug-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec83b",
    like: false,
    name: "Radio Cafe",
    url: "https://str.pcradio.ru/radio_cafe-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec83c",
    like: false,
    name: "Radio Caprice - Classical Choral / Vocal",
    url: "https://str.pcradio.ru/caprice_claschoral-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec83d",
    like: false,
    name: "Radio Caprice - Classical Crossover",
    url: "https://str.pcradio.ru/caprice_classcross-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec83e",
    like: false,
    name: "Radio Caprice - Drum and Bass",
    url: "https://str.pcradio.ru/caprice_dnb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec83f",
    like: false,
    name: "Radio Caprice - Melodic Black Metal",
    url: "https://str.pcradio.ru/caprice_mbm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec840",
    like: false,
    name: "Radio Caprice - Minimal Techno",
    url: "https://str.pcradio.ru/caprice_minitech-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec841",
    like: false,
    name: "Radio Caprice - Neoclassical Metal",
    url: "https://str.pcradio.ru/caprice_neoclmetal-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec842",
    like: false,
    name: "Radio Caprice - Neoclassical music",
    url: "https://str.pcradio.ru/caprice_neoclass-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec843",
    like: false,
    name: "Radio Caprice - Power Metal",
    url: "https://str.pcradio.ru/caprice_powermetal-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec844",
    like: false,
    name: "Radio Caprice - Rock Ballads",
    url: "https://str.pcradio.ru/caprice_rock_ballads-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec845",
    like: false,
    name: "Radio Caprice - Ska-Punk / Core",
    url: "https://str.pcradio.ru/caprice_skapunk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec846",
    like: false,
    name: "Radio Caprice - Spacesynth - Synthdance",
    url: "https://str.pcradio.ru/radcap_spacesynth-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec847",
    like: false,
    name: "Radio Caprice - Uplifiting Trance",
    url: "https://str.pcradio.ru/caprice_uplift_trance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec848",
    like: false,
    name: "Radio Caprice - Witch House",
    url: "https://str.pcradio.ru/caprice_witchhouse-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec849",
    like: false,
    name: "Radio Caprice - Русский Панк Рок",
    url: "https://str.pcradio.ru/caprice_ruspunk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec84a",
    like: false,
    name: "Radio Caprice - Русский Постшансон",
    url: "https://str.pcradio.ru/caprice_postshans-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec84b",
    like: false,
    name: "Radio Caprice - Русский шансон",
    url: "https://str.pcradio.ru/caprice_russhans-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec84c",
    like: false,
    name: "Radio Caprice - Dark Psytrance",
    url: "https://str.pcradio.ru/caprice_darkpsy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec84d",
    like: false,
    name: "Radio Caprice - NeuroFunk/TechnoID",
    url: "https://str.pcradio.ru/caprice_neurofunk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec84e",
    like: false,
    name: "Radio Caprice - Русская народная",
    url: "https://str.pcradio.ru/caprice_rusfolk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec84f",
    like: false,
    name: "Radio Caprice - Русский рэп",
    url: "https://str.pcradio.ru/caprice_rusrap-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec850",
    like: false,
    name: "Radio Caroline",
    url: "https://str.pcradio.ru/caroline_co_uk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec851",
    like: false,
    name: "Radio Caroline (Рен)",
    url: "https://str.pcradio.ru/caroline_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec852",
    like: false,
    name: "Radio Caroline Flashback",
    url: "https://str.pcradio.ru/caroline_co_flash-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec853",
    like: false,
    name: "Radio Católica Mundial EWTN",
    url: "https://str.pcradio.ru/catolica_mundial-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec854",
    like: false,
    name: "Radio CBN (Сан-Паулу)",
    url: "https://str.pcradio.ru/cbnnoticias-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec855",
    like: false,
    name: "Radio Central",
    url: "https://str.pcradio.ru/radiocentral_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec856",
    like: false,
    name: "Radio Charivari",
    url: "https://str.pcradio.ru/charivari_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec857",
    like: false,
    name: "Radio Charivari (Вюрцбург)",
    url: "https://str.pcradio.ru/charivari_wurzburg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec858",
    like: false,
    name: "Radio Charivari (Регенсбург)",
    url: "https://str.pcradio.ru/charivari_regens-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec859",
    like: false,
    name: "Radio Cinco - Rádio Nacional de Angola",
    url: "https://str.pcradio.ru/radio5_nac_angola-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec85a",
    like: false,
    name: "Radio City",
    url: "https://str.pcradio.ru/radiocity_fi-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec85b",
    like: false,
    name: "Radio City Freedom",
    url: "https://str.pcradio.ru/radiocity_freedom-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec85c",
    like: false,
    name: "Radio City Hindi",
    url: "https://str.pcradio.ru/radiocity_hindy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec85d",
    like: false,
    name: "Radio Clasic Beethoven",
    url: "https://str.pcradio.ru/clasic_ro_beethoven-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec85e",
    like: false,
    name: "Radio Clasic Hits",
    url: "https://str.pcradio.ru/clasic_ro_hits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec85f",
    like: false,
    name: "Radio Clasic Jazz",
    url: "https://str.pcradio.ru/clasic_ro_jazz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec860",
    like: false,
    name: "Radio Clasic Kids",
    url: "https://str.pcradio.ru/clasic_ro_kids-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec861",
    like: false,
    name: "Radio Clasic Live",
    url: "https://str.pcradio.ru/clasic_ro_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec862",
    like: false,
    name: "Radio Clasic Mozart",
    url: "https://str.pcradio.ru/clasic_ro_mozart-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec863",
    like: false,
    name: "Radio Clasic Opera",
    url: "https://str.pcradio.ru/clasic_ro_opera-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec864",
    like: false,
    name: "Radio Clasic Popular",
    url: "https://str.pcradio.ru/clasic_ro_popular-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec865",
    like: false,
    name: "Radio Clasic Strauss",
    url: "https://str.pcradio.ru/clasic_ro_strauss-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec866",
    like: false,
    name: "Radio Classique",
    url: "https://str.pcradio.ru/classique_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec867",
    like: false,
    name: "Radio Contact Ostbelgien",
    url: "https://str.pcradio.ru/contact_ostbelgien-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec868",
    like: false,
    name: "Radio Country Acadienne",
    url: "https://str.pcradio.ru/country_acadienne-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec869",
    like: false,
    name: "Radio Country Live",
    url: "https://str.pcradio.ru/country_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec86a",
    like: false,
    name: "Radio de Fe Panamá",
    url: "https://str.pcradio.ru/defe_panama-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec86b",
    like: false,
    name: "Radio Dechovka",
    url: "https://str.pcradio.ru/dechovka_cz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec86c",
    like: false,
    name: "Radio Decibel",
    url: "https://str.pcradio.ru/decibel_nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec86d",
    like: false,
    name: "Radio Diva FM",
    url: "https://str.pcradio.ru/radio_diva_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec86e",
    like: false,
    name: "Radio DJ Shmagi",
    url: "https://str.pcradio.ru/dj_shmagi-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec86f",
    like: false,
    name: "Radio Dresden",
    url: "https://str.pcradio.ru/radiodresden_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec870",
    like: false,
    name: "Radio Dresden - 80er Kulthits",
    url: "https://str.pcradio.ru/radiodresden_80-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec871",
    like: false,
    name: "Radio Dresden - 90er XXL",
    url: "https://str.pcradio.ru/radiodresden_90-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec872",
    like: false,
    name: "Radio Dreyeckland (RDL)",
    url: "https://str.pcradio.ru/dreyeckland_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec873",
    like: false,
    name: "Radio Dreyeckland (Мюлуз)",
    url: "https://str.pcradio.ru/dreyeckland_mulh-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec874",
    like: false,
    name: "Radio Driland",
    url: "https://str.pcradio.ru/drilland_laut-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec875",
    like: false,
    name: "Radio E",
    url: "https://str.pcradio.ru/radioe_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec877",
    like: false,
    name: "Radio Eins",
    url: "https://str.pcradio.ru/radioeins_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec878",
    like: false,
    name: "Radio Elmar",
    url: "https://str.pcradio.ru/elmar_ee-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec879",
    like: false,
    name: "Radio Energy (София)",
    url: "https://str.pcradio.ru/nrj_bg_sofia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec87a",
    like: false,
    name: "Radio Enno 100.4",
    url: "https://str.pcradio.ru/enno_1004-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec87b",
    like: false,
    name: "Radio Essential",
    url: "https://str.pcradio.ru/radioessential-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec87c",
    like: false,
    name: "Radio Euroherz",
    url: "https://str.pcradio.ru/euroherz_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec87e",
    like: false,
    name: "Radio Eviva",
    url: "https://str.pcradio.ru/eviva_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec87f",
    like: false,
    name: "Radio F 94.5",
    url: "https://str.pcradio.ru/radiof_945-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec881",
    like: false,
    name: "Radio F 94.5 - Made in Germany",
    url: "https://str.pcradio.ru/radiof_945_mig-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec882",
    like: false,
    name: "Radio Fama",
    url: "https://str.pcradio.ru/radiofama_am-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec883",
    like: false,
    name: "Radio Farda",
    url: "https://str.pcradio.ru/farda_ir-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec884",
    like: false,
    name: "Radio ffn",
    url: "https://str.pcradio.ru/ffn_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec885",
    like: false,
    name: "Radio ffn Comedy",
    url: "https://str.pcradio.ru/ffn_comedy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec886",
    like: false,
    name: "Radio ffn Peppermint FM",
    url: "https://str.pcradio.ru/ffn_pepper-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec887",
    like: false,
    name: "Radio FG",
    url: "https://str.pcradio.ru/radiofg_main-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec888",
    like: false,
    name: "Radio FG Belgique",
    url: "https://str.pcradio.ru/radiofg_belgique-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec889",
    like: false,
    name: "Radio FG Chic",
    url: "https://str.pcradio.ru/radiofg_chic-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec88a",
    like: false,
    name: "Radio FG Clubbing",
    url: "https://str.pcradio.ru/radiofg_club-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec88b",
    like: false,
    name: "Radio FG Deep Dance",
    url: "https://str.pcradio.ru/radiofg_deepdance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec88c",
    like: false,
    name: "Radio FG Gay Party",
    url: "https://str.pcradio.ru/radiofg_gay-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec88d",
    like: false,
    name: "Radio FG Non Stop",
    url: "https://str.pcradio.ru/radiofg_nonstop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec88e",
    like: false,
    name: "Radio FG Underground",
    url: "https://str.pcradio.ru/radiofg_ug-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec88f",
    like: false,
    name: "Radio Focus",
    url: "https://str.pcradio.ru/focus_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec890",
    like: false,
    name: "Radio Fresh80s",
    url: "https://str.pcradio.ru/fresh80s_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec891",
    like: false,
    name: "Radio Galaxy Bayern",
    url: "https://str.pcradio.ru/galaxy_bayern-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec892",
    like: false,
    name: "Radio Galilée",
    url: "https://str.pcradio.ru/galilee_canada-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec893",
    like: false,
    name: "Radio Gege",
    url: "https://str.pcradio.ru/radio_gege_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec894",
    like: false,
    name: "Radio Gege",
    url: "https://str.pcradio.ru/radiogege-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec895",
    like: false,
    name: "Radio Gibraltar",
    url: "https://str.pcradio.ru/gbc_gi-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec896",
    like: false,
    name: "Radio Gibraltar Plus",
    url: "https://str.pcradio.ru/gbc_gi_plus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec897",
    like: false,
    name: "Radio Gloria",
    url: "https://str.pcradio.ru/radiogloria_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec898",
    like: false,
    name: "Radio Gold - Real Classics",
    url: "https://str.pcradio.ru/radiogold_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec899",
    like: false,
    name: "9 FM (Бухарест)",
    url: "https://str.pcradio.ru/gold_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec89a",
    like: false,
    name: "Radio Gong 106.9",
    url: "https://str.pcradio.ru/gong_1069-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec89b",
    like: false,
    name: "Radio Gong 97.1",
    url: "https://str.pcradio.ru/gong_971-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec89c",
    like: false,
    name: "Radio Haifa 107.5",
    url: "https://str.pcradio.ru/radiohaifa_1075-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec89d",
    like: false,
    name: "Radio Halmstad 88.6",
    url: "https://str.pcradio.ru/halmstad_se-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec89e",
    like: false,
    name: "Radio Hamburg 2",
    url: "https://str.pcradio.ru/radiohamburg2_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec89f",
    like: false,
    name: "Radio HCJB",
    url: "https://str.pcradio.ru/hcjb_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8a0",
    like: false,
    name: "Radio Holiday",
    url: "https://str.pcradio.ru/holiday_it-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8a1",
    like: false,
    name: "Radio Ice",
    url: "https://str.pcradio.ru/radioice_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8a2",
    like: false,
    name: "Radio IN",
    url: "https://str.pcradio.ru/radio_in-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec8a6",
    like: false,
    name: "Radio Italy Live",
    url: "https://str.pcradio.ru/italy_live_ny-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8a7",
    like: false,
    name: "Radio Jahani (WRN)",
    url: "https://str.pcradio.ru/jahani_wrn-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8a8",
    like: false,
    name: "Radio Jan 90.7 FM",
    url: "https://str.pcradio.ru/radio_jan_907-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8a9",
    like: false,
    name: "Radio Kol Rega 96 FM",
    url: "https://str.pcradio.ru/kol_rega_96fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8aa",
    like: false,
    name: "Radio Kroměříž",
    url: "https://str.pcradio.ru/kromeriz_cz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8ab",
    like: false,
    name: "Radio Laser 95.9 FM",
    url: "https://str.pcradio.ru/laser_959-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8ac",
    like: false,
    name: "Radio Leipzig - 90er XXL",
    url: "https://str.pcradio.ru/leipzig_90xxl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8ad",
    like: false,
    name: "Radio Liberté",
    url: "https://str.pcradio.ru/liberte_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8ae",
    like: false,
    name: "Radio Love Live",
    url: "https://str.pcradio.ru/love_live_ny-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8af",
    like: false,
    name: "Radio Lübeck",
    url: "https://str.pcradio.ru/radioluebeck_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8b0",
    like: false,
    name: "Radio Ma Va Shoma",
    url: "https://str.pcradio.ru/ma_va_shoma-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8b1",
    like: false,
    name: "Radio Mainwelle",
    url: "https://str.pcradio.ru/mainwelle_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8b2",
    like: false,
    name: "Radio Marca (Барселона)",
    url: "https://str.pcradio.ru/radiomarcabarcelona-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8b3",
    like: false,
    name: "Radio Margherita",
    url: "https://str.pcradio.ru/margherita_ita-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8b4",
    like: false,
    name: "Radio Maria Österreich",
    url: "https://str.pcradio.ru/maria_at-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8b5",
    like: false,
    name: "Radio Marshall 103.5",
    url: "https://str.pcradio.ru/marshall_am-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8b6",
    like: false,
    name: "Radio Maryja",
    url: "https://str.pcradio.ru/maryja_pl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8b7",
    like: false,
    name: "Radio Mediaș 725",
    url: "https://str.pcradio.ru/medias_725-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8b8",
    like: false,
    name: "Radio Mega-HIT Romania",
    url: "https://str.pcradio.ru/megahit_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8b9",
    like: false,
    name: "Radio Metal",
    url: "https://str.pcradio.ru/radiometal_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8ba",
    like: false,
    name: "Radio Metro 102.4",
    url: "https://str.pcradio.ru/metro_1024-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8bb",
    like: false,
    name: "Radio Metropolitana FM (Сан-Паулу)",
    url: "https://str.pcradio.ru/metropolitana-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8bc",
    like: false,
    name: "Radio Mihan",
    url: "https://str.pcradio.ru/mihan_tv-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8bd",
    like: false,
    name: "Radio Mirchi 98.3 FM",
    url: "https://str.pcradio.ru/mirchi_983-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8be",
    like: false,
    name: "Radio Monte Carlo FM",
    url: "https://str.pcradio.ru/rmc_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8bf",
    like: false,
    name: "Radio MRS",
    url: "https://str.pcradio.ru/radiomrs_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8c0",
    like: false,
    name: "Radio Muzika",
    url: "https://str.pcradio.ru/muzika_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8c1",
    like: false,
    name: "Radio Mágica 87.7",
    url: "https://str.pcradio.ru/magica_877-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8c2",
    like: false,
    name: "Radio Mélodie",
    url: "https://str.pcradio.ru/melodie_sarreg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8c3",
    like: false,
    name: "Radio Namkin",
    url: "https://str.pcradio.ru/namkin_boly-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8c4",
    like: false,
    name: "Radio Natale",
    url: "https://str.pcradio.ru/natale_it-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8c5",
    like: false,
    name: "Radio Neue Hoffnung",
    url: "https://str.pcradio.ru/rnh_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8c6",
    like: false,
    name: "Radio Neunkirchen",
    url: "https://str.pcradio.ru/neunkirchen_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8c7",
    like: false,
    name: "Radio New York Live",
    url: "https://str.pcradio.ru/newyork_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8c8",
    like: false,
    name: "Radio New Zealand National",
    url: "https://str.pcradio.ru/rnz_co_national-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8c9",
    like: false,
    name: "Radio Niederösterreich (ORF NOE)",
    url: "https://str.pcradio.ru/noe_orf-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8ca",
    like: false,
    name: "Radio Noise Romania",
    url: "https://str.pcradio.ru/radionoise_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8cb",
    like: false,
    name: "Radio Nord",
    url: "https://str.pcradio.ru/nord_dk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8cc",
    like: false,
    name: "Radio Nordsee International",
    url: "https://str.pcradio.ru/nordsee_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8cd",
    like: false,
    name: "Radio Nordseewelle",
    url: "https://str.pcradio.ru/nordseewelle_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8ce",
    like: false,
    name: "Radio North Pole",
    url: "https://str.pcradio.ru/northpole_ala-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8cf",
    like: false,
    name: "Radio Northsea International",
    url: "https://str.pcradio.ru/north_sea-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8d0",
    like: false,
    name: "Radio Nova (Хельсинки)",
    url: "https://str.pcradio.ru/nova_helsinki-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8d1",
    like: false,
    name: "Radio Nova CR",
    url: "https://str.pcradio.ru/novacr_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8d2",
    like: false,
    name: "Radio Oberösterreich - ORF Oö",
    url: "https://str.pcradio.ru/ooe_orf_at-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8d3",
    like: false,
    name: "Radio OKJ 103.4",
    url: "https://str.pcradio.ru/okj_1034-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8d4",
    like: false,
    name: "Radio OM Activ",
    url: "https://str.pcradio.ru/om_activ-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8d5",
    like: false,
    name: "Radio One 103.9 FM (Curaçao)",
    url: "https://str.pcradio.ru/one_1039curacao-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8d6",
    like: false,
    name: "Radio Oranje",
    url: "https://str.pcradio.ru/radiooranjenl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8d7",
    like: false,
    name: "Radio Paloma",
    url: "https://str.pcradio.ru/radiopaloma_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8d8",
    like: false,
    name: "Radio Paradise",
    url: "https://str.pcradio.ru/radioparadise_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8d9",
    like: false,
    name: "Radio Plassenburg",
    url: "https://str.pcradio.ru/plassenburg_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8da",
    like: false,
    name: "Radio Pokoj",
    url: "https://str.pcradio.ru/pokoj_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8db",
    like: false,
    name: "Radio Poland",
    url: "https://str.pcradio.ru/radio_poland-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8dc",
    like: false,
    name: "Radio Portugal USA",
    url: "https://str.pcradio.ru/portugal_usa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8dd",
    like: false,
    name: "Radio Pro Manele",
    url: "https://str.pcradio.ru/pro_manele-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8de",
    like: false,
    name: "Radio Provincia 1270 AM",
    url: "https://str.pcradio.ru/provincia_1270-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8df",
    like: false,
    name: "Radio PSR",
    url: "https://str.pcradio.ru/radiopsr_de_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8e0",
    like: false,
    name: "Radio Ramasuri",
    url: "https://str.pcradio.ru/ramasuri_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8e1",
    like: false,
    name: "Radio Ran",
    url: "https://str.pcradio.ru/radioran_co_il-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8e2",
    like: false,
    name: "Radio Record (Римини)",
    url: "https://str.pcradio.ru/record_rimini-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8e3",
    like: false,
    name: "Radio Regent",
    url: "https://str.pcradio.ru/radioregent_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8e4",
    like: false,
    name: "Radio Rennes 100.8 FM",
    url: "https://str.pcradio.ru/rennes_1008-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8e5",
    like: false,
    name: "Radio Rheinwelle 92.5 FM",
    url: "https://str.pcradio.ru/rheinwelle_925-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8e6",
    like: false,
    name: "Radio Riel - Ragtime",
    url: "https://str.pcradio.ru/radioriel_ragtime-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8e7",
    like: false,
    name: "Radio Rock On",
    url: "https://str.pcradio.ru/rock_on_la-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8e8",
    like: false,
    name: "Radio ROKS",
    url: "https://str.pcradio.ru/radioroks_ua-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec8ee",
    like: false,
    name: "Radio Romania Actualitati",
    url: "https://str.pcradio.ru/rom_actualitati-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8ef",
    like: false,
    name: "Radio Romania Brașov FM",
    url: "https://str.pcradio.ru/romania_brasov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8f0",
    like: false,
    name: "Radio Romania Constanta",
    url: "https://str.pcradio.ru/romania_constanta-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8f1",
    like: false,
    name: "Radio Romania International 1",
    url: "https://str.pcradio.ru/rri_1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8f2",
    like: false,
    name: "Radio Romania Oltenia",
    url: "https://str.pcradio.ru/romania_oltenia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8f3",
    like: false,
    name: "Radio Romania Timisoara",
    url: "https://str.pcradio.ru/timisoara_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8f4",
    like: false,
    name: "Radio Romania Târgu Mures",
    url: "https://str.pcradio.ru/romania_targu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8f5",
    like: false,
    name: "Radio Saarschleifenland (RSL)",
    url: "https://str.pcradio.ru/rsl_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8f6",
    like: false,
    name: "Radio Salobreña",
    url: "https://str.pcradio.ru/salobrena_gra-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8f7",
    like: false,
    name: "Radio Salü",
    url: "https://str.pcradio.ru/salue_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8f8",
    like: false,
    name: "Radio Salü Kulthits",
    url: "https://str.pcradio.ru/salue_kulthits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8f9",
    like: false,
    name: "Radio Santa Claus",
    url: "https://str.pcradio.ru/santa_claus_fin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8fa",
    like: false,
    name: "Radio Santa Cruz 960 AM",
    url: "https://str.pcradio.ru/santacruz_irfa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8fb",
    like: false,
    name: "Radio Santec (на английском)",
    url: "https://str.pcradio.ru/santec_english-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8fc",
    like: false,
    name: "Radio Santec (на немецком)",
    url: "https://str.pcradio.ru/santec_deutsch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8fd",
    like: false,
    name: "Radio Santiago AM 690",
    url: "https://str.pcradio.ru/santiago_am690-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8fe",
    like: false,
    name: "Radio SAW",
    url: "https://str.pcradio.ru/radiosaw_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec8ff",
    like: false,
    name: "Radio Schleswig-Holstein",
    url: "https://str.pcradio.ru/rsh_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec900",
    like: false,
    name: "Radio Seagull",
    url: "https://str.pcradio.ru/seagull_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec901",
    like: false,
    name: "Radio Seefunk RSF",
    url: "https://str.pcradio.ru/seefunk_rsf-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec902",
    like: false,
    name: "Radio Senti Chi Parla",
    url: "https://str.pcradio.ru/senti_chi_parla-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec903",
    like: false,
    name: "Radio Sfera Music",
    url: "https://str.pcradio.ru/sfera_music-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec904",
    like: false,
    name: "Radio Shadowbox",
    url: "https://str.pcradio.ru/shadowbox_cz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec905",
    like: false,
    name: "Radio Sharda 90.4 FM",
    url: "https://str.pcradio.ru/sharda_904-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec906",
    like: false,
    name: "Radio Skovoroda Live",
    url: "https://str.pcradio.ru/skovoroda_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec907",
    like: false,
    name: "Radio Skovoroda Music",
    url: "https://str.pcradio.ru/skovoroda_music-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec908",
    like: false,
    name: "Radio Slavic Family",
    url: "https://str.pcradio.ru/slavic_family-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec909",
    like: false,
    name: "Radio Sotenäs 95.3",
    url: "https://str.pcradio.ru/sotenas_953-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec90a",
    like: false,
    name: "Radio StHoerfunk",
    url: "https://str.pcradio.ru/st_hoerfunk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec90b",
    like: false,
    name: "Radio Studio 1",
    url: "https://str.pcradio.ru/studio_1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec90c",
    like: false,
    name: "Radio Sucesos 101.7",
    url: "https://str.pcradio.ru/sucessos_1017-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec90d",
    like: false,
    name: "Radio Suomipop",
    url: "https://str.pcradio.ru/suomi_pop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec90e",
    like: false,
    name: "Radio Symphony",
    url: "https://str.pcradio.ru/symphony_ny-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec90f",
    like: false,
    name: "Radio TBB",
    url: "https://str.pcradio.ru/radio_tbb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec910",
    like: false,
    name: "Radio Teddy",
    url: "https://str.pcradio.ru/radioteddy_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec911",
    like: false,
    name: "Radio Tell",
    url: "https://str.pcradio.ru/radiotell_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec912",
    like: false,
    name: "Radio The Big Boss",
    url: "https://str.pcradio.ru/the_big_boss_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec913",
    like: false,
    name: "Radio Titine",
    url: "https://str.pcradio.ru/radiotitine-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec914",
    like: false,
    name: "Radio Ton",
    url: "https://str.pcradio.ru/radioton_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec915",
    like: false,
    name: "Radio Top",
    url: "https://str.pcradio.ru/toponline_ch1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec916",
    like: false,
    name: "Radio Top 40 - Charts",
    url: "https://str.pcradio.ru/radiotop40_de_charts-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec917",
    like: false,
    name: "Radio Top 40 - Club Sound",
    url: "https://str.pcradio.ru/radiotop40_de_club-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec918",
    like: false,
    name: "Radio Top 40 - Urban",
    url: "https://str.pcradio.ru/radiotop40_de_urban-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec919",
    like: false,
    name: "Radio Top 40 Live",
    url: "https://str.pcradio.ru/radiotop40_de_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec91a",
    like: false,
    name: "Radio Top Two",
    url: "https://str.pcradio.ru/toponline_ch2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec91b",
    like: false,
    name: "Radio Trausnitz",
    url: "https://str.pcradio.ru/trausnitz_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec91c",
    like: false,
    name: "Radio Treby 87.8 FM",
    url: "https://str.pcradio.ru/treby_se-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec91d",
    like: false,
    name: "Radio Tunisie360",
    url: "https://str.pcradio.ru/tunisie360-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec91e",
    like: false,
    name: "Radio Univers",
    url: "https://str.pcradio.ru/univers_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec91f",
    like: false,
    name: "Radio Van",
    url: "https://str.pcradio.ru/radiovan_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec920",
    like: false,
    name: "Radio Veronica",
    url: "https://str.pcradio.ru/radioveronicanl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec921",
    like: false,
    name: "Radio Vintage",
    url: "https://str.pcradio.ru/radiovintage_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec922",
    like: false,
    name: "Radio Vitez",
    url: "https://str.pcradio.ru/vitez_ba-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec923",
    like: false,
    name: "Radio Vostok",
    url: "https://str.pcradio.ru/vostok_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec924",
    like: false,
    name: "Radio Vətən",
    url: "https://str.pcradio.ru/radioveten_ml-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec925",
    like: false,
    name: "Radio Wanderlust",
    url: "https://str.pcradio.ru/wanderlust-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec926",
    like: false,
    name: "Radio Western CHRW 94.9 FM",
    url: "https://str.pcradio.ru/western_chrw-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec927",
    like: false,
    name: "Radio WNET",
    url: "https://str.pcradio.ru/radiownet_pl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec928",
    like: false,
    name: "Radio WSW",
    url: "https://str.pcradio.ru/radiowsw_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec929",
    like: false,
    name: "Radio X London",
    url: "https://str.pcradio.ru/radio_x_london-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec92a",
    like: false,
    name: "Radio Yan - Armenian",
    url: "https://str.pcradio.ru/radioyan_armenian-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec92b",
    like: false,
    name: "Radio Yan - Patriotic",
    url: "https://str.pcradio.ru/radioyan_patriot-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec92c",
    like: false,
    name: "Radio Yeraz",
    url: "https://str.pcradio.ru/yeraz_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec92d",
    like: false,
    name: "Radio Z 95.8",
    url: "https://str.pcradio.ru/radioz_958-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec92e",
    like: false,
    name: "Radio ZET",
    url: "https://str.pcradio.ru/radiozet_pl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec92f",
    like: false,
    name: "Radio Zeta",
    url: "https://str.pcradio.ru/zeta_it-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec930",
    like: false,
    name: "Radio Zum 93.3 FM",
    url: "https://str.pcradio.ru/radiozum_933-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec931",
    like: false,
    name: "Radio Évasion",
    url: "https://str.pcradio.ru/evasion_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec932",
    like: false,
    name: "Radio Ö24 Wien",
    url: "https://str.pcradio.ru/oe24_wien-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec933",
    like: false,
    name: "Radio-Exclusiv",
    url: "https://str.pcradio.ru/exclusiv_laut-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec934",
    like: false,
    name: "Radio-M1",
    url: "https://str.pcradio.ru/radio_m1_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec935",
    like: false,
    name: "Radio-Nice",
    url: "https://str.pcradio.ru/radio_nice_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec936",
    like: false,
    name: "Radio-Nice Dance Music",
    url: "https://str.pcradio.ru/nice_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec937",
    like: false,
    name: "Radio-Nice Deep Progressive",
    url: "https://str.pcradio.ru/nice_deepprog-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec938",
    like: false,
    name: "RadioActive Rock",
    url: "https://str.pcradio.ru/rarock_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec939",
    like: false,
    name: "RadioAktiv",
    url: "https://str.pcradio.ru/radioaktiv_org-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec93a",
    like: false,
    name: "8",
    url: "https://str.pcradio.ru/berlin_888-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec93b",
    like: false,
    name: "Radioeins (RBB)",
    url: "https://str.pcradio.ru/radioeins-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec93c",
    like: false,
    name: "RadioEx",
    url: "https://str.pcradio.ru/radioex_in_ua-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec93d",
    like: false,
    name: "Radiofabrik 107.5 (Зальцбург)",
    url: "https://str.pcradio.ru/radiofabrik_1075-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec93e",
    like: false,
    name: "Radiogora Electro",
    url: "https://str.pcradio.ru/radiogora_electro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec93f",
    like: false,
    name: "RadioHBR",
    url: "https://str.pcradio.ru/hbr_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec940",
    like: false,
    name: "Radiohead",
    url: "https://str.pcradio.ru/radiohead-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec941",
    like: false,
    name: "Radiolife",
    url: "https://str.pcradio.ru/radiolife_su-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec942",
    like: false,
    name: "Radiolla",
    url: "https://str.pcradio.ru/radiolla_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec943",
    like: false,
    name: "RadioParty - Kanał Główny",
    url: "https://str.pcradio.ru/party_glowny-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec944",
    like: false,
    name: "3)",
    url: "https://str.pcradio.ru/belgorod_883-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec945",
    like: false,
    name: "RadioRock",
    url: "https://str.pcradio.ru/radiorock_fi-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec946",
    like: false,
    name: "Radiosai Bhajan",
    url: "https://str.pcradio.ru/radiosai_bhajan-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec947",
    like: false,
    name: "RadioStar Five",
    url: "https://str.pcradio.ru/radio_star5-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec948",
    like: false,
    name: "RadioSunna",
    url: "https://str.pcradio.ru/radiosunna-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec949",
    like: false,
    name: "RadioVideoMusic",
    url: "https://str.pcradio.ru/videomusic_info-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec94a",
    like: false,
    name: "radiOzora - Chill",
    url: "https://str.pcradio.ru/radiozora_chill-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec94b",
    like: false,
    name: "radiOzora - Trance",
    url: "https://str.pcradio.ru/radiozora_trance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec94c",
    like: false,
    name: "Radius 100FM",
    url: "https://str.pcradio.ru/radius_100fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec94d",
    like: false,
    name: "Raduga 100.8 FM",
    url: "https://str.pcradio.ru/raduga_lt-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec94e",
    like: false,
    name: "Radyo Mevlana",
    url: "https://str.pcradio.ru/radyo_mevlana-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec94f",
    like: false,
    name: "Radyo Viva",
    url: "https://str.pcradio.ru/radyo_viva-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec950",
    like: false,
    name: "Raggakings",
    url: "https://str.pcradio.ru/raggakings-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec951",
    like: false,
    name: "RAI 1",
    url: "https://str.pcradio.ru/rai1_it-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec952",
    like: false,
    name: "RAI 2",
    url: "https://str.pcradio.ru/rai2_it-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec953",
    like: false,
    name: "RAI 3",
    url: "https://str.pcradio.ru/rai3_it-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec954",
    like: false,
    name: "RAI R5 Classica",
    url: "https://str.pcradio.ru/rai5_classica-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec955",
    like: false,
    name: "Rai Südtirol",
    url: "https://str.pcradio.ru/rai_sudtirol-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec956",
    like: false,
    name: "Rainbow",
    url: "https://str.pcradio.ru/Rainbow-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec957",
    like: false,
    name: "Rammstein 18+",
    url: "https://str.pcradio.ru/Rammstein-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec958",
    like: false,
    name: "Ramones",
    url: "https://str.pcradio.ru/ramones-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec959",
    like: false,
    name: "Rangarang Radio",
    url: "https://str.pcradio.ru/rangarang_us-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec95a",
    like: false,
    name: "RauteMusik Club",
    url: "https://str.pcradio.ru/music_club_nem-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec95b",
    like: false,
    name: "RauteMusik Deutschrap",
    url: "https://str.pcradio.ru/rautemusik_deutschrap-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec95c",
    like: false,
    name: "RauteMusik Main",
    url: "https://str.pcradio.ru/rautemusik_main-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec95d",
    like: false,
    name: "RauteMusik Trap",
    url: "https://str.pcradio.ru/rautemusik_trap-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec95e",
    like: false,
    name: "Raw FM",
    url: "https://str.pcradio.ru/rawfm_com_au-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec95f",
    like: false,
    name: "RCF Radio",
    url: "https://str.pcradio.ru/rcf_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec960",
    like: false,
    name: "Rclasicos",
    url: "https://str.pcradio.ru/rclasicos_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec961",
    like: false,
    name: "RCM Deep FM",
    url: "https://str.pcradio.ru/rcm_deep_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec962",
    like: false,
    name: "RDP Internacional",
    url: "https://str.pcradio.ru/rdp_inter-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec963",
    like: false,
    name: "Real FM",
    url: "https://str.pcradio.ru/radioreal_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec964",
    like: false,
    name: "Real FM Lights",
    url: "https://str.pcradio.ru/realfmpro_lights-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec965",
    like: false,
    name: "RealFM",
    url: "https://str.pcradio.ru/realfm_spb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec966",
    like: false,
    name: "RealFM Relax",
    url: "https://str.pcradio.ru/realfmsp_relax-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec967",
    like: false,
    name: "Record (Казань)",
    url: "https://str.pcradio.ru/record_kazan-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec968",
    like: false,
    name: "Record (Омск)",
    url: "https://str.pcradio.ru/record_omsk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec969",
    like: false,
    name: "Record 104.0 FM (Тольятти)",
    url: "https://str.pcradio.ru/record_tolyatti-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec96a",
    like: false,
    name: "Record 1970-е",
    url: "https://str.pcradio.ru/record_70s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec96b",
    like: false,
    name: "Record 1980-е",
    url: "https://str.pcradio.ru/record_80s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec96c",
    like: false,
    name: "Record 2-Step",
    url: "https://str.pcradio.ru/record_2step-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec96d",
    like: false,
    name: "Record Big Hits",
    url: "https://str.pcradio.ru/record_bighits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec96e",
    like: false,
    name: "Record Black",
    url: "https://str.pcradio.ru/record_yo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec96f",
    like: false,
    name: "Record Breaks",
    url: "https://str.pcradio.ru/record_breaks-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec970",
    like: false,
    name: "Record Chillout",
    url: "https://str.pcradio.ru/record_chillout-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec971",
    like: false,
    name: "Record Club",
    url: "https://str.pcradio.ru/radiorecord_club-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec972",
    like: false,
    name: "Record Dancecore",
    url: "https://str.pcradio.ru/record_dancecore-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec973",
    like: false,
    name: "Record Darkside",
    url: "https://str.pcradio.ru/record_darkside-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec974",
    like: false,
    name: "Record Deep",
    url: "https://str.pcradio.ru/radiorecord_deep-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec975",
    like: false,
    name: "Record Disco/Funk",
    url: "https://str.pcradio.ru/record_disfunk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec976",
    like: false,
    name: "Record Dream Dance",
    url: "https://str.pcradio.ru/record_dreamdance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec977",
    like: false,
    name: "Record Drum'n'Bass Hits",
    url: "https://str.pcradio.ru/record_dnb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec978",
    like: false,
    name: "Record Dubstep",
    url: "https://str.pcradio.ru/record_dubstep-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec979",
    like: false,
    name: "Record EDM Hits",
    url: "https://str.pcradio.ru/record_edmhits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec97a",
    like: false,
    name: "Record Electro",
    url: "https://str.pcradio.ru/record_electro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec97b",
    like: false,
    name: "Record Eurodance",
    url: "https://str.pcradio.ru/record_eurdance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec97c",
    like: false,
    name: "Record Future Bass",
    url: "https://str.pcradio.ru/record_futbass-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec97d",
    like: false,
    name: "Record Future House",
    url: "https://str.pcradio.ru/record_futurehouse-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec97e",
    like: false,
    name: "Record GOA/PSY",
    url: "https://str.pcradio.ru/record_psy_goa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec97f",
    like: false,
    name: "Record Gold",
    url: "https://str.pcradio.ru/record_gold-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec980",
    like: false,
    name: "Record Hard Bass",
    url: "https://str.pcradio.ru/record_hbass-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec981",
    like: false,
    name: "Record Hardstyle",
    url: "https://str.pcradio.ru/record_hardstyle-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec982",
    like: false,
    name: "Record House Classics",
    url: "https://str.pcradio.ru/record_hoclas-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec983",
    like: false,
    name: "Record House Hits",
    url: "https://str.pcradio.ru/record_househits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec984",
    like: false,
    name: "Record Hypnotic",
    url: "https://str.pcradio.ru/record_hypnotic-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec985",
    like: false,
    name: "Record Jackin'/Garage",
    url: "https://str.pcradio.ru/record_jackgarage-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec986",
    like: false,
    name: "Record Jungle",
    url: "https://str.pcradio.ru/record_jungle-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec987",
    like: false,
    name: "Record Megamix",
    url: "https://str.pcradio.ru/radiorecord_mega-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec988",
    like: false,
    name: "Record Midtempo",
    url: "https://str.pcradio.ru/record_midtempo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec989",
    like: false,
    name: "Record Minimal/Tech",
    url: "https://str.pcradio.ru/record_minimal-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec98a",
    like: false,
    name: "Record Moombahton",
    url: "https://str.pcradio.ru/record_moomba-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec98b",
    like: false,
    name: "Record Neurofunk",
    url: "https://str.pcradio.ru/record_neurofunk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec98c",
    like: false,
    name: "Record Old School",
    url: "https://str.pcradio.ru/record_pump-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec98d",
    like: false,
    name: "Record Pirate Station",
    url: "https://str.pcradio.ru/radiorecord_pirate-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec98e",
    like: false,
    name: "Record Progressive",
    url: "https://str.pcradio.ru/record_progres-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec98f",
    like: false,
    name: "Record Rap Hits",
    url: "https://str.pcradio.ru/record_raphits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec990",
    like: false,
    name: "Record Rave FM",
    url: "https://str.pcradio.ru/record_rave_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec991",
    like: false,
    name: "Record Remix",
    url: "https://str.pcradio.ru/record_remix-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec992",
    like: false,
    name: "Record Rock",
    url: "https://str.pcradio.ru/record_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec993",
    like: false,
    name: "Record Russian Gold",
    url: "https://str.pcradio.ru/record_rusgold-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec994",
    like: false,
    name: "Record Russian Hits",
    url: "https://str.pcradio.ru/record_rushits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec995",
    like: false,
    name: "Record Russian Mix",
    url: "https://str.pcradio.ru/record_rusmix-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec996",
    like: false,
    name: "Record Samara",
    url: "https://str.pcradio.ru/record_samara-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec997",
    like: false,
    name: "Record Synthwave",
    url: "https://str.pcradio.ru/record_synthwave-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec998",
    like: false,
    name: "Record Technopop",
    url: "https://str.pcradio.ru/record_techpop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec999",
    like: false,
    name: "Record Tecktonik",
    url: "https://str.pcradio.ru/record_tecktonik-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec99a",
    like: false,
    name: "Record Trance Hits",
    url: "https://str.pcradio.ru/record_trhits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec99b",
    like: false,
    name: "Record Trancemission",
    url: "https://str.pcradio.ru/record_trnsm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec99c",
    like: false,
    name: "Record Trap",
    url: "https://str.pcradio.ru/record_trap-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec99d",
    like: false,
    name: "Record Tropical",
    url: "https://str.pcradio.ru/record_trop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec99e",
    like: false,
    name: "Record Uplifting",
    url: "https://str.pcradio.ru/record_uplift-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec99f",
    like: false,
    name: "Record Vip House",
    url: "https://str.pcradio.ru/record_viphouse-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9a0",
    like: false,
    name: "Record Веснушка FM",
    url: "https://str.pcradio.ru/record_vesnush-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9a1",
    like: false,
    name: "Record Гастарбайтер",
    url: "https://str.pcradio.ru/record_gast-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9a2",
    like: false,
    name: "Record Гоп FM 18+",
    url: "https://str.pcradio.ru/record_gopfm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9a3",
    like: false,
    name: "Record Маятник Фуко",
    url: "https://str.pcradio.ru/record_mayatnik-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9a4",
    like: false,
    name: "Record Медляк FM",
    url: "https://str.pcradio.ru/record_medlyak-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9a5",
    like: false,
    name: "Record Нафталин FM",
    url: "https://str.pcradio.ru/record_naft-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9a6",
    like: false,
    name: "Record Симфония FM",
    url: "https://str.pcradio.ru/record_symph-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9a7",
    like: false,
    name: "Record Супердискотека 90-х",
    url: "https://str.pcradio.ru/record_superdisco-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9a8",
    like: false,
    name: "Red Hot Chili Peppers",
    url: "https://str.pcradio.ru/red_hot_chili_peppers-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9a9",
    like: false,
    name: "Regenbogen",
    url: "https://str.pcradio.ru/regenbogen-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9aa",
    like: false,
    name: "Regenbogen 2",
    url: "https://str.pcradio.ru/regenbogen2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9ab",
    like: false,
    name: "Regenbogen Adler Mannheim",
    url: "https://str.pcradio.ru/regenbogen_adler-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9ac",
    like: false,
    name: "Reggae Mix Station",
    url: "https://str.pcradio.ru/reggae_mix_station-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9ad",
    like: false,
    name: "Relax FM (Москва)",
    url: "https://str.pcradio.ru/relax_fm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9ae",
    like: false,
    name: "Relax FM Gold",
    url: "https://str.pcradio.ru/relax_fm_gold-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9af",
    like: false,
    name: "Relax FM Jazz",
    url: "https://str.pcradio.ru/relax_fm_jazz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9b0",
    like: false,
    name: "Relax FM Latino",
    url: "https://str.pcradio.ru/relax_fm_latino-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9b1",
    like: false,
    name: "Relax FM Life",
    url: "https://str.pcradio.ru/relax_fm_life-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9b2",
    like: false,
    name: "Relax FM Nature",
    url: "https://str.pcradio.ru/relax_fm_nature-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9b3",
    like: false,
    name: "Relax Zone",
    url: "https://str.pcradio.ru/relax_zone-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9b4",
    like: false,
    name: "Retro Rádió",
    url: "https://str.pcradio.ru/retroradio_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9b5",
    like: false,
    name: "Retro Rádió (Будапешт)",
    url: "https://str.pcradio.ru/retro_hu_buda-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9b6",
    like: false,
    name: "RetroPop",
    url: "https://str.pcradio.ru/retropop_es-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9b7",
    like: false,
    name: "ReVoice Пранкота 18+",
    url: "https://str.pcradio.ru/revoice_prankota-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9b8",
    like: false,
    name: "Revolution Radio",
    url: "https://str.pcradio.ru/revolutionradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9b9",
    like: false,
    name: "RFI Monde",
    url: "https://str.pcradio.ru/rfi_monde-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9ba",
    like: false,
    name: "RFI Persian",
    url: "https://str.pcradio.ru/rfi_persian-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9bb",
    like: false,
    name: "RFI Русский",
    url: "https://str.pcradio.ru/rfi_russian-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9bc",
    like: false,
    name: "RFM 103.9",
    url: "https://str.pcradio.ru/rfmradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9bd",
    like: false,
    name: "Richard Clayderman",
    url: "https://str.pcradio.ru/Richard_Clayderman-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9be",
    like: false,
    name: "Rihanna",
    url: "https://str.pcradio.ru/Rihanna-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9bf",
    like: false,
    name: "Ring FM",
    url: "https://str.pcradio.ru/ringfm_ee-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9c0",
    like: false,
    name: "Rire et Chansons",
    url: "https://str.pcradio.ru/rire_et_chansons-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9c1",
    like: false,
    name: "Rise FM",
    url: "https://str.pcradio.ru/risefm_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9c2",
    like: false,
    name: "RJM Dance",
    url: "https://str.pcradio.ru/rjm_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9c3",
    like: false,
    name: "RLCB Dance",
    url: "https://str.pcradio.ru/rlcb_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9c4",
    like: false,
    name: "RLCB Tuga",
    url: "https://str.pcradio.ru/rlcb_tuga-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9c5",
    like: false,
    name: "RMC 80",
    url: "https://str.pcradio.ru/rmc_80-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9c6",
    like: false,
    name: "RMC 90",
    url: "https://str.pcradio.ru/rmc_90-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9c7",
    like: false,
    name: "RMC Buddha-Bar",
    url: "https://str.pcradio.ru/rmc_buddha-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9c8",
    like: false,
    name: "RMC Duets",
    url: "https://str.pcradio.ru/rmc_duets-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9c9",
    like: false,
    name: "RMC Great Artists",
    url: "https://str.pcradio.ru/rmc_greatart-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9ca",
    like: false,
    name: "RMC Hits",
    url: "https://str.pcradio.ru/rmc_hits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ec9cc",
    like: false,
    name: "RMC Kay Kay",
    url: "https://str.pcradio.ru/rmc_kaykay-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9cd",
    like: false,
    name: "RMC Love Songs",
    url: "https://str.pcradio.ru/rmc_lovesongs-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9ce",
    like: false,
    name: "RMC Marine",
    url: "https://str.pcradio.ru/rmc_marine-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9cf",
    like: false,
    name: "RMC Monte Carlo Nights Story",
    url: "https://str.pcradio.ru/rmc_mcnights-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9d0",
    like: false,
    name: "RMC New Classics",
    url: "https://str.pcradio.ru/rmc_newclass-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9d1",
    like: false,
    name: "RMF Classic",
    url: "https://str.pcradio.ru/rmf_classic-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9d2",
    like: false,
    name: "RMF Disco Polo",
    url: "https://str.pcradio.ru/rmf_discopolo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9d3",
    like: false,
    name: "RMF FM",
    url: "https://str.pcradio.ru/rmffm_krakow-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9d4",
    like: false,
    name: "RMF Maxxx",
    url: "https://str.pcradio.ru/rmf_maxxx-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9d5",
    like: false,
    name: "RMF Nostalgia",
    url: "https://str.pcradio.ru/rmf_nostalgia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9d6",
    like: false,
    name: "RMN Relax",
    url: "https://str.pcradio.ru/rmn_relax-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9d7",
    like: false,
    name: "RNA - Canal A",
    url: "https://str.pcradio.ru/rna_canala-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9d8",
    like: false,
    name: "RNB and Hip Hop Radio",
    url: "https://str.pcradio.ru/rnbnhiphop_us-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9d9",
    like: false,
    name: "Robbie Williams",
    url: "https://str.pcradio.ru/Robbie_Williams-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9da",
    like: false,
    name: "Robert Miles",
    url: "https://str.pcradio.ru/Robert_Miles-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9db",
    like: false,
    name: "Robyn",
    url: "https://str.pcradio.ru/Robyn-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9dc",
    like: false,
    name: "Rock Antenne Alternative",
    url: "https://str.pcradio.ru/rockantenne_alternative-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9dd",
    like: false,
    name: "Rock Antenne Classic Perlen",
    url: "https://str.pcradio.ru/rock_antenne_classicperl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9de",
    like: false,
    name: "Rock Antenne Deutschrock",
    url: "https://str.pcradio.ru/rock_antenne_deutschrock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9df",
    like: false,
    name: "Rock Antenne Heavy Metal",
    url: "https://str.pcradio.ru/rockantenne_heavymetal-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9e0",
    like: false,
    name: "Rock Antenne Live",
    url: "https://str.pcradio.ru/rock_antenne_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9e1",
    like: false,
    name: "Rock Antenne Soft Rock",
    url: "https://str.pcradio.ru/rock_antenne_soft-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9e2",
    like: false,
    name: "Rock Antenne Young Stars",
    url: "https://str.pcradio.ru/rock_antenne_young-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9e3",
    like: false,
    name: "Rock Arena",
    url: "https://str.pcradio.ru/rockarena_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9e4",
    like: false,
    name: "Rock FM",
    url: "https://str.pcradio.ru/rockfm_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9e5",
    like: false,
    name: "Rock FM",
    url: "https://str.pcradio.ru/rockfm_moscow-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9e6",
    like: false,
    name: "Rock FM (Бухарест)",
    url: "https://str.pcradio.ru/rockfm_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9e7",
    like: false,
    name: "Rock Mania FM",
    url: "https://str.pcradio.ru/Rock_maniy_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9e8",
    like: false,
    name: "Rock Mauritius Radio",
    url: "https://str.pcradio.ru/mauritius_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9e9",
    like: false,
    name: "Rock Radio (Варшава)",
    url: "https://str.pcradio.ru/rockradio_tuba_pl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9ea",
    like: false,
    name: "Rock Zone (Прага)",
    url: "https://str.pcradio.ru/rockzone_praga-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9eb",
    like: false,
    name: "Rockabilly Radio",
    url: "https://str.pcradio.ru/rockabilly_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9ec",
    like: false,
    name: "Rocker Rádió",
    url: "https://str.pcradio.ru/rockerradio_online-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9ed",
    like: false,
    name: "Rockhaus Radio",
    url: "https://str.pcradio.ru/rockhaus_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9ee",
    like: false,
    name: "Rockland Radio",
    url: "https://str.pcradio.ru/rockland_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9ef",
    like: false,
    name: "RockLand.FM",
    url: "https://str.pcradio.ru/rockland_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9f0",
    like: false,
    name: "RockRadio1",
    url: "https://str.pcradio.ru/rockradio1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9f1",
    like: false,
    name: "RockSatelite Madrid-One",
    url: "https://str.pcradio.ru/rocksatelitecom-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9f2",
    like: false,
    name: "Romantic Радио",
    url: "https://str.pcradio.ru/Romantic-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9f3",
    like: false,
    name: "Romantika",
    url: "https://str.pcradio.ru/romantica-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9f4",
    like: false,
    name: "Roundandsound Radio",
    url: "https://str.pcradio.ru/roundandsound_nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9f5",
    like: false,
    name: "Roxette",
    url: "https://str.pcradio.ru/Roxette-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9f6",
    like: false,
    name: "RoyalRadio 98.6 FM",
    url: "https://str.pcradio.ru/royal_radio986-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9f7",
    like: false,
    name: "Royksopp",
    url: "https://str.pcradio.ru/royksopp-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9f8",
    like: false,
    name: "RPR1. 100% Deutsch-Pop",
    url: "https://str.pcradio.ru/rpr1_de_100deu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9f9",
    like: false,
    name: "RPR1. Acoustic",
    url: "https://str.pcradio.ru/rpr1_de_acou-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9fa",
    like: false,
    name: "RPR1. Aprés Ski und Ballermann",
    url: "https://str.pcradio.ru/rpr1_spreski-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9fb",
    like: false,
    name: "RPR1. Best of 80's",
    url: "https://str.pcradio.ru/rpr1_de_80s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9fc",
    like: false,
    name: "RPR1. Chilloutzone",
    url: "https://str.pcradio.ru/rpr1_de_chill-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9fd",
    like: false,
    name: "RPR1. Classic Rock",
    url: "https://str.pcradio.ru/rpr1_de_clasro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9fe",
    like: false,
    name: "RPR1. Country",
    url: "https://str.pcradio.ru/rpr1_de_coun-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ec9ff",
    like: false,
    name: "RPR1. Die Tanzbar",
    url: "https://str.pcradio.ru/rpr1_de_tanzbar-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca00",
    like: false,
    name: "RPR1. Evergreens",
    url: "https://str.pcradio.ru/rpr1_de_ever-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca01",
    like: false,
    name: "RPR1. Fitness",
    url: "https://str.pcradio.ru/rpr1_de_wout-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca02",
    like: false,
    name: "RPR1. Hard Rock",
    url: "https://str.pcradio.ru/rpr1_hardrock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca03",
    like: false,
    name: "RPR1. Heavy Metal",
    url: "https://str.pcradio.ru/rpr1_de_metal-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca04",
    like: false,
    name: "RPR1. Hits für Kids",
    url: "https://str.pcradio.ru/rpr1_hitskids-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca05",
    like: false,
    name: "RPR1. Kinderlieder",
    url: "https://str.pcradio.ru/rpr1_de_kid-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca06",
    like: false,
    name: "RPR1. Live",
    url: "https://str.pcradio.ru/rpr1_de_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca07",
    like: false,
    name: "RPR1. Neue Deutsche Welle",
    url: "https://str.pcradio.ru/rpr1_de_ndw-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca08",
    like: false,
    name: "RPR1. Oldies",
    url: "https://str.pcradio.ru/rpr1_de_oldies-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca09",
    like: false,
    name: "RPR1. Oldschool Hip-Hop",
    url: "https://str.pcradio.ru/rpr1_de_ohip-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca0a",
    like: false,
    name: "RPR1. Original 2000er",
    url: "https://str.pcradio.ru/rpr1_de_00er-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca0b",
    like: false,
    name: "RPR1. Original 70er",
    url: "https://str.pcradio.ru/rpr1_de_70er-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca0c",
    like: false,
    name: "RPR1. Original 90er",
    url: "https://str.pcradio.ru/rpr1_de_90er-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca0d",
    like: false,
    name: "RPR1. Original Old School Hip-Hop",
    url: "https://str.pcradio.ru/rpr1_de_oldhip-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca0e",
    like: false,
    name: "RPR1. Pappnasen-Playlist",
    url: "https://str.pcradio.ru/rpr1_de_pappna-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca0f",
    like: false,
    name: "RPR1. Schlagerhits",
    url: "https://str.pcradio.ru/rpr1_de_schla-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca10",
    like: false,
    name: "RPR1. Sommerhits",
    url: "https://str.pcradio.ru/rpr1_de_summer-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca11",
    like: false,
    name: "RPR1. Top 50",
    url: "https://str.pcradio.ru/rpr1_de_top50-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca12",
    like: false,
    name: "RPR1. Traumfabrik",
    url: "https://str.pcradio.ru/rpr1_de_traum-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca13",
    like: false,
    name: "RPR1. Weihnachtslieder",
    url: "https://str.pcradio.ru/rpr1_de_xmas-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca14",
    like: false,
    name: "RPR1. Yoga Sounds",
    url: "https://str.pcradio.ru/rpr1_de_pur-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca15",
    like: false,
    name: "RS2 94.3",
    url: "https://str.pcradio.ru/rs2_943-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca16",
    like: false,
    name: "RS2 Kulthits",
    url: "https://str.pcradio.ru/rs2_kult-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca17",
    like: false,
    name: "RS2 Top40",
    url: "https://str.pcradio.ru/rs2_top40-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca18",
    like: false,
    name: "RSI Rete Uno",
    url: "https://str.pcradio.ru/rsi_reteuno-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca19",
    like: false,
    name: "RT1 - 2000er",
    url: "https://str.pcradio.ru/rt1_2000er-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca1a",
    like: false,
    name: "RT1 - 80er",
    url: "https://str.pcradio.ru/rt1_80er-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca1b",
    like: false,
    name: "RT1 - 90er",
    url: "https://str.pcradio.ru/rt1_90er-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca1c",
    like: false,
    name: "RT1 - Black",
    url: "https://str.pcradio.ru/rt1_black-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca1d",
    like: false,
    name: "RT1 - ChillHouse",
    url: "https://str.pcradio.ru/rt1_chillhouse-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca1e",
    like: false,
    name: "RT1 - Dance",
    url: "https://str.pcradio.ru/rt1_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca1f",
    like: false,
    name: "RT1 - Deutsch",
    url: "https://str.pcradio.ru/rt1_deutsch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca20",
    like: false,
    name: "RT1 - EuroDance",
    url: "https://str.pcradio.ru/rt1_eurodance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca21",
    like: false,
    name: "RT1 - Funk",
    url: "https://str.pcradio.ru/rt1_funk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca22",
    like: false,
    name: "RT1 - In the Mix",
    url: "https://str.pcradio.ru/rt1_inthemix-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca23",
    like: false,
    name: "RT1 - Kids",
    url: "https://str.pcradio.ru/rt1_kids-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca24",
    like: false,
    name: "RT1 - Lounge",
    url: "https://str.pcradio.ru/rt1_lounge-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca25",
    like: false,
    name: "RT1 - Oldies",
    url: "https://str.pcradio.ru/rt1_oldies-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca26",
    like: false,
    name: "RT1 - Power Workout",
    url: "https://str.pcradio.ru/rt1_workout-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca27",
    like: false,
    name: "RT1 - Relax",
    url: "https://str.pcradio.ru/rt1_relax-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca28",
    like: false,
    name: "RT1 - Rock",
    url: "https://str.pcradio.ru/rt1_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca29",
    like: false,
    name: "RT1 - Weekend",
    url: "https://str.pcradio.ru/rt1_weekend-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca2a",
    like: false,
    name: "RTBF International",
    url: "https://str.pcradio.ru/rtbf_int-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca2b",
    like: false,
    name: "RTBF La Première",
    url: "https://str.pcradio.ru/rtbf_la1ere-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca2c",
    like: false,
    name: "RTBF VivaCité",
    url: "https://str.pcradio.ru/rtbf_vivacite-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca2d",
    like: false,
    name: "RTE Radio 1",
    url: "https://str.pcradio.ru/rte_radio1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca2e",
    like: false,
    name: "RTE Radio 1 Extra",
    url: "https://str.pcradio.ru/rte_radio1_extra-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca2f",
    like: false,
    name: "RTI Radio Transsylvania International",
    url: "https://str.pcradio.ru/rti_transsylv-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca30",
    like: false,
    name: "RTL",
    url: "https://str.pcradio.ru/rtl_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca31",
    like: false,
    name: "RTL Radio",
    url: "https://str.pcradio.ru/rtlradio_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca32",
    like: false,
    name: "RTL Radio - Die besten Hits aller Zeiten",
    url: "https://str.pcradio.ru/rtlradio_hits_aller_zeiten-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca33",
    like: false,
    name: "RTL2",
    url: "https://str.pcradio.ru/rtl2_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca34",
    like: false,
    name: "RTS - La Première",
    url: "https://str.pcradio.ru/rts_1ere-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca35",
    like: false,
    name: "RTVS Pátria Rádio",
    url: "https://str.pcradio.ru/patria_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca36",
    like: false,
    name: "RTVS Radio Regina Stred",
    url: "https://str.pcradio.ru/rtvs_reg_stred-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca37",
    like: false,
    name: "RTVS Rádio Devín",
    url: "https://str.pcradio.ru/rtvs_devin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca38",
    like: false,
    name: "RTVS Rádio Junior",
    url: "https://str.pcradio.ru/rtvs_junior-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca39",
    like: false,
    name: "RTVS Rádio Litera",
    url: "https://str.pcradio.ru/rtvs_litera-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca3a",
    like: false,
    name: "RTVS Rádio Pyramída",
    url: "https://str.pcradio.ru/rtvs_pyramida-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca3b",
    like: false,
    name: "RTVS Rádio Regina Východ",
    url: "https://str.pcradio.ru/rtvs_reginavych-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca3c",
    like: false,
    name: "RTVS Rádio Regina Západ",
    url: "https://str.pcradio.ru/rtvs_reginazap-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca3d",
    like: false,
    name: "RTVS Rádio Slovakia International",
    url: "https://str.pcradio.ru/rtvs_slovak_int-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca3e",
    like: false,
    name: "RTVS Rádio Slovensko",
    url: "https://str.pcradio.ru/rtvs_slovensko-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca3f",
    like: false,
    name: "RTVS Rádio_FM",
    url: "https://str.pcradio.ru/rtvs_radio_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca40",
    like: false,
    name: "RTVSLO Muravidéki Magyar Rádió",
    url: "https://str.pcradio.ru/rtvslo_mmr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca41",
    like: false,
    name: "RTÉ 2FM",
    url: "https://str.pcradio.ru/rte_2fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca42",
    like: false,
    name: "RTÉ 2XM",
    url: "https://str.pcradio.ru/rte_2xm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca43",
    like: false,
    name: "RU музыка",
    url: "https://str.pcradio.ru/RU_Music-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca44",
    like: false,
    name: "Rudy Maxa's World",
    url: "https://str.pcradio.ru/maxas_world-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca45",
    like: false,
    name: "Ruff Draft Radio",
    url: "https://str.pcradio.ru/ruff_draft-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca46",
    like: false,
    name: "Run FM",
    url: "https://str.pcradio.ru/Dlja_bega-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca47",
    like: false,
    name: "Run-D.M.C.",
    url: "https://str.pcradio.ru/run_dmc-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca48",
    like: false,
    name: "RusRadio LT",
    url: "https://str.pcradio.ru/rusradio_lt-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca49",
    like: false,
    name: "Russian! Radio",
    url: "https://str.pcradio.ru/russian_cux-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca4a",
    like: false,
    name: "RussianFM",
    url: "https://str.pcradio.ru/russianfm_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca4b",
    like: false,
    name: "Rusyn FM",
    url: "https://str.pcradio.ru/rusyn_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca4c",
    like: false,
    name: "Rádio 7",
    url: "https://str.pcradio.ru/radio7_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca4d",
    like: false,
    name: "Rádio Aetter",
    url: "https://str.pcradio.ru/aetter_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca4e",
    like: false,
    name: "Rádio Amigos do Flashback",
    url: "https://str.pcradio.ru/amigos_flash-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca4f",
    like: false,
    name: "Rádio Amigos do Sertanejo",
    url: "https://str.pcradio.ru/amigos_sertan-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca50",
    like: false,
    name: "Rádio Anténa Rock",
    url: "https://str.pcradio.ru/antenarock_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca51",
    like: false,
    name: "Rádio Anténa Rock Hard",
    url: "https://str.pcradio.ru/antenarock_sk_hard-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca52",
    like: false,
    name: "Rádio Aparecida 820 AM",
    url: "https://str.pcradio.ru/aparecida820-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca53",
    like: false,
    name: "Rádio Comercial",
    url: "https://str.pcradio.ru/comercial_pt-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca54",
    like: false,
    name: "Rádio Conexão Manaus Reggae",
    url: "https://str.pcradio.ru/conexao_manaus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca55",
    like: false,
    name: "Rádio Cultura 1200 AM",
    url: "https://str.pcradio.ru/cultura_1200-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca56",
    like: false,
    name: "Rádio Ecclesia",
    url: "https://str.pcradio.ru/ecclesia_angola-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca57",
    like: false,
    name: "Rádio Esperança de Picos",
    url: "https://str.pcradio.ru/esperanca_depicos-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca58",
    like: false,
    name: "Rádio Estacao Gospel",
    url: "https://str.pcradio.ru/estacaogospel_br-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca59",
    like: false,
    name: "Rádio Expres",
    url: "https://str.pcradio.ru/expres_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca5a",
    like: false,
    name: "Rádio Fonte",
    url: "https://str.pcradio.ru/fonte_com_br-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca5b",
    like: false,
    name: "Rádio Girassol",
    url: "https://str.pcradio.ru/girassol_belu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca5c",
    like: false,
    name: "Rádio Grenal",
    url: "https://str.pcradio.ru/grenal_com_br-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca5d",
    like: false,
    name: "Rádio Impuls",
    url: "https://str.pcradio.ru/impuls_raaadio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca5e",
    like: false,
    name: "Rádio Inconfidência 880 AM",
    url: "https://str.pcradio.ru/inconfi_880am-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca5f",
    like: false,
    name: "Rádio Jampa Jovens",
    url: "https://str.pcradio.ru/jampa_jovens-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca60",
    like: false,
    name: "Rádio Jemné",
    url: "https://str.pcradio.ru/jemne_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca61",
    like: false,
    name: "Rádio Jemné Chillout",
    url: "https://str.pcradio.ru/jemne_sk_chill-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca62",
    like: false,
    name: "Rádio Jupiter",
    url: "https://str.pcradio.ru/jupiter_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca63",
    like: false,
    name: "Rádio Košice",
    url: "https://str.pcradio.ru/radiokosice_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca64",
    like: false,
    name: "Rádio Kuia Beu",
    url: "https://str.pcradio.ru/kuia_beu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca65",
    like: false,
    name: "Rádio Logos",
    url: "https://str.pcradio.ru/logos_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca66",
    like: false,
    name: "Rádio Lumen",
    url: "https://str.pcradio.ru/lumen_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca67",
    like: false,
    name: "Rádio Modra",
    url: "https://str.pcradio.ru/modra_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca68",
    like: false,
    name: "Rádio Mária Slovensko",
    url: "https://str.pcradio.ru/maria_slovensko-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca69",
    like: false,
    name: "Rádio Piešťany 90.2",
    url: "https://str.pcradio.ru/piestany_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca6a",
    like: false,
    name: "Rádio Planeta",
    url: "https://str.pcradio.ru/radioplaneta_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca6b",
    like: false,
    name: "Rádio Radar 97.8 FM",
    url: "https://str.pcradio.ru/radar_978_lis-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca6c",
    like: false,
    name: "Rádio Rebeca",
    url: "https://str.pcradio.ru/rebeca_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca6d",
    like: false,
    name: "Rádio Reggae 10",
    url: "https://str.pcradio.ru/reggae10-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca6e",
    like: false,
    name: "Rádio Santa Rita de Cássia",
    url: "https://str.pcradio.ru/santarita_cassia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca6f",
    like: false,
    name: "Rádio Santorelli",
    url: "https://str.pcradio.ru/santorelli_zeno-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca70",
    like: false,
    name: "Rádio SiTy 107FM",
    url: "https://str.pcradio.ru/radiosity_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca71",
    like: false,
    name: "Rádio Super Funk Melody",
    url: "https://str.pcradio.ru/super_funk_melody-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca72",
    like: false,
    name: "Rádio The End",
    url: "https://str.pcradio.ru/theend_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca73",
    like: false,
    name: "Rádio Viva 94.9 FM",
    url: "https://str.pcradio.ru/viva_949fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca74",
    like: false,
    name: "Rádio Vlna",
    url: "https://str.pcradio.ru/vlna_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca75",
    like: false,
    name: "Rádio Vlna",
    url: "https://str.pcradio.ru/radiovlna_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca76",
    like: false,
    name: "Rádio Vlna Golden",
    url: "https://str.pcradio.ru/vlna_sk_golden-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca77",
    like: false,
    name: "Rádio Web Vida Gospel",
    url: "https://str.pcradio.ru/vidagospel_br-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca78",
    like: false,
    name: "Rádio Šírava",
    url: "https://str.pcradio.ru/sirava_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca79",
    like: false,
    name: "Rádió 24",
    url: "https://str.pcradio.ru/r24_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca7a",
    like: false,
    name: "Rádió 88",
    url: "https://str.pcradio.ru/radio88_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca7b",
    like: false,
    name: "Rádió Gaga",
    url: "https://str.pcradio.ru/radiogaga_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca7c",
    like: false,
    name: "Rádió M",
    url: "https://str.pcradio.ru/fmradiom_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca7d",
    like: false,
    name: "Rádió Szarvas 105.4",
    url: "https://str.pcradio.ru/szarvas_1054-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca7e",
    like: false,
    name: "S13 Radio",
    url: "https://str.pcradio.ru/s13_grodno-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca7f",
    like: false,
    name: "Sade",
    url: "https://str.pcradio.ru/Sade-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca80",
    like: false,
    name: "Salsa Gorda Radio",
    url: "https://str.pcradio.ru/salsa_gorda-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca81",
    like: false,
    name: "Sampler Radio",
    url: "https://str.pcradio.ru/sampler_br-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca82",
    like: false,
    name: "San FM Alternative",
    url: "https://str.pcradio.ru/sanfm_ru_alternative-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca83",
    like: false,
    name: "San FM Drum and Bass",
    url: "https://str.pcradio.ru/sanfm_ru_drum-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca84",
    like: false,
    name: "San FM Pop",
    url: "https://str.pcradio.ru/sanfm_ru_pop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca85",
    like: false,
    name: "San FM Relax",
    url: "https://str.pcradio.ru/sanfm_ru_relax-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca86",
    like: false,
    name: "San FM Trance",
    url: "https://str.pcradio.ru/sanfm_ru_trance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca87",
    like: false,
    name: "San Francisco's 70's Hits",
    url: "https://str.pcradio.ru/sanfran_70hits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca88",
    like: false,
    name: "Sandra",
    url: "https://str.pcradio.ru/Sandra-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca89",
    like: false,
    name: "SanFM - Drum and Bass",
    url: "https://str.pcradio.ru/sanfm_dnb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca8a",
    like: false,
    name: "Sasaki Sayaka",
    url: "https://str.pcradio.ru/Sasaki_Sayaka-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca8b",
    like: false,
    name: "SATzentrale - Das Radio",
    url: "https://str.pcradio.ru/satzentrael_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca8c",
    like: false,
    name: "Sawano Hiroyuki",
    url: "https://str.pcradio.ru/Savano_Hirojuki-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca8d",
    like: false,
    name: "Sax and Love",
    url: "https://str.pcradio.ru/Saxophone-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca8e",
    like: false,
    name: "Sax4Love",
    url: "https://str.pcradio.ru/one_sax4ever-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca8f",
    like: false,
    name: "Schiller",
    url: "https://str.pcradio.ru/Schiller-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca90",
    like: false,
    name: "Schizoid Chillout - Ambient",
    url: "https://str.pcradio.ru/schizoid_chill-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca91",
    like: false,
    name: "Schizoid Dub Techno",
    url: "https://str.pcradio.ru/schizoid_progress-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca92",
    like: false,
    name: "Schizoid Progressive Psy",
    url: "https://str.pcradio.ru/schizoid_progpsy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca93",
    like: false,
    name: "Schizoid Psychedelic Trance",
    url: "https://str.pcradio.ru/schizoid_psytrance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca94",
    like: false,
    name: "Schlager Radio",
    url: "https://str.pcradio.ru/schlagerradio_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca95",
    like: false,
    name: "Schlagerparadies",
    url: "https://str.pcradio.ru/schlagerparadies-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca96",
    like: false,
    name: "SchlagerPlanet",
    url: "https://str.pcradio.ru/schlager_planet-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca97",
    like: false,
    name: "Schwarzwald Radio",
    url: "https://str.pcradio.ru/schwarzwaldradio_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca98",
    like: false,
    name: "Scooter",
    url: "https://str.pcradio.ru/Scooter-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca99",
    like: false,
    name: "Scorpions",
    url: "https://str.pcradio.ru/Scorpions-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca9a",
    like: false,
    name: "Sector Progressive",
    url: "https://str.pcradio.ru/sector_progressive-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca9b",
    like: false,
    name: "Sector Space",
    url: "https://str.pcradio.ru/sector_space-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca9c",
    like: false,
    name: "Select Radio",
    url: "https://str.pcradio.ru/selectuk_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca9d",
    like: false,
    name: "Sensuelle Radio",
    url: "https://str.pcradio.ru/sensu_elle-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca9e",
    like: false,
    name: "Sepultura",
    url: "https://str.pcradio.ru/Sepultura-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eca9f",
    like: false,
    name: "Seven Skies Radio 1",
    url: "https://str.pcradio.ru/sevenskies_1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaa0",
    like: false,
    name: "Seven Skies Radio 2",
    url: "https://str.pcradio.ru/sevenskies_2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaa1",
    like: false,
    name: "Seven Skies Radio 3",
    url: "https://str.pcradio.ru/sevenskies_3-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaa2",
    like: false,
    name: "Sex Pistols",
    url: "https://str.pcradio.ru/sex_pistols-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaa3",
    like: false,
    name: "2 FM",
    url: "https://str.pcradio.ru/sfera1022-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaa4",
    like: false,
    name: "Shaivam",
    url: "https://str.pcradio.ru/shaivam_org-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaa5",
    like: false,
    name: "Shakira",
    url: "https://str.pcradio.ru/Shakira-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaa6",
    like: false,
    name: "Shakthi FM",
    url: "https://str.pcradio.ru/shakthi_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaa7",
    like: false,
    name: "Sham FM",
    url: "https://str.pcradio.ru/shamfm_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaa8",
    like: false,
    name: "Shanson USA",
    url: "https://str.pcradio.ru/shanson_usa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaa9",
    like: false,
    name: "Show Radyo",
    url: "https://str.pcradio.ru/show_radyo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaaa",
    like: false,
    name: "Shraddha - Lakviru Radio",
    url: "https://str.pcradio.ru/lakviru_lk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaab",
    like: false,
    name: "Shuffle-Radio",
    url: "https://str.pcradio.ru/shuffle_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaac",
    like: false,
    name: "SikhNet",
    url: "https://str.pcradio.ru/sikh_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaad",
    like: false,
    name: "SK-Radio",
    url: "https://str.pcradio.ru/sk_radio_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaae",
    like: false,
    name: "Skillet",
    url: "https://str.pcradio.ru/skillet-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaaf",
    like: false,
    name: "Skonto",
    url: "https://str.pcradio.ru/skonto_riga-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecab0",
    like: false,
    name: "Skrillex",
    url: "https://str.pcradio.ru/Skrillex-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecab1",
    like: false,
    name: "Sky Plus",
    url: "https://str.pcradio.ru/skyplus_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecab2",
    like: false,
    name: "Sky Radio - 80's",
    url: "https://str.pcradio.ru/skyradio_80s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecab3",
    like: false,
    name: "Sky Radio - 90's",
    url: "https://str.pcradio.ru/skyradio_90s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecab4",
    like: false,
    name: "Sky Radio - Hits",
    url: "https://str.pcradio.ru/skyradio_hits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecab5",
    like: false,
    name: "Sky Radio - Lounge",
    url: "https://str.pcradio.ru/skyradio_lounge-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecab6",
    like: false,
    name: "Sky Radio - Love Songs",
    url: "https://str.pcradio.ru/skyradio_love-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecab7",
    like: false,
    name: "Sky Radio 101 FM",
    url: "https://str.pcradio.ru/skyradionl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecab8",
    like: false,
    name: "SKY Rádio (Прешов)",
    url: "https://str.pcradio.ru/skyradio_sk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecab9",
    like: false,
    name: "Sky Радио",
    url: "https://str.pcradio.ru/sky_radio_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaba",
    like: false,
    name: "Skyline Radio and Soul",
    url: "https://str.pcradio.ru/skyline_soul-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecabb",
    like: false,
    name: "SLAM! FM",
    url: "https://str.pcradio.ru/slamfmnl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecabc",
    like: false,
    name: "SLAM! Hardstyle",
    url: "https://str.pcradio.ru/slam_hardstyle-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecabd",
    like: false,
    name: "SLAM! MixMarathon",
    url: "https://str.pcradio.ru/slam_mixma-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecabe",
    like: false,
    name: "SLAM! Non-stop",
    url: "https://str.pcradio.ru/slam_nonstop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecabf",
    like: false,
    name: "SLAM! The Boom Room",
    url: "https://str.pcradio.ru/slam_theboom-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecac0",
    like: false,
    name: "Slipknot",
    url: "https://str.pcradio.ru/SlipKnot-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecac1",
    like: false,
    name: "Slobodný vysielač",
    url: "https://str.pcradio.ru/slobodny_vysielac-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecac3",
    like: false,
    name: "Sláger FM",
    url: "https://str.pcradio.ru/slagerfm_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecac4",
    like: false,
    name: "Smash!!",
    url: "https://str.pcradio.ru/smash-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecac5",
    like: false,
    name: "Smooth Jazz - Tampa Bay",
    url: "https://str.pcradio.ru/smjazz_tampabay-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecac6",
    like: false,
    name: "Smooth Jazz 247",
    url: "https://str.pcradio.ru/smoothjazz247-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecac7",
    like: false,
    name: "Smooth Jazz CD101.9 New York",
    url: "https://str.pcradio.ru/smoothjazz_nyc1019-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecac8",
    like: false,
    name: "Smooth Jazz Florida Plus",
    url: "https://str.pcradio.ru/smoothjazz_plus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecac9",
    like: false,
    name: "Smooth Jazz Global",
    url: "https://str.pcradio.ru/smoothjazz_global-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaca",
    like: false,
    name: "Smooth Jazz Lounge",
    url: "https://str.pcradio.ru/smoothjazz_lou-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecacb",
    like: false,
    name: "Smooth Jazz Smooth Wave",
    url: "https://str.pcradio.ru/smooth_jazzwave-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecacc",
    like: false,
    name: "Smooth Lounge Global",
    url: "https://str.pcradio.ru/smoothlounge_global-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecacd",
    like: false,
    name: "smoothfm 91.5 (Мельбурн)",
    url: "https://str.pcradio.ru/smoothfm_915melb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecace",
    like: false,
    name: "Sok FM",
    url: "https://str.pcradio.ru/sokfm_gr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecacf",
    like: false,
    name: "Sol de Justicia",
    url: "https://str.pcradio.ru/sol_de_just-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecad0",
    like: false,
    name: "Sol FM",
    url: "https://str.pcradio.ru/solfm1007-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecad1",
    like: false,
    name: "Soldier",
    url: "https://str.pcradio.ru/Soldier-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecad2",
    like: false,
    name: "SomaFM - Boot Liquor",
    url: "https://str.pcradio.ru/somafm_boot-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecad3",
    like: false,
    name: "SomaFM - Drone Zone",
    url: "https://str.pcradio.ru/somafm_drone_zone-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecad4",
    like: false,
    name: "SomaFM - Dubstep",
    url: "https://str.pcradio.ru/somafm_dubstep-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecad5",
    like: false,
    name: "SomaFM - Left Coast 70s",
    url: "https://str.pcradio.ru/soma_left70s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecad6",
    like: false,
    name: "SomaFM - SF 10-33",
    url: "https://str.pcradio.ru/somafm_sf1033-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecad7",
    like: false,
    name: "SomaFM - Space Station",
    url: "https://str.pcradio.ru/somafm_spacesta-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecad8",
    like: false,
    name: "Sonatica",
    url: "https://str.pcradio.ru/sonatica_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecad9",
    like: false,
    name: "Sonido Oscuro",
    url: "https://str.pcradio.ru/sonido_oscuro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecada",
    like: false,
    name: "Sopron Rádió FM 94.1",
    url: "https://str.pcradio.ru/sopron_941-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecadb",
    like: false,
    name: "Sorte Web Radio",
    url: "https://str.pcradio.ru/sorte_web_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecadc",
    like: false,
    name: "Soulfly",
    url: "https://str.pcradio.ru/Soulfly-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecadd",
    like: false,
    name: "Soulful House",
    url: "https://str.pcradio.ru/soulfulhou_vip-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecade",
    like: false,
    name: "Soulplay Radio",
    url: "https://str.pcradio.ru/soulplay_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecadf",
    like: false,
    name: "Soulshow Radio",
    url: "https://str.pcradio.ru/soulshow_nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecae0",
    like: false,
    name: "Soundeo",
    url: "https://str.pcradio.ru/soundeo_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecae1",
    like: false,
    name: "SoundPark Deep",
    url: "https://str.pcradio.ru/sp_deep-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecae2",
    like: false,
    name: "Soundstorm - Relax Radio",
    url: "https://str.pcradio.ru/soundstorm_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecae3",
    like: false,
    name: "SpaceSynth RU",
    url: "https://str.pcradio.ru/space_synth_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecae4",
    like: false,
    name: "Spice Girls",
    url: "https://str.pcradio.ru/Spice_Girls-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecae5",
    like: false,
    name: "Spin FM",
    url: "https://str.pcradio.ru/swh_spin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecae6",
    like: false,
    name: "Spirit FM",
    url: "https://str.pcradio.ru/spirit_radio_pcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecae7",
    like: false,
    name: "Spreeradio 105'5 - 80er",
    url: "https://str.pcradio.ru/spreeradio_1055_80er-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecae8",
    like: false,
    name: "Spreeradio 105'5 - Live",
    url: "https://str.pcradio.ru/spreeradio_1055_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecae9",
    like: false,
    name: "Spreeradio 105'5 - Love",
    url: "https://str.pcradio.ru/spreeradio_1055_love-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaea",
    like: false,
    name: "Spreeradio 105'5 - Rock",
    url: "https://str.pcradio.ru/spreeradio_1055_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaeb",
    like: false,
    name: "Sputnik (English)",
    url: "https://str.pcradio.ru/sputnik_english-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaec",
    like: false,
    name: "Sputnik Mundo",
    url: "https://str.pcradio.ru/sputnik_mundo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaed",
    like: false,
    name: "SpyNetStation - Bright Side",
    url: "https://str.pcradio.ru/spynet_bright-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaee",
    like: false,
    name: "SpyNetStation - Dark Side",
    url: "https://str.pcradio.ru/spynet_dark-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaef",
    like: false,
    name: "SR 1 Europawelle",
    url: "https://str.pcradio.ru/sr1_euwelle-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaf0",
    like: false,
    name: "SR 2 Kulturradio",
    url: "https://str.pcradio.ru/sr2_kulturradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaf1",
    like: false,
    name: "SR 3 Saarlandwelle",
    url: "https://str.pcradio.ru/sr3_saarland-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaf2",
    like: false,
    name: "SRF 1",
    url: "https://str.pcradio.ru/srf1_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaf3",
    like: false,
    name: "SRF 2 Kultur",
    url: "https://str.pcradio.ru/srf2_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaf4",
    like: false,
    name: "SRF 3",
    url: "https://str.pcradio.ru/srf3_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaf5",
    like: false,
    name: "SRF 4 News",
    url: "https://str.pcradio.ru/srf_4_news-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaf6",
    like: false,
    name: "SRF Musikwelle",
    url: "https://str.pcradio.ru/srf_mw_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaf7",
    like: false,
    name: "SRF Virus",
    url: "https://str.pcradio.ru/srf_virus_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaf8",
    like: false,
    name: "Star FM (Нюрнберг)",
    url: "https://str.pcradio.ru/starm_fm_nuernberg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaf9",
    like: false,
    name: "Star FM (Таллинн)",
    url: "https://str.pcradio.ru/starfm_tallinn-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecafa",
    like: false,
    name: "Star FM Rock Classics",
    url: "https://str.pcradio.ru/starfm_roclass-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecafb",
    like: false,
    name: "Star*Sat Radio",
    url: "https://str.pcradio.ru/starsat_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecafc",
    like: false,
    name: "Stellar Attraction",
    url: "https://str.pcradio.ru/stellar_attraction-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecafd",
    like: false,
    name: "Stevie Ray Vaughan",
    url: "https://str.pcradio.ru/stevie_r_vaughan-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecafe",
    like: false,
    name: "Stevie Wonder",
    url: "https://str.pcradio.ru/stevie_wonder-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecaff",
    like: false,
    name: "Sting",
    url: "https://str.pcradio.ru/sting-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb00",
    like: false,
    name: "Strefa FM",
    url: "https://str.pcradio.ru/strefa_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb01",
    like: false,
    name: "Studio 21",
    url: "https://str.pcradio.ru/studio21_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb02",
    like: false,
    name: "Studio B",
    url: "https://str.pcradio.ru/studiob_rs-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb03",
    like: false,
    name: "Sublime FM",
    url: "https://str.pcradio.ru/sublimefm_nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb04",
    like: false,
    name: "Sud Radio",
    url: "https://str.pcradio.ru/sudradio_fr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb05",
    like: false,
    name: "Sugababes",
    url: "https://str.pcradio.ru/Sugababes-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb06",
    like: false,
    name: "SunAlpes",
    url: "https://str.pcradio.ru/funalpes-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb07",
    like: false,
    name: "Sunrise Radio",
    url: "https://str.pcradio.ru/sunrise_uk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb08",
    like: false,
    name: "Sunshine FM 99.4",
    url: "https://str.pcradio.ru/sunshine_994-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb09",
    like: false,
    name: "sunshine live",
    url: "https://str.pcradio.ru/sunshinelive-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb0a",
    like: false,
    name: "sunshine live - Classics",
    url: "https://str.pcradio.ru/sunshinelive_classics-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb0b",
    like: false,
    name: "sunshine live - Die 80er",
    url: "https://str.pcradio.ru/sunshinelive_80er-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb0c",
    like: false,
    name: "sunshine live - Die 90er",
    url: "https://str.pcradio.ru/sunshinelive_90er-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb0d",
    like: false,
    name: "sunshine live - Drum n Bass",
    url: "https://str.pcradio.ru/sunshinelive_drumnbass-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb0e",
    like: false,
    name: "sunshine live - EDM",
    url: "https://str.pcradio.ru/sunshinelive_edm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb0f",
    like: false,
    name: "sunshine live - Festival",
    url: "https://str.pcradio.ru/sunshinelive_festival-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb10",
    like: false,
    name: "sunshine live - Hands Up",
    url: "https://str.pcradio.ru/sunshinelive_handsup-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb11",
    like: false,
    name: "sunshine live - Hard",
    url: "https://str.pcradio.ru/sunshinelive_hard-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb12",
    like: false,
    name: "sunshine live - House",
    url: "https://str.pcradio.ru/sunshinelive_house-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb13",
    like: false,
    name: "sunshine live - Lounge",
    url: "https://str.pcradio.ru/sunshinelive_lounge-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb14",
    like: false,
    name: "sunshine live - Mayday",
    url: "https://str.pcradio.ru/sunshinelive_mayday-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb15",
    like: false,
    name: "sunshine live - Nature One",
    url: "https://str.pcradio.ru/sunshinelive_natureone-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb16",
    like: false,
    name: "sunshine live - Techno",
    url: "https://str.pcradio.ru/sunshinelive_techno-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb17",
    like: false,
    name: "sunshine live - Time Warp",
    url: "https://str.pcradio.ru/sunshinelive_timewarp-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb18",
    like: false,
    name: "sunshine live - Trance",
    url: "https://str.pcradio.ru/sunshinelive_trance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb19",
    like: false,
    name: "Super FM",
    url: "https://str.pcradio.ru/karnaval_com_superfm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb1a",
    like: false,
    name: "Svensk Pop",
    url: "https://str.pcradio.ru/svensk_pop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb1b",
    like: false,
    name: "Sveriges Radio P1 (SR P1)",
    url: "https://str.pcradio.ru/sveriges_p1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb1c",
    like: false,
    name: "Sveriges Radio P2 Musik (SR P2)",
    url: "https://str.pcradio.ru/sveriges_p2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb1d",
    like: false,
    name: "Sveriges Radio P3 (SR P3)",
    url: "https://str.pcradio.ru/sverige_p3-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb1e",
    like: false,
    name: "Sveriges Radio P4 (SR P4)",
    url: "https://str.pcradio.ru/sveriges_p4-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb1f",
    like: false,
    name: "SWH",
    url: "https://str.pcradio.ru/swh_main-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb20",
    like: false,
    name: "SWH Gold",
    url: "https://str.pcradio.ru/swh_gold-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb21",
    like: false,
    name: "SWH Rock",
    url: "https://str.pcradio.ru/swh_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb22",
    like: false,
    name: "SWH+",
    url: "https://str.pcradio.ru/swh_plus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb23",
    like: false,
    name: "Swiss Internet Radio - Classical",
    url: "https://str.pcradio.ru/swiss_classical-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb24",
    like: false,
    name: "Swiss Pop",
    url: "https://str.pcradio.ru/swisspop_ch-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb25",
    like: false,
    name: "SWR1 Baden-Wuerttemberg",
    url: "https://str.pcradio.ru/swr1_badden-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb26",
    like: false,
    name: "SWR1 Rheinland-Pfalz",
    url: "https://str.pcradio.ru/swr1_rheinland-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb27",
    like: false,
    name: "SWR2",
    url: "https://str.pcradio.ru/swr2_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb28",
    like: false,
    name: "SWR3 Live",
    url: "https://str.pcradio.ru/swr3_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb29",
    like: false,
    name: "SWR3 Lyrix",
    url: "https://str.pcradio.ru/swr3_lyrix-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb2a",
    like: false,
    name: "SWR3 Party",
    url: "https://str.pcradio.ru/swr3_party-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb2b",
    like: false,
    name: "SWR4 Baden-Württemberg",
    url: "https://str.pcradio.ru/swr4_baden-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb2c",
    like: false,
    name: "SWR4 Rheinland-Pfalz",
    url: "https://str.pcradio.ru/swr4_pfalz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb2d",
    like: false,
    name: "SWRinfo",
    url: "https://str.pcradio.ru/swr_info-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb2e",
    like: false,
    name: "Synth Radio",
    url: "https://str.pcradio.ru/synth_radio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb2f",
    like: false,
    name: "System of a Down",
    url: "https://str.pcradio.ru/System_of_a_down-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb30",
    like: false,
    name: "Szent Korona Rádió",
    url: "https://str.pcradio.ru/szent_korona_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb31",
    like: false,
    name: "Szépvíz Rádió",
    url: "https://str.pcradio.ru/szepviz_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb32",
    like: false,
    name: "Südtirol 1",
    url: "https://str.pcradio.ru/suedtirol1_it-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb33",
    like: false,
    name: "T-Rock 103.8 FM",
    url: "https://str.pcradio.ru/t_rock_at-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb34",
    like: false,
    name: "Talisman",
    url: "https://str.pcradio.ru/Talisman-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb35",
    like: false,
    name: "Talk Radio Europe",
    url: "https://str.pcradio.ru/talkeurope_es-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb36",
    like: false,
    name: "TalkRadio",
    url: "https://str.pcradio.ru/talkradio_co_uk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb37",
    like: false,
    name: "Tanz FM",
    url: "https://str.pcradio.ru/tanzfm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb38",
    like: false,
    name: "Tanănana",
    url: "https://str.pcradio.ru/tananana_ro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb39",
    like: false,
    name: "Tapesh",
    url: "https://str.pcradio.ru/tapesh_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb3a",
    like: false,
    name: "Tarja Turunen",
    url: "https://str.pcradio.ru/Tarja_turunen-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb3b",
    like: false,
    name: "Tarkan",
    url: "https://str.pcradio.ru/tarkan-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb3c",
    like: false,
    name: "TDI Classic's",
    url: "https://str.pcradio.ru/tdi_classics-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb3d",
    like: false,
    name: "TDI Crna Gora",
    url: "https://str.pcradio.ru/tdi_crna_gora-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb3e",
    like: false,
    name: "TDI Domacica",
    url: "https://str.pcradio.ru/tdi_domacica-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb3f",
    like: false,
    name: "TDI House",
    url: "https://str.pcradio.ru/tdi_house-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb40",
    like: false,
    name: "TDI Love",
    url: "https://str.pcradio.ru/tdi_love-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb41",
    like: false,
    name: "TDI Radio",
    url: "https://str.pcradio.ru/tdi_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb42",
    like: false,
    name: "TDI Top40",
    url: "https://str.pcradio.ru/tdi_top40-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb43",
    like: false,
    name: "Tech N9ne",
    url: "https://str.pcradio.ru/tech_n9ne-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb44",
    like: false,
    name: "Techno.FM Live",
    url: "https://str.pcradio.ru/techno_fm_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb45",
    like: false,
    name: "Technobase FM",
    url: "https://str.pcradio.ru/technobase_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb46",
    like: false,
    name: "Tel Aviv 102FM",
    url: "https://str.pcradio.ru/telaviv_102fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb47",
    like: false,
    name: "Telstar Radio",
    url: "https://str.pcradio.ru/telstar_laut-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb48",
    like: false,
    name: "TeluguOne Radio TORi",
    url: "https://str.pcradio.ru/telugu_one-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb49",
    like: false,
    name: "TFM",
    url: "https://str.pcradio.ru/tfm_belarus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb4a",
    like: false,
    name: "The 1920s Radio Network",
    url: "https://str.pcradio.ru/the1920s_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb4b",
    like: false,
    name: "The Beat",
    url: "https://str.pcradio.ru/thebeat_no-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb4c",
    like: false,
    name: "The Beatles",
    url: "https://str.pcradio.ru/The_Beatles-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb4d",
    like: false,
    name: "The Big Joe 97.3",
    url: "https://str.pcradio.ru/bigjoe_973-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb4e",
    like: false,
    name: "The Chemodan 18+",
    url: "https://str.pcradio.ru/the_chemodan-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb4f",
    like: false,
    name: "The Corrs",
    url: "https://str.pcradio.ru/The_Corrs-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb50",
    like: false,
    name: "The Current 89.3 (MPR)",
    url: "https://str.pcradio.ru/mpr_current_893-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb51",
    like: false,
    name: "The Disco Palace",
    url: "https://str.pcradio.ru/thediscopalace_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb52",
    like: false,
    name: "The Doors",
    url: "https://str.pcradio.ru/the_doors-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb53",
    like: false,
    name: "The Gun Club",
    url: "https://str.pcradio.ru/The_Gun_Club-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb54",
    like: false,
    name: "The Notorious",
    url: "https://str.pcradio.ru/The_Notorious-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb55",
    like: false,
    name: "The Offspring",
    url: "https://str.pcradio.ru/the_offspring-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb56",
    like: false,
    name: "The Prodigy",
    url: "https://str.pcradio.ru/The_Prodigy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb57",
    like: false,
    name: "The Rap MIXX",
    url: "https://str.pcradio.ru/rap_mixx-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb58",
    like: false,
    name: "The Rasmus",
    url: "https://str.pcradio.ru/the_rasmus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb59",
    like: false,
    name: "The Rock Solid Radio",
    url: "https://str.pcradio.ru/rock_solidradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecb5b",
    like: false,
    name: "This Is Radio",
    url: "https://str.pcradio.ru/this_is_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb5c",
    like: false,
    name: "Three D Radio",
    url: "https://str.pcradio.ru/three_d_au-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb5d",
    like: false,
    name: "Tiesto",
    url: "https://str.pcradio.ru/Tiesto-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb5e",
    like: false,
    name: "Tilos Rádió",
    url: "https://str.pcradio.ru/tilos_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb5f",
    like: false,
    name: "TIM FM 95.7",
    url: "https://str.pcradio.ru/timfm_online-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb60",
    like: false,
    name: "Time To Relax",
    url: "https://str.pcradio.ru/timetorelax_vip-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb61",
    like: false,
    name: "Today Dance Radio",
    url: "https://str.pcradio.ru/todaydance_it-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb62",
    like: false,
    name: "Todo Éxito",
    url: "https://str.pcradio.ru/todoexito_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb63",
    like: false,
    name: "Tok FM",
    url: "https://str.pcradio.ru/tokfm_pl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb64",
    like: false,
    name: "Tokio Hotel",
    url: "https://str.pcradio.ru/tokio_hotel-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb65",
    like: false,
    name: "Tom Waits",
    url: "https://str.pcradio.ru/Tom_Waits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb66",
    like: false,
    name: "Tomorrowland One World Radio",
    url: "https://str.pcradio.ru/tomorrowland_owr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb67",
    like: false,
    name: "Tool Room",
    url: "https://str.pcradio.ru/tool_room_pcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb68",
    like: false,
    name: "Top 100 Russia",
    url: "https://str.pcradio.ru/TOP100RUS-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb69",
    like: false,
    name: "Top 100 Station",
    url: "https://str.pcradio.ru/top100_station-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb6a",
    like: false,
    name: "Top 200",
    url: "https://str.pcradio.ru/Top_200-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb6b",
    like: false,
    name: "Top FM 106.4",
    url: "https://str.pcradio.ru/top_fm_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb6c",
    like: false,
    name: "TOPradio",
    url: "https://str.pcradio.ru/topradio_lv-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb6d",
    like: false,
    name: "TOPradio (Брюссель)",
    url: "https://str.pcradio.ru/topradio_be-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb6e",
    like: false,
    name: "Tori Amos",
    url: "https://str.pcradio.ru/Tori_Amos-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb6f",
    like: false,
    name: "Tormented Radio",
    url: "https://str.pcradio.ru/tormentedradio_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb70",
    like: false,
    name: "Total FM Algarve",
    url: "https://str.pcradio.ru/totalfm_algarve-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb71",
    like: false,
    name: "TotalRock Radio",
    url: "https://str.pcradio.ru/totalrock_uk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb72",
    like: false,
    name: "Toto Cutugno (Тото Кутуньо)",
    url: "https://str.pcradio.ru/Toto_Cutugno-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb73",
    like: false,
    name: "Trance Athens Radio",
    url: "https://str.pcradio.ru/trance_athens-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb74",
    like: false,
    name: "Trance Century Radio",
    url: "https://str.pcradio.ru/trancecentury_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb75",
    like: false,
    name: "Trance Is Star",
    url: "https://str.pcradio.ru/tranceisstar_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb76",
    like: false,
    name: "Trance.one Radio",
    url: "https://str.pcradio.ru/trance_one-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb77",
    like: false,
    name: "TranceBase",
    url: "https://str.pcradio.ru/trancebase_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb78",
    like: false,
    name: "Trap FM",
    url: "https://str.pcradio.ru/trap_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb79",
    like: false,
    name: "Tre Raadio Rapla 91.3",
    url: "https://str.pcradio.ru/rapla_tre_ee-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb7a",
    like: false,
    name: "Trend FM",
    url: "https://str.pcradio.ru/trendfm_hu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb7b",
    like: false,
    name: "Trik Trak Radio",
    url: "https://str.pcradio.ru/triktrak_ca-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb7c",
    like: false,
    name: "Triple R - Rock Rarity Radio",
    url: "https://str.pcradio.ru/triple_r_laut-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb7d",
    like: false,
    name: "Trnavské rádio 103.9 FM",
    url: "https://str.pcradio.ru/trnavske_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb7e",
    like: false,
    name: "TRT Tamil Olli India",
    url: "https://str.pcradio.ru/trt_tamil_olli-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb7f",
    like: false,
    name: "Truckers FM",
    url: "https://str.pcradio.ru/truckers_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb80",
    like: false,
    name: "True Black Metal Radio",
    url: "https://str.pcradio.ru/true_black_metal-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb81",
    like: false,
    name: "TSF Radio Noticias",
    url: "https://str.pcradio.ru/tsf_noticias-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb82",
    like: false,
    name: "Tumar FM",
    url: "https://str.pcradio.ru/tumar_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb83",
    like: false,
    name: "Twisted Sister",
    url: "https://str.pcradio.ru/twisted_sister-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb84",
    like: false,
    name: "U1 Radio Tirol",
    url: "https://str.pcradio.ru/u1_tirol-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb85",
    like: false,
    name: "U105",
    url: "https://str.pcradio.ru/u105_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb86",
    like: false,
    name: "U2",
    url: "https://str.pcradio.ru/u2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecb89",
    like: false,
    name: "Ulitka",
    url: "https://str.pcradio.ru/radio_ulitka-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb8a",
    like: false,
    name: "Ultima.FM",
    url: "https://str.pcradio.ru/ultima_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb8b",
    like: false,
    name: "Ultimate spinach",
    url: "https://str.pcradio.ru/Ultimate-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb8c",
    like: false,
    name: "Ultra",
    url: "https://str.pcradio.ru/radio_ultra-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb8d",
    like: false,
    name: "ultRadio",
    url: "https://str.pcradio.ru/ultradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb8e",
    like: false,
    name: "UltraPlay",
    url: "https://str.pcradio.ru/ultraplay_tk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb8f",
    like: false,
    name: "Uma2rmaH (Уматурман)",
    url: "https://str.pcradio.ru/Uma2rmaH-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb90",
    like: false,
    name: "4",
    url: "https://str.pcradio.ru/unicross_uni-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb91",
    like: false,
    name: "Unika FM",
    url: "https://str.pcradio.ru/unika_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb92",
    like: false,
    name: "UniKid",
    url: "https://str.pcradio.ru/radio_unikid_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb93",
    like: false,
    name: "United FM Radio Jamz",
    url: "https://str.pcradio.ru/unitedfm_jamz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb94",
    like: false,
    name: "United FM Radio Rock and Metal 24.7",
    url: "https://str.pcradio.ru/unitedfm_rockmetal-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb95",
    like: false,
    name: "Unity FM",
    url: "https://str.pcradio.ru/unityfm_nl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb96",
    like: false,
    name: "UnserDing 103.7",
    url: "https://str.pcradio.ru/unserding_1037-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb97",
    like: false,
    name: "unserRadio",
    url: "https://str.pcradio.ru/unserradio_de-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb98",
    like: false,
    name: "UOP - Radio Sertaneja",
    url: "https://str.pcradio.ru/uop_sertaneja-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb99",
    like: false,
    name: "UP FM",
    url: "https://str.pcradio.ru/upfm_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb9a",
    like: false,
    name: "Ural Sound FM",
    url: "https://str.pcradio.ru/uralsound_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb9b",
    like: false,
    name: "Urban Space Radio",
    url: "https://str.pcradio.ru/mjoy_urbansr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb9c",
    like: false,
    name: "Uturn Radio - Drum and Bass",
    url: "https://str.pcradio.ru/uturn_dnb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb9d",
    like: false,
    name: "UZIC - Techno Minimal",
    url: "https://str.pcradio.ru/uzic_techno-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb9e",
    like: false,
    name: "Vanessa-Mae",
    url: "https://str.pcradio.ru/Vanessa_Mae-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecb9f",
    like: false,
    name: "Vangelis",
    url: "https://str.pcradio.ru/vangelis-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecba0",
    like: false,
    name: "Vanilla FM",
    url: "https://str.pcradio.ru/vanilla_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecba1",
    like: false,
    name: "VCY America",
    url: "https://str.pcradio.ru/vcyamerica-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecba2",
    like: false,
    name: "Velvet Acid Christ",
    url: "https://str.pcradio.ru/Velvet_Acid_Christ-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecba3",
    like: false,
    name: "Vem Radio 91.1 FM",
    url: "https://str.pcradio.ru/vem_am-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecba4",
    like: false,
    name: "Venice Classic Radio Auditorium",
    url: "https://str.pcradio.ru/vcr_auditorium-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecba5",
    like: false,
    name: "Venice Classic Radio Live",
    url: "https://str.pcradio.ru/vcr_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecba6",
    like: false,
    name: "Verdure Station",
    url: "https://str.pcradio.ru/verdure_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecba7",
    like: false,
    name: "Versuz Radio",
    url: "https://str.pcradio.ru/versuz_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecba8",
    like: false,
    name: "Vibe FM 88.7",
    url: "https://str.pcradio.ru/vibefm_malta-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecba9",
    like: false,
    name: "Vibe-in Radio",
    url: "https://str.pcradio.ru/vibe_in_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecbaa",
    like: false,
    name: "Viberoom - Beats Radio",
    url: "https://str.pcradio.ru/viberoom_beats-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecbab",
    like: false,
    name: "Vibration Vintage",
    url: "https://str.pcradio.ru/vibration_vint-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecbac",
    like: false,
    name: "Virgin Radio France",
    url: "https://str.pcradio.ru/virgin_france-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecbb7",
    like: false,
    name: "Vocal Chillout",
    url: "https://str.pcradio.ru/vocalchill_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecbb8",
    like: false,
    name: "Vocal Trance FM",
    url: "https://str.pcradio.ru/vocaltrance_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecbb9",
    like: false,
    name: "Vogtland Radio",
    url: "https://str.pcradio.ru/vogtland_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecbba",
    like: false,
    name: "Voice of America",
    url: "https://str.pcradio.ru/voice_of_america-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecbbb",
    like: false,
    name: "Voice of America Persian (VOA)",
    url: "https://str.pcradio.ru/voa_pers-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecbbc",
    like: false,
    name: "Voice of Van",
    url: "https://str.pcradio.ru/voiceofvan_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecbea",
    like: false,
    name: "xRadio",
    url: "https://str.pcradio.ru/xradio_lv-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecbeb",
    like: false,
    name: "XS Manchester 106.1",
    url: "https://str.pcradio.ru/xs_manchester-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecbec",
    like: false,
    name: "Yanni",
    url: "https://str.pcradio.ru/Yanni-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecbed",
    like: false,
    name: "Yello",
    url: "https://str.pcradio.ru/Yello-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc00",
    like: false,
    name: "Zефир FM",
    url: "https://str.pcradio.ru/zefir_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc01",
    like: false,
    name: "А-Студио",
    url: "https://str.pcradio.ru/a_studio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc03",
    like: false,
    name: "АвтоРадио",
    url: "https://str.pcradio.ru/avtoradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc0b",
    like: false,
    name: "Агата Кристи",
    url: "https://str.pcradio.ru/Agata_Kristi-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc0d",
    like: false,
    name: "Аквариум",
    url: "https://str.pcradio.ru/akvarium-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc0e",
    like: false,
    name: "Акула",
    url: "https://str.pcradio.ru/Akula-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc0f",
    like: false,
    name: "Акунин - История Российского государства",
    url: "https://str.pcradio.ru/akunin_history-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc10",
    like: false,
    name: "Акунин - Приключения магистра",
    url: "https://str.pcradio.ru/akunin_magistr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc11",
    like: false,
    name: "Акунин - Приключения Э. Фандорина",
    url: "https://str.pcradio.ru/Akunin_Erast-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc13",
    like: false,
    name: "Акунин - Смерть на брудершафт",
    url: "https://str.pcradio.ru/akunin_brudershaft-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc14",
    like: false,
    name: "Акунин - цикл Жанры",
    url: "https://str.pcradio.ru/akunin_genres-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc15",
    like: false,
    name: "Алания FM",
    url: "https://str.pcradio.ru/alania_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc16",
    like: false,
    name: "Александр Вертинский",
    url: "https://str.pcradio.ru/Aleksandr_Vertinskij-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc17",
    like: false,
    name: "Александр Малинин",
    url: "https://str.pcradio.ru/Malinin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc18",
    like: false,
    name: "Александр Маршал",
    url: "https://str.pcradio.ru/alexandr_marshal-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc19",
    like: false,
    name: "Александр Новиков",
    url: "https://str.pcradio.ru/Aleksandr_Novikov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc1a",
    like: false,
    name: "Александр Розенбаум",
    url: "https://str.pcradio.ru/Aleksandr_Rozenbaum-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc1b",
    like: false,
    name: "Александр Серов",
    url: "https://str.pcradio.ru/alexandr_serov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc1c",
    like: false,
    name: "Алексей Рыбников",
    url: "https://str.pcradio.ru/alexey_rybnikov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc1d",
    like: false,
    name: "Алексин 18+",
    url: "https://str.pcradio.ru/Aleksin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc1e",
    like: false,
    name: "Алена Апина (Комбинация)",
    url: "https://str.pcradio.ru/apina_kombinacia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc1f",
    like: false,
    name: "Алиса",
    url: "https://str.pcradio.ru/Alisa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc20",
    like: false,
    name: "Алла Пугачева",
    url: "https://str.pcradio.ru/Alla_Pugacheva-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc21",
    like: false,
    name: "Алсу",
    url: "https://str.pcradio.ru/Alsu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc22",
    like: false,
    name: "Анатолий Брусникин (Борис Акунин)",
    url: "https://str.pcradio.ru/brusnikin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc23",
    like: false,
    name: "Андрей Бандера",
    url: "https://str.pcradio.ru/Andrej_Bandera-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc24",
    like: false,
    name: "Андрей Губин",
    url: "https://str.pcradio.ru/andrey_gubin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc26",
    like: false,
    name: "Ани Лорак",
    url: "https://str.pcradio.ru/Ani_Lorak-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc27",
    like: false,
    name: "Анна Герман",
    url: "https://str.pcradio.ru/Anna_German-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc28",
    like: false,
    name: "Ансамбль Мещерина (ЭМИ)",
    url: "https://str.pcradio.ru/ansambl_mesherina-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc29",
    like: false,
    name: "Антонио Вивальди",
    url: "https://str.pcradio.ru/Vivaldi-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc2a",
    like: false,
    name: "Апекс-Радио",
    url: "https://str.pcradio.ru/apeks_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc2b",
    like: false,
    name: "Апекс-Радио - Новогоднее",
    url: "https://str.pcradio.ru/apeks_newyear-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc2c",
    like: false,
    name: "Апекс-Радио - Реальное радио",
    url: "https://str.pcradio.ru/apeks_real-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc2d",
    like: false,
    name: "Аплюс Deep",
    url: "https://str.pcradio.ru/aplus_deep-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc30",
    like: false,
    name: "Ария",
    url: "https://str.pcradio.ru/Aria-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc35",
    like: false,
    name: "Архив Радио России",
    url: "https://str.pcradio.ru/radiorus_arc-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc36",
    like: false,
    name: "АссА",
    url: "https://str.pcradio.ru/radioassa_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc37",
    like: false,
    name: "Атаман FM",
    url: "https://str.pcradio.ru/ataman_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc38",
    like: false,
    name: "Атмосфера",
    url: "https://str.pcradio.ru/atmoradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc3b",
    like: false,
    name: "Балтийский Берег",
    url: "https://str.pcradio.ru/baltiyskiy_bereg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc3d",
    like: false,
    name: "Банд’Эрос",
    url: "https://str.pcradio.ru/BandJeros-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc3e",
    like: false,
    name: "0",
    url: "https://str.pcradio.ru/baranovichi_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc3f",
    like: false,
    name: "Баста",
    url: "https://str.pcradio.ru/Basta-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc40",
    like: false,
    name: "Белое Радио",
    url: "https://str.pcradio.ru/beloe_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc42",
    like: false,
    name: "Белый лебедь",
    url: "https://str.pcradio.ru/beliy_lebed-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc43",
    like: false,
    name: "Бессмертный полк",
    url: "https://str.pcradio.ru/bessmert_polk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc44",
    like: false,
    name: "Би-2",
    url: "https://str.pcradio.ru/Bi_2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc45",
    like: false,
    name: "Бизнес FM (Алматы)",
    url: "https://str.pcradio.ru/businessfm_kz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc46",
    like: false,
    name: "8 FM",
    url: "https://str.pcradio.ru/bim_radio1028-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc4c",
    like: false,
    name: "Блестящие",
    url: "https://str.pcradio.ru/blestyashie-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc4e",
    like: false,
    name: "Божья коровка",
    url: "https://str.pcradio.ru/Bozhja_Korovka-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc4f",
    like: false,
    name: "Большая Балашиха",
    url: "https://str.pcradio.ru/bigbalash-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc50",
    like: false,
    name: "Большое радио",
    url: "https://str.pcradio.ru/big_radio_murmansk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc51",
    like: false,
    name: "Борис Моисеев",
    url: "https://str.pcradio.ru/Boris_Moiseev-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc52",
    like: false,
    name: "Борнео",
    url: "https://str.pcradio.ru/borneo_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc53",
    like: false,
    name: "Браво",
    url: "https://str.pcradio.ru/Bravo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc55",
    like: false,
    name: "Братья Грим",
    url: "https://str.pcradio.ru/Bratja_Grim-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc56",
    like: false,
    name: "Братья Карамазовы",
    url: "https://str.pcradio.ru/bratya_karamazovy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc57",
    like: false,
    name: "Бумбокс",
    url: "https://str.pcradio.ru/Bumboks-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc5a",
    like: false,
    name: "БФМ Радио (Нью Йорк)",
    url: "https://str.pcradio.ru/bfmradio_us-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc5b",
    like: false,
    name: "Валерий Леонтьев",
    url: "https://str.pcradio.ru/valery_leontiev-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc5c",
    like: false,
    name: "Валерий Меладзе",
    url: "https://str.pcradio.ru/Valerij_Meladze-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc5d",
    like: false,
    name: "Валерия",
    url: "https://str.pcradio.ru/Valerija-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc5f",
    like: false,
    name: "Варвара",
    url: "https://str.pcradio.ru/Varvara-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc62",
    like: false,
    name: "Вахтанг Кикабидзе",
    url: "https://str.pcradio.ru/Vahtang_Kikabidze-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc64",
    like: false,
    name: "Вежа",
    url: "https://str.pcradio.ru/vezha_org-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc65",
    like: false,
    name: "Верка Cердючка",
    url: "https://str.pcradio.ru/Verka_Serdjuchka-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc66",
    like: false,
    name: "Вести FM",
    url: "https://str.pcradio.ru/radiovesti_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc67",
    like: false,
    name: "Вечерний Бриз",
    url: "https://str.pcradio.ru/vech_breeze-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc68",
    like: false,
    name: "ВИА Гра",
    url: "https://str.pcradio.ru/Viagra-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc69",
    like: false,
    name: "Виктор Королев",
    url: "https://str.pcradio.ru/Koroljov_Viktor-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc6a",
    like: false,
    name: "Виктор Петлюра",
    url: "https://str.pcradio.ru/Viktor_Petljura-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc6b",
    like: false,
    name: "Виктор Салтыков",
    url: "https://str.pcradio.ru/viktor_saltykov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc6c",
    like: false,
    name: "Виктор Третьяков",
    url: "https://str.pcradio.ru/Viktor_Tretjakov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc6d",
    like: false,
    name: "Виктор Цой (Кино)",
    url: "https://str.pcradio.ru/gr_Kino-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc6e",
    like: false,
    name: "Виктори Рок (Victoree)",
    url: "https://str.pcradio.ru/victoree_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc6f",
    like: false,
    name: "Вилган",
    url: "https://str.pcradio.ru/vilgan_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc70",
    like: false,
    name: "Вилли Токарев",
    url: "https://str.pcradio.ru/villi_tokarev-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc71",
    like: false,
    name: "Винтаж",
    url: "https://str.pcradio.ru/Vintazh-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc72",
    like: false,
    name: "Винтаж",
    url: "https://str.pcradio.ru/Vintage-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc73",
    like: false,
    name: "Вирус",
    url: "https://str.pcradio.ru/Virus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc74",
    like: false,
    name: "Витамин FM v.90",
    url: "https://str.pcradio.ru/vitamin_fm_v90-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc75",
    like: false,
    name: "Витамин FM Танцевальный",
    url: "https://str.pcradio.ru/vitamin_fm_dance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc76",
    like: false,
    name: "Витас",
    url: "https://str.pcradio.ru/Vitas-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc77",
    like: false,
    name: "Владивосток FM",
    url: "https://str.pcradio.ru/vladivostok_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc78",
    like: false,
    name: "Владимир Высоцкий",
    url: "https://str.pcradio.ru/Visotskiy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc79",
    like: false,
    name: "Владимир Кузьмин (Динамик)",
    url: "https://str.pcradio.ru/vladimir_kuzmin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc7b",
    like: false,
    name: "Волна FM",
    url: "https://str.pcradio.ru/volnafm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc7c",
    like: false,
    name: "Волна Счастья",
    url: "https://str.pcradio.ru/volna_schastia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc7e",
    like: false,
    name: "Волшебное Радио",
    url: "https://str.pcradio.ru/volshebnoe_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc81",
    like: false,
    name: "Воскресение",
    url: "https://str.pcradio.ru/pravradioru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc82",
    like: false,
    name: "Восток России",
    url: "https://str.pcradio.ru/vostok_rossii-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc85",
    like: false,
    name: "Вячеслав Добрынин",
    url: "https://str.pcradio.ru/Dobrynin_Vjacheslav-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc86",
    like: false,
    name: "Вячеслав Малежик",
    url: "https://str.pcradio.ru/Malegek-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc87",
    like: false,
    name: "Гамаюн",
    url: "https://str.pcradio.ru/raga_rf-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc88",
    like: false,
    name: "Гарик Сукачёв",
    url: "https://str.pcradio.ru/Garik_Sukachov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc89",
    like: false,
    name: "Гималаи",
    url: "https://str.pcradio.ru/himalaya24-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc8c",
    like: false,
    name: "Говорит Москва",
    url: "https://str.pcradio.ru/govoritmoskva_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc91",
    like: false,
    name: "Гомель FM",
    url: "https://str.pcradio.ru/gomelfm_by-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc92",
    like: false,
    name: "7 FM",
    url: "https://str.pcradio.ru/gomelplus_by-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc93",
    like: false,
    name: "4 FM",
    url: "https://str.pcradio.ru/gomel_city_1074-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc94",
    like: false,
    name: "Город 312",
    url: "https://str.pcradio.ru/gorod_312-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc95",
    like: false,
    name: "Город FM",
    url: "https://str.pcradio.ru/gorodfm_org-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc96",
    like: false,
    name: "Город Кудрово",
    url: "https://str.pcradio.ru/gorod_kudrovo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc97",
    like: false,
    name: "Городская волна",
    url: "https://str.pcradio.ru/gorvolna_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc98",
    like: false,
    name: "Горячие головы",
    url: "https://str.pcradio.ru/Gorjachie_golovy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc99",
    like: false,
    name: "Гости из будущего",
    url: "https://str.pcradio.ru/Gosti_is_Budushego-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc9a",
    like: false,
    name: "Град Петров",
    url: "https://str.pcradio.ru/grad_petrov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc9b",
    like: false,
    name: "Гражданская оборона",
    url: "https://str.pcradio.ru/Grazhdanskaja_oborona-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc9c",
    like: false,
    name: "Григорий Лепс",
    url: "https://str.pcradio.ru/Leps-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecc9e",
    like: false,
    name: "Группа Фабрика",
    url: "https://str.pcradio.ru/Fabrika-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecc9f",
    like: false,
    name: "Дала FM",
    url: "https://str.pcradio.ru/dala_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecca0",
    like: false,
    name: "ДДТ",
    url: "https://str.pcradio.ru/DDT-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecca1",
    like: false,
    name: "Дельфин 18+",
    url: "https://str.pcradio.ru/dolphin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecca2",
    like: false,
    name: "Дельфины",
    url: "https://str.pcradio.ru/dolphins_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecca3",
    like: false,
    name: "Денис Майданов",
    url: "https://str.pcradio.ru/denis_maydanov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecca4",
    like: false,
    name: "Детское радио",
    url: "https://str.pcradio.ru/deti_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecca5",
    like: false,
    name: "Детское христианское радио",
    url: "https://str.pcradio.ru/detskoe_christ-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecca6",
    like: false,
    name: "Децл",
    url: "https://str.pcradio.ru/Decl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecca7",
    like: false,
    name: "Дж. Роулинг - Гарри Поттер",
    url: "https://str.pcradio.ru/harry_potter-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecca8",
    like: false,
    name: "Джаз Филармоник Радио",
    url: "https://str.pcradio.ru/jazz_philar-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853eccaa",
    like: false,
    name: "Диалог",
    url: "https://str.pcradio.ru/radio_dialog_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccab",
    like: false,
    name: "Диана Арбенина (Ночные снайперы)",
    url: "https://str.pcradio.ru/nochnye_snaypery_arbenina-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccac",
    like: false,
    name: "Дидюля",
    url: "https://str.pcradio.ru/Didulya-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccad",
    like: false,
    name: "Дима Билан",
    url: "https://str.pcradio.ru/Dima_Bilan-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccae",
    like: false,
    name: "Диполь FM",
    url: "https://str.pcradio.ru/dipol_fm_main-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccaf",
    like: false,
    name: "Диско 80-х",
    url: "https://str.pcradio.ru/e_80-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccb0",
    like: false,
    name: "Дискотека 90х",
    url: "https://str.pcradio.ru/diskoteka90_ucoz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccb1",
    like: false,
    name: "Дискотека Авария",
    url: "https://str.pcradio.ru/Diskoteka_Avaria-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccb2",
    like: false,
    name: "Дискотека в стиле Руки вверх!",
    url: "https://str.pcradio.ru/Diskoteka_v_stile_ruki_v_verh-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccb3",
    like: false,
    name: "Дмитрий Маликов",
    url: "https://str.pcradio.ru/dmitry_malikov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccb4",
    like: false,
    name: "Дон-ТР",
    url: "https://str.pcradio.ru/dontr_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccb5",
    like: false,
    name: "Дорожное",
    url: "https://str.pcradio.ru/dorozhnoe-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccb6",
    like: false,
    name: "Дорожное (Омск)",
    url: "https://str.pcradio.ru/dorozhnoe_omsk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccb7",
    like: false,
    name: "Дорожное (Оренбург)",
    url: "https://str.pcradio.ru/dorozhnoe_oren-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccb8",
    like: false,
    name: "Дорожное - Ностальгия",
    url: "https://str.pcradio.ru/dorozhnoe_nostalgia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccb9",
    like: false,
    name: "Дорожное - Рок-клуб",
    url: "https://str.pcradio.ru/dorozhnoe_rockclub-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccba",
    like: false,
    name: "Дорожное - Танцы по-русски",
    url: "https://str.pcradio.ru/dorozhnoe_rudance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853eccbc",
    like: false,
    name: "Другая Астрахань",
    url: "https://str.pcradio.ru/astrdr_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853eccbe",
    like: false,
    name: "Душа Кавказа",
    url: "https://str.pcradio.ru/dusha_kavkaza-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccbf",
    like: false,
    name: "7 FM",
    url: "https://str.pcradio.ru/dushevnoeradio_by-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccc0",
    like: false,
    name: "Дэн Браун",
    url: "https://str.pcradio.ru/dan_brown-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccc1",
    like: false,
    name: "Дюна",
    url: "https://str.pcradio.ru/Djuna-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853eccc3",
    like: false,
    name: "Европа (Волгоград)",
    url: "https://str.pcradio.ru/evropa_volgograd-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccc4",
    like: false,
    name: "Европа (Кемерово)",
    url: "https://str.pcradio.ru/evropa_kemerovo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccc5",
    like: false,
    name: "Европа (Москва)",
    url: "https://str.pcradio.ru/europa_plus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccc6",
    like: false,
    name: "Европа (Нижний Новгород)",
    url: "https://str.pcradio.ru/evropa_nnov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccc7",
    like: false,
    name: "Европа (Омск)",
    url: "https://str.pcradio.ru/evropa_omsk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccc8",
    like: false,
    name: "Европа (Самара)",
    url: "https://str.pcradio.ru/evropa_samara-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccc9",
    like: false,
    name: "Европа (СПб)",
    url: "https://str.pcradio.ru/evropa_spb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccca",
    like: false,
    name: "Европа Light",
    url: "https://str.pcradio.ru/evropa_light-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecccb",
    like: false,
    name: "Европа New",
    url: "https://str.pcradio.ru/evropa_new-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecccc",
    like: false,
    name: "Европа ResiDance",
    url: "https://str.pcradio.ru/evropa_residance-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecccd",
    like: false,
    name: "Европа RnB",
    url: "https://str.pcradio.ru/evropa_rnb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccce",
    like: false,
    name: "Европа Top40",
    url: "https://str.pcradio.ru/evropa_top40-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853eccd2",
    like: false,
    name: "Елена Ваенга",
    url: "https://str.pcradio.ru/Elena_Vaenga-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853eccd4",
    like: false,
    name: "Жека",
    url: "https://str.pcradio.ru/zheka-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccd5",
    like: false,
    name: "Железо FM 99.0",
    url: "https://str.pcradio.ru/fefm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccd6",
    like: false,
    name: "Женя Белоусов",
    url: "https://str.pcradio.ru/Zhenja_Belousov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853eccd9",
    like: false,
    name: "5 FM",
    url: "https://str.pcradio.ru/zaoblakamiru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccda",
    like: false,
    name: "За облаками Relax",
    url: "https://str.pcradio.ru/zaoblakami_relax-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccdb",
    like: false,
    name: "Зайцев FM - Club",
    url: "https://str.pcradio.ru/electro_zaycev_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccdc",
    like: false,
    name: "Зайцев FM - New Rock",
    url: "https://str.pcradio.ru/newrock_zaycev_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccdd",
    like: false,
    name: "Зайцев FM - Relax",
    url: "https://str.pcradio.ru/relax_zaycev_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccde",
    like: false,
    name: "Зайцев FM - RnB",
    url: "https://str.pcradio.ru/rnb_zaycev_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccdf",
    like: false,
    name: "Зайцев FM - Rus",
    url: "https://str.pcradio.ru/rus_zaycev_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecce0",
    like: false,
    name: "Зайцев FM - Диско",
    url: "https://str.pcradio.ru/disco_zaycev_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecce1",
    like: false,
    name: "Зайцев FM - Поп",
    url: "https://str.pcradio.ru/pop_zaycev_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecce2",
    like: false,
    name: "Зайцев FM - Шансон",
    url: "https://str.pcradio.ru/zaycev_fm_shanson-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecce3",
    like: false,
    name: "Закарпатье",
    url: "https://str.pcradio.ru/zakarpattya_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecce4",
    like: false,
    name: "Западный полюс",
    url: "https://str.pcradio.ru/zapadnyj_poljus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecce5",
    like: false,
    name: "Зара",
    url: "https://str.pcradio.ru/Zara-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecce6",
    like: false,
    name: "Застольные по-новому",
    url: "https://str.pcradio.ru/Narodnie-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecce7",
    like: false,
    name: "Звери",
    url: "https://str.pcradio.ru/Zveri-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecce8",
    like: false,
    name: "Звуки Моря",
    url: "https://str.pcradio.ru/sea_song-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecce9",
    like: false,
    name: "Звуки природы - Nature",
    url: "https://str.pcradio.ru/Priroda-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccea",
    like: false,
    name: "Здоровый сон",
    url: "https://str.pcradio.ru/healthy_sleep-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecceb",
    like: false,
    name: "Земля plus Club",
    url: "https://str.pcradio.ru/earthplus_club-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccec",
    like: false,
    name: "Земфира",
    url: "https://str.pcradio.ru/Zemfira-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecced",
    like: false,
    name: "Зенит",
    url: "https://str.pcradio.ru/zenit_sp-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccee",
    like: false,
    name: "Золотой век",
    url: "https://str.pcradio.ru/zolotoy_setmedia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccef",
    like: false,
    name: "Иван Купала",
    url: "https://str.pcradio.ru/Ivan_Kupala-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccf0",
    like: false,
    name: "Иван Кучин",
    url: "https://str.pcradio.ru/Ivan_Kuchin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccf1",
    like: false,
    name: "Иваново FM",
    url: "https://str.pcradio.ru/ivanovo_1067-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccf2",
    like: false,
    name: "Иванушки International",
    url: "https://str.pcradio.ru/Ivanushki_International-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccf3",
    like: false,
    name: "Игорь Крутой",
    url: "https://str.pcradio.ru/igor_krutoy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccf4",
    like: false,
    name: "Игорь Николаев",
    url: "https://str.pcradio.ru/Igor_Nikolaev-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccf5",
    like: false,
    name: "Игорь Тальков",
    url: "https://str.pcradio.ru/igor_talkov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccf6",
    like: false,
    name: "Игра слов",
    url: "https://str.pcradio.ru/Igra_Slov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853eccf8",
    like: false,
    name: "Импульс FM",
    url: "https://str.pcradio.ru/impuls_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccf9",
    like: false,
    name: "Инструментал ФМ",
    url: "https://str.pcradio.ru/Instrumental_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccfa",
    like: false,
    name: "9 FM (Челябинск)",
    url: "https://str.pcradio.ru/intervolna_che-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccfb",
    like: false,
    name: "Интерволна Next",
    url: "https://str.pcradio.ru/Intervolna_che_next-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccfc",
    like: false,
    name: "Интерра FM",
    url: "https://str.pcradio.ru/interra_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccfd",
    like: false,
    name: "Инфинити",
    url: "https://str.pcradio.ru/Infiniti-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eccfe",
    like: false,
    name: "Информатор FM",
    url: "https://str.pcradio.ru/informator_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecd00",
    like: false,
    name: "Искатель",
    url: "https://str.pcradio.ru/iskatel-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd01",
    like: false,
    name: "Кабриолет",
    url: "https://str.pcradio.ru/Kabriolet-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd02",
    like: false,
    name: "Кабриолет",
    url: "https://str.pcradio.ru/kabriolet_setmedia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd03",
    like: false,
    name: "Казак FM",
    url: "https://str.pcradio.ru/kazak_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd04",
    like: false,
    name: "Казахское радио",
    url: "https://str.pcradio.ru/kazradio_kz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd05",
    like: false,
    name: "Казки (Kazka Radio)",
    url: "https://str.pcradio.ru/kazky_ua-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd06",
    like: false,
    name: "Кай Метов",
    url: "https://str.pcradio.ru/kay_metov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd07",
    like: false,
    name: "Калинов Мост",
    url: "https://str.pcradio.ru/Kalinov_most-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd08",
    like: false,
    name: "Калуш FM 107.4",
    url: "https://str.pcradio.ru/kalush_1074-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd09",
    like: false,
    name: "Кальян FM",
    url: "https://str.pcradio.ru/kalyan_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd0a",
    like: false,
    name: "Канитель",
    url: "https://str.pcradio.ru/kanitelfm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd0b",
    like: false,
    name: "Кар-мэн (Car-Man)",
    url: "https://str.pcradio.ru/car_man-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd0c",
    like: false,
    name: "Карибу-Арт",
    url: "https://str.pcradio.ru/karibu_art-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd0d",
    like: false,
    name: "Карнавал FM 92.8",
    url: "https://str.pcradio.ru/carnavalfmru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd0e",
    like: false,
    name: "Каста",
    url: "https://str.pcradio.ru/Kasta-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd0f",
    like: false,
    name: "Катя Огонёк 18+",
    url: "https://str.pcradio.ru/katya_ogonek-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd10",
    like: false,
    name: "Кекс (Москва)",
    url: "https://str.pcradio.ru/keks_moscow-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd11",
    like: false,
    name: "Кинозал.ТВ Радио",
    url: "https://str.pcradio.ru/kinozal_tv-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd12",
    like: false,
    name: "Киномузыка",
    url: "https://str.pcradio.ru/Kino_music-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd13",
    like: false,
    name: "Кипелов",
    url: "https://str.pcradio.ru/kipelov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd14",
    like: false,
    name: "Классное радио",
    url: "https://str.pcradio.ru/klass_ua-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd15",
    like: false,
    name: "Клетка",
    url: "https://str.pcradio.ru/kletka_verhova-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd16",
    like: false,
    name: "Комета",
    url: "https://str.pcradio.ru/kometa_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd17",
    like: false,
    name: "Комиссар",
    url: "https://str.pcradio.ru/komissar-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd18",
    like: false,
    name: "Коммерсантъ FM",
    url: "https://str.pcradio.ru/kommersant_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecd1a",
    like: false,
    name: "Компот FM",
    url: "https://str.pcradio.ru/kompot_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd1b",
    like: false,
    name: "Комсомольская правда",
    url: "https://str.pcradio.ru/kp_mscow-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecd21",
    like: false,
    name: "Континенталь",
    url: "https://str.pcradio.ru/radiocon_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd22",
    like: false,
    name: "Король и Шут",
    url: "https://str.pcradio.ru/Korol_i_Shut-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd23",
    like: false,
    name: "Коррозия металла",
    url: "https://str.pcradio.ru/korrozia_metalla-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd24",
    like: false,
    name: "Космический Шум",
    url: "https://str.pcradio.ru/cosmic_noise-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd25",
    like: false,
    name: "Краски",
    url: "https://str.pcradio.ru/Kraski-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd26",
    like: false,
    name: "Красная Армия",
    url: "https://str.pcradio.ru/redarmy_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd27",
    like: false,
    name: "Красная плесень 18+",
    url: "https://str.pcradio.ru/Krasnaja_plesen-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd28",
    like: false,
    name: "Красноярск Главный FM 102.8",
    url: "https://str.pcradio.ru/krasno_glavny-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecd2a",
    like: false,
    name: "Крематорий",
    url: "https://str.pcradio.ru/krematoriy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecd32",
    like: false,
    name: "7 FM",
    url: "https://str.pcradio.ru/kurs_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd33",
    like: false,
    name: "Кухня",
    url: "https://str.pcradio.ru/Kuhnja-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecd35",
    like: false,
    name: "Лада FM (Ладыжин)",
    url: "https://str.pcradio.ru/lada_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd36",
    like: false,
    name: "Лариса Черникова",
    url: "https://str.pcradio.ru/Larisa_Chernikova-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd37",
    like: false,
    name: "Ласковый май",
    url: "https://str.pcradio.ru/Laskovyj_maj-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd38",
    like: false,
    name: "Латино",
    url: "https://str.pcradio.ru/Latino-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd39",
    like: false,
    name: "Легенды FM",
    url: "https://str.pcradio.ru/legendy_by-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd3a",
    like: false,
    name: "Легкие Люди",
    url: "https://str.pcradio.ru/legkieludi_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd3b",
    like: false,
    name: "Лезги Радио",
    url: "https://str.pcradio.ru/lezgi_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd3c",
    like: false,
    name: "Ленинград 18+",
    url: "https://str.pcradio.ru/Leningrad-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd3d",
    like: false,
    name: "Леонид Агутин",
    url: "https://str.pcradio.ru/Leonid_Agutin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd3e",
    like: false,
    name: "Леонид Федоров",
    url: "https://str.pcradio.ru/leonid_fedorov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd3f",
    like: false,
    name: "Леприконсы",
    url: "https://str.pcradio.ru/leprikonsy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd40",
    like: false,
    name: "Лесоповал",
    url: "https://str.pcradio.ru/Lesopoval-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd41",
    like: false,
    name: "Линда",
    url: "https://str.pcradio.ru/Linda-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd42",
    like: false,
    name: "7",
    url: "https://str.pcradio.ru/lipetsk_907-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd43",
    like: false,
    name: "Литературное радио",
    url: "https://str.pcradio.ru/litradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd44",
    like: false,
    name: "Лихие 90е",
    url: "https://str.pcradio.ru/lihie90epcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd45",
    like: false,
    name: "Лицей",
    url: "https://str.pcradio.ru/Licej-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd46",
    like: false,
    name: "Лолита",
    url: "https://str.pcradio.ru/Lolita-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd47",
    like: false,
    name: "Лоре",
    url: "https://str.pcradio.ru/lore_asha-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecd49",
    like: false,
    name: "Люба FM",
    url: "https://str.pcradio.ru/lubafmpcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd4a",
    like: false,
    name: "Любимый город",
    url: "https://str.pcradio.ru/lyubimy_gorod-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd4b",
    like: false,
    name: "Любовь Успенская",
    url: "https://str.pcradio.ru/Ljubov_Uspenskaja-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd4c",
    like: false,
    name: "Любэ",
    url: "https://str.pcradio.ru/Lyube-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd4d",
    like: false,
    name: "Люкс ФМ",
    url: "https://str.pcradio.ru/luxfm_ua-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecd4f",
    like: false,
    name: "Ляпис Трубецкой",
    url: "https://str.pcradio.ru/Lyapis_Trubickoy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd50",
    like: false,
    name: "Лёгкое Радио",
    url: "https://str.pcradio.ru/legkoe_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd51",
    like: false,
    name: "Майк Науменко (Зоопарк)",
    url: "https://str.pcradio.ru/zoopark-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd52",
    like: false,
    name: "МакSим",
    url: "https://str.pcradio.ru/MakSim-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd53",
    like: false,
    name: "Макс FM",
    url: "https://str.pcradio.ru/max_fm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd54",
    like: false,
    name: "Максим Леонидов",
    url: "https://str.pcradio.ru/maxim_leonidov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd55",
    like: false,
    name: "Максим Фадеев",
    url: "https://str.pcradio.ru/Maks_Fadeev-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecd57",
    like: false,
    name: "МанифестЪ",
    url: "https://str.pcradio.ru/manifest_vk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd58",
    like: false,
    name: "Мантра",
    url: "https://str.pcradio.ru/radiomantra_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd59",
    like: false,
    name: "Марал Радиосу",
    url: "https://str.pcradio.ru/maralfm_kg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd5a",
    like: false,
    name: "Мария FM (Киров)",
    url: "https://str.pcradio.ru/mariafm_kirov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd5b",
    like: false,
    name: "Маруся FM",
    url: "https://str.pcradio.ru/marusya_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd5c",
    like: false,
    name: "Матрешка",
    url: "https://str.pcradio.ru/matryoshka_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd5d",
    like: false,
    name: "Машенька",
    url: "https://str.pcradio.ru/mashenka-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd5e",
    like: false,
    name: "Машина времени",
    url: "https://str.pcradio.ru/Mashina_Vremeni-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd5f",
    like: false,
    name: "Маяк",
    url: "https://str.pcradio.ru/radiomayak_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd60",
    like: false,
    name: "Маяк (Оренбург)",
    url: "https://str.pcradio.ru/radiomayak_oren-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd61",
    like: false,
    name: "Мега Радио",
    url: "https://str.pcradio.ru/megaradio_pro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd62",
    like: false,
    name: "Мейдан FM",
    url: "https://str.pcradio.ru/meydan_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd63",
    like: false,
    name: "Мелодии века",
    url: "https://str.pcradio.ru/melodii_veka-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd64",
    like: false,
    name: "Мелодия-Воронеж",
    url: "https://str.pcradio.ru/radiomelody_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecd69",
    like: false,
    name: "Мельница",
    url: "https://str.pcradio.ru/melnitsa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd6a",
    like: false,
    name: "4 (Костомукша)",
    url: "https://str.pcradio.ru/mestnoe_1004-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd6b",
    like: false,
    name: "Микс (Луга)",
    url: "https://str.pcradio.ru/luga_rf-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd6c",
    like: false,
    name: "Милицейская Волна",
    url: "https://str.pcradio.ru/radiomv_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd6d",
    like: false,
    name: "Минск",
    url: "https://str.pcradio.ru/radiominsk_by-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd6e",
    like: false,
    name: "Мир (Минск)",
    url: "https://str.pcradio.ru/mir_minsk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd6f",
    like: false,
    name: "Мир Белогорья",
    url: "https://str.pcradio.ru/mir_belogorya-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecd71",
    like: false,
    name: "Мираж",
    url: "https://str.pcradio.ru/Mirazh-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd72",
    like: false,
    name: "Михаил Боярский",
    url: "https://str.pcradio.ru/Mihail_Bojarskij-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd73",
    like: false,
    name: "Михаил Круг",
    url: "https://str.pcradio.ru/Michail_Krug-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd74",
    like: false,
    name: "Михаил Шуфутинский",
    url: "https://str.pcradio.ru/Michail_Shifutinsky-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd75",
    like: false,
    name: "Многоточие 18+",
    url: "https://str.pcradio.ru/Mnogotochie-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd76",
    like: false,
    name: "Модель для сборки 1 - MDS станция",
    url: "https://str.pcradio.ru/mdsst_ru_1-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd77",
    like: false,
    name: "Модель для сборки 2 - MDS станция",
    url: "https://str.pcradio.ru/mdsst_ru_2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd78",
    like: false,
    name: "Модель для сборки 3 - MDS станция",
    url: "https://str.pcradio.ru/mdsst_ru_3-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd79",
    like: false,
    name: "Модное Радио",
    url: "https://str.pcradio.ru/modnoeradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd7a",
    like: false,
    name: "Монте-Карло (Москва)",
    url: "https://str.pcradio.ru/montecarlo_moscow-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd7b",
    like: false,
    name: "Монте-Карло (Санкт-Петербург)",
    url: "https://str.pcradio.ru/montecarlo_spb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd7c",
    like: false,
    name: "Монте-Карло - Bossa Nova",
    url: "https://str.pcradio.ru/montecarlo_bossa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd7d",
    like: false,
    name: "Монте-Карло - France",
    url: "https://str.pcradio.ru/montecarlo_france-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd7e",
    like: false,
    name: "Монте-Карло - Nights",
    url: "https://str.pcradio.ru/montecarlo_nights-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd7f",
    like: false,
    name: "Монте-Карло - Sweet",
    url: "https://str.pcradio.ru/montecarlo_sweet-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd80",
    like: false,
    name: "Монте-Карло - Золотая коллекция",
    url: "https://str.pcradio.ru/montecarlo_gold-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd81",
    like: false,
    name: "Монте-Карло - Музыка без слов",
    url: "https://str.pcradio.ru/montecarlo_instrumental-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd82",
    like: false,
    name: "Монте-Карло - Песни о любви",
    url: "https://str.pcradio.ru/montecarlo_love-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd83",
    like: false,
    name: "Моральный кодекс",
    url: "https://str.pcradio.ru/Moralniy_Kodeks-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd84",
    like: false,
    name: "Море",
    url: "https://str.pcradio.ru/more_simferopol-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd85",
    like: false,
    name: "0",
    url: "https://str.pcradio.ru/moskva920-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd86",
    like: false,
    name: "1 FM",
    url: "https://str.pcradio.ru/moya_udmurt-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd87",
    like: false,
    name: "Музком",
    url: "https://str.pcradio.ru/muzkom_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd88",
    like: false,
    name: "Музыка для массажа",
    url: "https://str.pcradio.ru/massage_music-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd89",
    like: false,
    name: "Мульти-Пульти",
    url: "https://str.pcradio.ru/Kinder-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd8a",
    like: false,
    name: "Мумий Тролль",
    url: "https://str.pcradio.ru/Mumyi_Trol-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd8b",
    like: false,
    name: "Мурзилки Интернешнл",
    url: "https://str.pcradio.ru/Murzilki_International-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd8c",
    like: false,
    name: "Муслим Магомаев",
    url: "https://str.pcradio.ru/Muslim_Magomaev-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecd8e",
    like: false,
    name: "На-На",
    url: "https://str.pcradio.ru/na_na-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd8f",
    like: false,
    name: "Надежда Кадышева",
    url: "https://str.pcradio.ru/Nadezhda_Kadysheva-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd90",
    like: false,
    name: "НАИВ",
    url: "https://str.pcradio.ru/naiv-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd91",
    like: false,
    name: "Найк Борзов 18+",
    url: "https://str.pcradio.ru/nayk_borzov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd92",
    like: false,
    name: "Народное радио",
    url: "https://str.pcradio.ru/narodnoeradio_ee-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd93",
    like: false,
    name: "5 FM",
    url: "https://str.pcradio.ru/narodnoe_radio_1025-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd94",
    like: false,
    name: "Народное Славянское радио",
    url: "https://str.pcradio.ru/slavmir_org-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd95",
    like: false,
    name: "Натали",
    url: "https://str.pcradio.ru/natali-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd96",
    like: false,
    name: "Наташа Королева",
    url: "https://str.pcradio.ru/natasha_koroleva-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd97",
    like: false,
    name: "Наутилус Помпилиус",
    url: "https://str.pcradio.ru/Nautilus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecd99",
    like: false,
    name: "Наше радио (Москва)",
    url: "https://str.pcradio.ru/nashe_moscow-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd9a",
    like: false,
    name: "Наше радио (Пермь)",
    url: "https://str.pcradio.ru/nashe_perm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd9b",
    like: false,
    name: "Наше радио (СПб)",
    url: "https://str.pcradio.ru/nashe_spb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd9c",
    like: false,
    name: "Наше Радио - Классик рок",
    url: "https://str.pcradio.ru/nashe_classic-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd9d",
    like: false,
    name: "Наше Радио - Панки хой!",
    url: "https://str.pcradio.ru/nashe_punks-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd9e",
    like: false,
    name: "Наше Радио - Щас спою",
    url: "https://str.pcradio.ru/nashe_songs-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecd9f",
    like: false,
    name: "Наше радио 2.0",
    url: "https://str.pcradio.ru/nashe20-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecda0",
    like: false,
    name: "Нашествие",
    url: "https://str.pcradio.ru/nashestvie_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecda2",
    like: false,
    name: "Неслучайное Радио",
    url: "https://str.pcradio.ru/nes_rock_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecda3",
    like: false,
    name: "Неформатное Радио",
    url: "https://str.pcradio.ru/neformatnoe_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecda4",
    like: false,
    name: "Ника FM",
    url: "https://str.pcradio.ru/nika_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecda5",
    like: false,
    name: "Никколо Паганини",
    url: "https://str.pcradio.ru/Paganini-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecda6",
    like: false,
    name: "Николай Басков",
    url: "https://str.pcradio.ru/Nikolaj_Baskov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecda7",
    like: false,
    name: "Новая жизнь",
    url: "https://str.pcradio.ru/new_life-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecda8",
    like: false,
    name: "Новое (Вильнюс)",
    url: "https://str.pcradio.ru/russkoe_litva-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecda9",
    like: false,
    name: "Новое Вещание (Liquid Flash)",
    url: "https://str.pcradio.ru/new_veshanie-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdaa",
    like: false,
    name: "Новое Радио (Минск)",
    url: "https://str.pcradio.ru/novoeradio_by-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdab",
    like: false,
    name: "Новое Радио (Молдавия)",
    url: "https://str.pcradio.ru/novoe_md-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdac",
    like: false,
    name: "Новое Радио (Санкт-Петербург)",
    url: "https://str.pcradio.ru/novoe_spb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdad",
    like: false,
    name: "Новое Радио - Top100",
    url: "https://str.pcradio.ru/novoeradio_top-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdae",
    like: false,
    name: "4",
    url: "https://str.pcradio.ru/novoe_radio98_4-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdaf",
    like: false,
    name: "Новый день",
    url: "https://str.pcradio.ru/novy_1019-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdb0",
    like: false,
    name: "Ногу свело!",
    url: "https://str.pcradio.ru/Nogu_Svelo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdb1",
    like: false,
    name: "Нож для фрау Мюллер",
    url: "https://str.pcradio.ru/Noj_Frau_Muller-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdb2",
    like: false,
    name: "Норд FM",
    url: "https://str.pcradio.ru/nordfm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdb3",
    like: false,
    name: "Нэнси",
    url: "https://str.pcradio.ru/Njensi-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdb4",
    like: false,
    name: "Обозреватель - Лирика шансона",
    url: "https://str.pcradio.ru/obozrevatel_lyric_shans-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdb5",
    like: false,
    name: "Обозреватель - Прикольные песни 18+",
    url: "https://str.pcradio.ru/obozrevatel_prikolnye-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdb6",
    like: false,
    name: "Обозреватель - Русский рэп 18+",
    url: "https://str.pcradio.ru/obozrevatel_rusrap-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdb7",
    like: false,
    name: "Обозреватель - Шансон",
    url: "https://str.pcradio.ru/obozrevatel_shanson-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdb8",
    like: false,
    name: "Обозреватель - Эйсид джаз",
    url: "https://str.pcradio.ru/obozrevatel_acidjazz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdb9",
    like: false,
    name: "Образ",
    url: "https://str.pcradio.ru/obraz_nn-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdba",
    like: false,
    name: "Общественное радио Армении",
    url: "https://str.pcradio.ru/armradio_am-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdbb",
    like: false,
    name: "0",
    url: "https://str.pcradio.ru/odessa_mama-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdbc",
    like: false,
    name: "Океан Ельзи",
    url: "https://str.pcradio.ru/Okean_Elzy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdbd",
    like: false,
    name: "Олег Газманов",
    url: "https://str.pcradio.ru/oleg_gazmanov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdbe",
    like: false,
    name: "Олег Митяев",
    url: "https://str.pcradio.ru/oleg_mityaev-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdbf",
    like: false,
    name: "Ольга Арефьева (Ковчег)",
    url: "https://str.pcradio.ru/arefieva_kovcheg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdc0",
    like: false,
    name: "Орену",
    url: "https://str.pcradio.ru/orenu_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdc1",
    like: false,
    name: "Орфей",
    url: "https://str.pcradio.ru/orfey-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdc2",
    like: false,
    name: "Отличное Радио",
    url: "https://str.pcradio.ru/oneex_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdc3",
    like: false,
    name: "Паустовский - Повесть о жизни",
    url: "https://str.pcradio.ru/paustovsky_povest_zhizn-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdc4",
    like: false,
    name: "Пение птиц",
    url: "https://str.pcradio.ru/song_bird-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdc5",
    like: false,
    name: "Первое портальное",
    url: "https://str.pcradio.ru/pervoe_portalnoe-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdc6",
    like: false,
    name: "1",
    url: "https://str.pcradio.ru/pervoe_891-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdc7",
    like: false,
    name: "Первое сетевое",
    url: "https://str.pcradio.ru/pervoesetevoe_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdc8",
    like: false,
    name: "Первый канал Белорусского радио",
    url: "https://str.pcradio.ru/radio1_belarus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdc9",
    like: false,
    name: "Перец FM",
    url: "https://str.pcradio.ru/perec_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdca",
    like: false,
    name: "Петлюра (Ю.Барабаш)",
    url: "https://str.pcradio.ru/petlyura_yuriy_barabash-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdcb",
    like: false,
    name: "Пи ФМ (Pi FM)",
    url: "https://str.pcradio.ru/pifm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdcc",
    like: false,
    name: "Пикник",
    url: "https://str.pcradio.ru/piknik-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdcd",
    like: false,
    name: "Пилот",
    url: "https://str.pcradio.ru/pilot-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdce",
    like: false,
    name: "7 FM",
    url: "https://str.pcradio.ru/pilot_tver-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdcf",
    like: false,
    name: "Пионер FM (Златоуст)",
    url: "https://str.pcradio.ru/pionerfm_zlatoust-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdd0",
    like: false,
    name: "Пионер FM - Dance 9.0",
    url: "https://str.pcradio.ru/pionerfm_90-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdd1",
    like: false,
    name: "Пионер FM - Русская Волна",
    url: "https://str.pcradio.ru/pionerfm_ruwave-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdd2",
    like: false,
    name: "Питер FM 100.9",
    url: "https://str.pcradio.ru/piterfm_1009-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdd3",
    like: false,
    name: "Планка",
    url: "https://str.pcradio.ru/Planka-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdd4",
    like: false,
    name: "Пляж",
    url: "https://str.pcradio.ru/radio_beach_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdd5",
    like: false,
    name: "Подмосковные вечера",
    url: "https://str.pcradio.ru/podmoskov_setmedia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdd6",
    like: false,
    name: "Потап и Настя",
    url: "https://str.pcradio.ru/potap_nastya-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdd7",
    like: false,
    name: "Правда Радио (Гомель)",
    url: "https://str.pcradio.ru/pravda_gomel-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdd8",
    like: false,
    name: "Правильное радио",
    url: "https://str.pcradio.ru/pravilnoe_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdd9",
    like: false,
    name: "Православное Радио",
    url: "https://str.pcradio.ru/pravoslavnoe_radio_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdda",
    like: false,
    name: "Православное радио (СПб)",
    url: "https://str.pcradio.ru/sprusk_spb_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecddb",
    like: false,
    name: "Прибой",
    url: "https://str.pcradio.ru/priboy_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecddc",
    like: false,
    name: "Приключения Электроников",
    url: "https://str.pcradio.ru/priklyuchenia_elektronikov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecddd",
    like: false,
    name: "Приозерск FM",
    url: "https://str.pcradio.ru/priozersk_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdde",
    like: false,
    name: "Пропаганда",
    url: "https://str.pcradio.ru/Propaganda-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecde0",
    like: false,
    name: "Просто Ради.о - Одесса",
    url: "https://str.pcradio.ru/prosto_radio_odessa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecde1",
    like: false,
    name: "Просто Радио 108.0 (Лиепая)",
    url: "https://str.pcradio.ru/prosto_liepaja-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecde2",
    like: false,
    name: "8 FM",
    url: "https://str.pcradio.ru/puls_radio1038-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecde3",
    like: false,
    name: "Пурга",
    url: "https://str.pcradio.ru/radiopurga_org-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecde4",
    like: false,
    name: "Пятница",
    url: "https://str.pcradio.ru/radiopyatnica_com_ua-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecde5",
    like: false,
    name: "Радио - 90е",
    url: "https://str.pcradio.ru/eradiopcradio90_2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecde6",
    like: false,
    name: "Радио 1 (Первое подмосковное)",
    url: "https://str.pcradio.ru/nashe_podmoscow-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecde7",
    like: false,
    name: "Радио 1 (Тирасполь)",
    url: "https://str.pcradio.ru/radio1_tiraspol-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecde8",
    like: false,
    name: "Радио 1 Рок (Radio 1 Rock)",
    url: "https://str.pcradio.ru/rock1_bg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecde9",
    like: false,
    name: "Радио 10 (Петрозаводск)",
    url: "https://str.pcradio.ru/radio10_live-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdea",
    like: false,
    name: "Радио 107",
    url: "https://str.pcradio.ru/radio107_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdeb",
    like: false,
    name: "Радио 2 106.3 FM",
    url: "https://str.pcradio.ru/radio2_komsomol-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdec",
    like: false,
    name: "Радио 21",
    url: "https://str.pcradio.ru/radio_21_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecded",
    like: false,
    name: " Архангельск)",
    url: "https://str.pcradio.ru/r29_arkh-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdee",
    like: false,
    name: "1",
    url: "https://str.pcradio.ru/twobytwo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdef",
    like: false,
    name: "Радио 40",
    url: "https://str.pcradio.ru/radio_sorok-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdf0",
    like: false,
    name: "Радио 53 (Великий Новгород)",
    url: "https://str.pcradio.ru/radio53_vn-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdf1",
    like: false,
    name: "2 FM)",
    url: "https://str.pcradio.ru/radio54_1062fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdf2",
    like: false,
    name: "Радио 7",
    url: "https://str.pcradio.ru/radio7_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdf3",
    like: false,
    name: "Радио 7 (Семей)",
    url: "https://str.pcradio.ru/radio7_kz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdf4",
    like: false,
    name: "Радио 7 - Наедине с музыкой",
    url: "https://str.pcradio.ru/radio7_alone-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdf5",
    like: false,
    name: "Радио 7 - Настроение любить",
    url: "https://str.pcradio.ru/radio7_love-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdf6",
    like: false,
    name: "Радио 7 - Настроение счастья",
    url: "https://str.pcradio.ru/radio7_happy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdf7",
    like: false,
    name: "Радио 80s Hits",
    url: "https://str.pcradio.ru/Hits80-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdf8",
    like: false,
    name: "Радио Best",
    url: "https://str.pcradio.ru/radiobest_media-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdf9",
    like: false,
    name: "Радио Disney",
    url: "https://str.pcradio.ru/radio_disney_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdfa",
    like: false,
    name: "Радио Doodle",
    url: "https://str.pcradio.ru/Doodle-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdfb",
    like: false,
    name: "8 (Нижний Новгород)",
    url: "https://str.pcradio.ru/nrg_nn-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdfc",
    like: false,
    name: "Радио Jazz 89.1",
    url: "https://str.pcradio.ru/jazz_891-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdfd",
    like: false,
    name: "Радио Jazz 89.1 - Classic",
    url: "https://str.pcradio.ru/jazz_891_classic-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdfe",
    like: false,
    name: "Радио Jazz 89.1 - Legends",
    url: "https://str.pcradio.ru/jazz_891_legends-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecdff",
    like: false,
    name: "Радио Jazz 89.1 - Smooth",
    url: "https://str.pcradio.ru/jazz_891_smooth-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece00",
    like: false,
    name: "Радио Jazz 89.1 - Vocals",
    url: "https://str.pcradio.ru/jazz_891_vocals-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece01",
    like: false,
    name: "Радио mCm",
    url: "https://str.pcradio.ru/mcm_irkutsk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece02",
    like: false,
    name: "Радио New Age",
    url: "https://str.pcradio.ru/New_Age-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece03",
    like: false,
    name: "Радио NS",
    url: "https://str.pcradio.ru/nskz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece04",
    like: false,
    name: "Радио Nu Jazz",
    url: "https://str.pcradio.ru/Nu_Jazz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece05",
    like: false,
    name: "Радио Premium",
    url: "https://str.pcradio.ru/rpfm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece06",
    like: false,
    name: "Радио Record",
    url: "https://str.pcradio.ru/radiorecord_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ece08",
    like: false,
    name: "Радио Relax - Relax International",
    url: "https://str.pcradio.ru/radiorelax_ua_nature-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece09",
    like: false,
    name: "Радио Relax - Музыка без слов",
    url: "https://str.pcradio.ru/radiorelax_ua_instrumental-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece0a",
    like: false,
    name: "Радио VBC",
    url: "https://str.pcradio.ru/radiovbc_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece0b",
    like: false,
    name: "Радио Zefirot",
    url: "https://str.pcradio.ru/zefirot_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece0c",
    like: false,
    name: "Радио Ангелов",
    url: "https://str.pcradio.ru/angelsradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece0d",
    like: false,
    name: "Радио АСТВ",
    url: "https://str.pcradio.ru/astv_sahalin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece0e",
    like: false,
    name: "Радио Беларусь FM",
    url: "https://str.pcradio.ru/belarus_by_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece0f",
    like: false,
    name: "Радио Беларусь Онлайн",
    url: "https://str.pcradio.ru/belarus_by_online-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece10",
    like: false,
    name: "Радио Берег - Евангелие",
    url: "https://str.pcradio.ru/radiobereg_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece11",
    like: false,
    name: "Радио Берег - Песни",
    url: "https://str.pcradio.ru/radiobereg_pesni-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece12",
    like: false,
    name: "Радио Берег - Повествования",
    url: "https://str.pcradio.ru/radiobereg_besedy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece13",
    like: false,
    name: "Радио Би Эй",
    url: "https://str.pcradio.ru/radio_ba-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece14",
    like: false,
    name: "Радио Благо",
    url: "https://str.pcradio.ru/radioblago_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece15",
    like: false,
    name: "Радио Благовестие",
    url: "https://str.pcradio.ru/radio_blagovestie-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece16",
    like: false,
    name: "Радио Благовещение",
    url: "https://str.pcradio.ru/radioblagoveshchenie_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece17",
    like: false,
    name: "Радио Болид 88.0 FM (Bolid)",
    url: "https://str.pcradio.ru/bolid_perm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece18",
    like: false,
    name: "8 FM",
    url: "https://str.pcradio.ru/radiobrest_by-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece19",
    like: false,
    name: "Радио Булбул",
    url: "https://str.pcradio.ru/bulbul_kz-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece1a",
    like: false,
    name: "Радио Ваня (Иваново)",
    url: "https://str.pcradio.ru/radio_vanya-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece1b",
    like: false,
    name: "Радио Ваня (Москва)",
    url: "https://str.pcradio.ru/vanya_moscow-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece1c",
    like: false,
    name: "Радио Вера",
    url: "https://str.pcradio.ru/radiovera_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece1d",
    like: false,
    name: "Радио ВТСУ (VTSU)",
    url: "https://str.pcradio.ru/vtsu_org_ua-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece1e",
    like: false,
    name: "Радио Вышка",
    url: "https://str.pcradio.ru/vyshka24_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece1f",
    like: false,
    name: "Радио Германия",
    url: "https://str.pcradio.ru/radiogermanijade-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece20",
    like: false,
    name: "Радио Глаголь",
    url: "https://str.pcradio.ru/radioglagol_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece21",
    like: false,
    name: "Радио Город (Владикавказ)",
    url: "https://str.pcradio.ru/kavkaz_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece22",
    like: false,
    name: "Радио Гродно",
    url: "https://str.pcradio.ru/radio_grodno-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece23",
    like: false,
    name: "Радио Дагестан",
    url: "https://str.pcradio.ru/dagestan_005-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece24",
    like: false,
    name: "Радио День",
    url: "https://str.pcradio.ru/radioday_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece25",
    like: false,
    name: "Радио Диджей",
    url: "https://str.pcradio.ru/DJ-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece26",
    like: false,
    name: "Радио для двоих",
    url: "https://str.pcradio.ru/rddfm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece27",
    like: false,
    name: "Радио для друзей",
    url: "https://str.pcradio.ru/radio4d_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece28",
    like: false,
    name: "Радио Инмедиа",
    url: "https://str.pcradio.ru/inmedia_site-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece29",
    like: false,
    name: "Радио Инструментал",
    url: "https://str.pcradio.ru/Instrumental-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece2a",
    like: false,
    name: "Радио Кавказ",
    url: "https://str.pcradio.ru/kavkaz_005-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece2b",
    like: false,
    name: "Радио Канон",
    url: "https://str.pcradio.ru/radio_kanon-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece2c",
    like: false,
    name: "Радио Карл",
    url: "https://str.pcradio.ru/karl_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece2d",
    like: false,
    name: "Радио Картина",
    url: "https://str.pcradio.ru/radio_kartina_tv-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ece2f",
    like: false,
    name: "Радио Классик",
    url: "https://str.pcradio.ru/radio_classic-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece30",
    like: false,
    name: "Радио КН (Костанай)",
    url: "https://str.pcradio.ru/kn_kostanay-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece31",
    like: false,
    name: "Радио Книга",
    url: "https://str.pcradio.ru/radiokniga_com-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece32",
    like: false,
    name: "Радио Контур",
    url: "https://str.pcradio.ru/radiokontur_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece33",
    like: false,
    name: "Радио Крым",
    url: "https://str.pcradio.ru/crimea_1tv-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece34",
    like: false,
    name: "Радио Культура",
    url: "https://str.pcradio.ru/rcult-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece35",
    like: false,
    name: "Радио Лайн",
    url: "https://str.pcradio.ru/radioline24_info-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece36",
    like: false,
    name: "Радио Линия",
    url: "https://str.pcradio.ru/radio_liniya-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece37",
    like: false,
    name: "Радио Лисица",
    url: "https://str.pcradio.ru/lisitsa_myrh-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece38",
    like: false,
    name: "Радио Мария",
    url: "https://str.pcradio.ru/radiomaria_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ece3a",
    like: false,
    name: "Радио Мегахит",
    url: "https://str.pcradio.ru/megahit_online-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece3b",
    like: false,
    name: "Радио Междугородье",
    url: "https://str.pcradio.ru/mgradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece3c",
    like: false,
    name: "Радио Мир",
    url: "https://str.pcradio.ru/radiomir_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece3d",
    like: false,
    name: "Радио Могилев",
    url: "https://str.pcradio.ru/mogilev_by-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece3e",
    like: false,
    name: "Радио Мост",
    url: "https://str.pcradio.ru/radiomost-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece3f",
    like: false,
    name: "Радио Мята",
    url: "https://str.pcradio.ru/myata_asha-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece40",
    like: false,
    name: "Радио Надыма",
    url: "https://str.pcradio.ru/nadym_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece41",
    like: false,
    name: "Радио Нестандарт",
    url: "https://str.pcradio.ru/radionestandart_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece42",
    like: false,
    name: "Радио Новый Завет (совр. перевод)",
    url: "https://str.pcradio.ru/nov_zavet_ruwor-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece43",
    like: false,
    name: "Радио Пассаж",
    url: "https://str.pcradio.ru/radio_passazh-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece44",
    like: false,
    name: "Радио Петербург",
    url: "https://str.pcradio.ru/radio_peterburg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece45",
    like: false,
    name: "Радио Пилигрим - Библия",
    url: "https://str.pcradio.ru/piligrim_bible-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece46",
    like: false,
    name: "Радио Пилигрим - Музыка",
    url: "https://str.pcradio.ru/piligrim_music-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece47",
    like: false,
    name: "Радио Пилигрим - Онлайн вещание",
    url: "https://str.pcradio.ru/piligrim_online-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ece49",
    like: false,
    name: "Радио Приднестровья (Тирасполь)",
    url: "https://str.pcradio.ru/radio_pridnestr-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece4a",
    like: false,
    name: "Радио Природа",
    url: "https://str.pcradio.ru/nature_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ece4c",
    like: false,
    name: "Радио Радио",
    url: "https://str.pcradio.ru/radioradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ece4f",
    like: false,
    name: "Радио Рекорд (Саратов)",
    url: "https://str.pcradio.ru/record_saratov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece50",
    like: false,
    name: "Радио Родных Дорог",
    url: "https://str.pcradio.ru/rodnyh_dorog-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece51",
    like: false,
    name: "Радио Рокс (Санкт-Петербург)",
    url: "https://str.pcradio.ru/roks_spb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece52",
    like: false,
    name: "Радио России",
    url: "https://str.pcradio.ru/radiorus_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece53",
    like: false,
    name: "Радио России (Иркутск)",
    url: "https://str.pcradio.ru/radiorus_irk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece54",
    like: false,
    name: "Радио России (Нижний Новгород)",
    url: "https://str.pcradio.ru/russiafm_nn-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece55",
    like: false,
    name: "Радио России (Оренбург)",
    url: "https://str.pcradio.ru/radiorus_oren-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece56",
    like: false,
    name: "Радио России (Санкт Петербург)",
    url: "https://str.pcradio.ru/gtrk_spb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece57",
    like: false,
    name: "Радио России (Тамбов)",
    url: "https://str.pcradio.ru/gtrk_tambov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece58",
    like: false,
    name: "Радио России (Хабаровск)",
    url: "https://str.pcradio.ru/gtrk_habar-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece59",
    like: false,
    name: "Радио России (Чита)",
    url: "https://str.pcradio.ru/gtrkchita_rossia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece5a",
    like: false,
    name: "Радио России - Южный Урал",
    url: "https://str.pcradio.ru/radiorus_uural-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece5b",
    like: false,
    name: "Радио России Башкортостан",
    url: "https://str.pcradio.ru/gtrk_bashkor-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece5c",
    like: false,
    name: "Радио России Урал",
    url: "https://str.pcradio.ru/gtrk_ural-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece5d",
    like: false,
    name: "Радио Ростова",
    url: "https://str.pcradio.ru/radio_rostova-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece5e",
    like: false,
    name: "Радио Русь",
    url: "https://str.pcradio.ru/radio_rus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece5f",
    like: false,
    name: "Радио Сибирь (Томск)",
    url: "https://str.pcradio.ru/tomsk_radiosibir-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece60",
    like: false,
    name: "Радио СССР",
    url: "https://str.pcradio.ru/SSSR-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece61",
    like: false,
    name: "Радио Сталинград",
    url: "https://str.pcradio.ru/stalingrad-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece62",
    like: false,
    name: "Радио Странствий",
    url: "https://str.pcradio.ru/stranstvy_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece63",
    like: false,
    name: "Радио Трасса",
    url: "https://str.pcradio.ru/rtrassa_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece64",
    like: false,
    name: "Радио Уфалея",
    url: "https://str.pcradio.ru/radio_ufaleya-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece65",
    like: false,
    name: "Радио Фантастики",
    url: "https://str.pcradio.ru/radio_fantastiki-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece66",
    like: false,
    name: "Радио ФМ Горный 101.6",
    url: "https://str.pcradio.ru/gorny_1016-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece67",
    like: false,
    name: "Радио Хит (Орск)",
    url: "https://str.pcradio.ru/hit_radio_orsk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece68",
    like: false,
    name: "Радио Хиты 90х",
    url: "https://str.pcradio.ru/i_love_90_pcradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece69",
    like: false,
    name: "Радио Чат Дыхание",
    url: "https://str.pcradio.ru/chat_breathing-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece6a",
    like: false,
    name: "Радио ШОК",
    url: "https://str.pcradio.ru/radioshockru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece6b",
    like: false,
    name: "Радио Эрмитаж",
    url: "https://str.pcradio.ru/radio_hermitage-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece6c",
    like: false,
    name: "Радио Юность",
    url: "https://str.pcradio.ru/yunost_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece6d",
    like: false,
    name: "Радио Юность - ЮFM (Москва)",
    url: "https://str.pcradio.ru/ufm_moscow_off-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece6e",
    like: false,
    name: "Радио Юность-ЮFM",
    url: "https://str.pcradio.ru/yunost_ufm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece6f",
    like: false,
    name: "Радио Юрган",
    url: "https://str.pcradio.ru/yurgan_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece70",
    like: false,
    name: "Радио-3 (Омск)",
    url: "https://str.pcradio.ru/omsk_3-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ece73",
    like: false,
    name: "Радио-Н (Новочеркасск)",
    url: "https://str.pcradio.ru/nradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece74",
    like: false,
    name: "Радио-Радио",
    url: "https://str.pcradio.ru/radio_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece75",
    like: false,
    name: "Радиогазета Слово",
    url: "https://str.pcradio.ru/radioslovo_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece76",
    like: false,
    name: "РадиоГора",
    url: "https://str.pcradio.ru/gora_aldan-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece77",
    like: false,
    name: "Радиоканал Мелодия",
    url: "https://str.pcradio.ru/melodia_spb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece78",
    like: false,
    name: "0 FM (Саратов)",
    url: "https://str.pcradio.ru/radiola_saratov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece79",
    like: false,
    name: "2 FM",
    url: "https://str.pcradio.ru/radiola_1062-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece7a",
    like: false,
    name: "3 FM (Самара)",
    url: "https://str.pcradio.ru/radiola_samara-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece7b",
    like: false,
    name: "4 (Нижний Новгород)",
    url: "https://str.pcradio.ru/radiola_964-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece7c",
    like: false,
    name: "Радиус FM",
    url: "https://str.pcradio.ru/radius_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ece87",
    like: false,
    name: "Ранетки",
    url: "https://str.pcradio.ru/Ranetki-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece88",
    like: false,
    name: "Рассветное радио",
    url: "https://str.pcradio.ru/rassvetnoe_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece89",
    like: false,
    name: "Редкие Рыбы 18+",
    url: "https://str.pcradio.ru/redkie_ryby-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ece8b",
    like: false,
    name: "Ретро FM (Москва)",
    url: "https://str.pcradio.ru/retrofm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece8c",
    like: false,
    name: "Ретро FM (Москва) - 70е",
    url: "https://str.pcradio.ru/retrofm_ru_70s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece8d",
    like: false,
    name: "Ретро FM (Москва) - 80е",
    url: "https://str.pcradio.ru/retrofm_ru_80s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece8e",
    like: false,
    name: "Ретро FM (Москва) - 90е",
    url: "https://str.pcradio.ru/retrofm_ru_90s-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece8f",
    like: false,
    name: "Ретро FM (Москва) - Вечеринка Ретро FM",
    url: "https://str.pcradio.ru/retrofm_mos_vech-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece90",
    like: false,
    name: "Ретро FM (Москва) - Сан-ремо",
    url: "https://str.pcradio.ru/retrofm_mos_sanremo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece91",
    like: false,
    name: "Ретро FM (Омск)",
    url: "https://str.pcradio.ru/retrofm_omsk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece92",
    like: false,
    name: "Ретро FM (Санкт-Петербург)",
    url: "https://str.pcradio.ru/retrofm_spb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ece96",
    like: false,
    name: "Рефлекс",
    url: "https://str.pcradio.ru/Reflex-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece97",
    like: false,
    name: "Рок Легенды",
    url: "https://str.pcradio.ru/Rock_Legend-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece98",
    like: false,
    name: "Рок-Острова",
    url: "https://str.pcradio.ru/Rok_Ostrova-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ece9b",
    like: false,
    name: "Роман Трахтенберг 18+",
    url: "https://str.pcradio.ru/Roman_Trakhtenberg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece9c",
    like: false,
    name: "Руки Вверх",
    url: "https://str.pcradio.ru/Ruki_Vverh-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ece9d",
    like: false,
    name: "Русская Волна",
    url: "https://str.pcradio.ru/ruvolna-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ece9f",
    like: false,
    name: "Русские Песни",
    url: "https://str.pcradio.ru/rusongsru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecea0",
    like: false,
    name: "Русский Берлин",
    url: "https://str.pcradio.ru/russkij_berlin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecea2",
    like: false,
    name: "Русский размер",
    url: "https://str.pcradio.ru/Russkij_Razmer-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecea3",
    like: false,
    name: "Русский Рок",
    url: "https://str.pcradio.ru/Rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecea4",
    like: false,
    name: "Русский рок",
    url: "https://str.pcradio.ru/russkiy_rock-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecea5",
    like: false,
    name: "Русский Рэп 18+",
    url: "https://str.pcradio.ru/Rap-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecea6",
    like: false,
    name: "Русское",
    url: "https://str.pcradio.ru/rusradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecea9",
    like: false,
    name: "Русское - Детский канал",
    url: "https://str.pcradio.ru/rusradio_deti-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eceaa",
    like: false,
    name: "Русское - Золотой Граммофон",
    url: "https://str.pcradio.ru/russkoe_zg-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eceab",
    like: false,
    name: "Русское - Кино",
    url: "https://str.pcradio.ru/russkoe_kino-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eceac",
    like: false,
    name: "6 (Таллинн)",
    url: "https://str.pcradio.ru/russkoe_estonia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecead",
    like: false,
    name: "Русское FM",
    url: "https://str.pcradio.ru/russkoe_vk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eceae",
    like: false,
    name: "Русское Кино",
    url: "https://str.pcradio.ru/russian_cinema-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eceaf",
    like: false,
    name: "Русское Молдова",
    url: "https://str.pcradio.ru/ruradio_md-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eceb0",
    like: false,
    name: "Русское Радио Азия",
    url: "https://str.pcradio.ru/rusradio_asia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853eceb5",
    like: false,
    name: "Самарское Губернское Радио (Губерния)",
    url: "https://str.pcradio.ru/guberniafm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eceb6",
    like: false,
    name: "Света",
    url: "https://str.pcradio.ru/Sveta-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eceb7",
    like: false,
    name: "Светлое радио Еммануил",
    url: "https://str.pcradio.ru/svitle_org-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853eceba",
    like: false,
    name: "Свое FM",
    url: "https://str.pcradio.ru/svoe_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecebc",
    like: false,
    name: "Своя Волна",
    url: "https://str.pcradio.ru/sv_narod-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecebd",
    like: false,
    name: "Севастополь FM",
    url: "https://str.pcradio.ru/sevastopol_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecebe",
    like: false,
    name: "5",
    url: "https://str.pcradio.ru/sever_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecebf",
    like: false,
    name: "Секрет",
    url: "https://str.pcradio.ru/sekret-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecec0",
    like: false,
    name: "Сектор газа 18+",
    url: "https://str.pcradio.ru/Sector_Gaza-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecec1",
    like: false,
    name: "Сектор Газовой Атаки 18+",
    url: "https://str.pcradio.ru/sector_gazovoy_ataki-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecec2",
    like: false,
    name: "Сергей Бабкин (5’nizza)",
    url: "https://str.pcradio.ru/babkin_5nizza-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecec3",
    like: false,
    name: "Сергей Галанин (СерьГа)",
    url: "https://str.pcradio.ru/serga_galanin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecec4",
    like: false,
    name: "Сергей Минаев",
    url: "https://str.pcradio.ru/sergey_minaev-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecec5",
    like: false,
    name: "Сергей Трофимов",
    url: "https://str.pcradio.ru/Sergej_trofimov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecec6",
    like: false,
    name: "Серебро",
    url: "https://str.pcradio.ru/Serebro-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecec7",
    like: false,
    name: "Сити Эдем",
    url: "https://str.pcradio.ru/cityeden_info-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecec8",
    like: false,
    name: "Сказки для детей",
    url: "https://str.pcradio.ru/Skazki-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecec9",
    like: false,
    name: "9 FM (Орша)",
    url: "https://str.pcradio.ru/skif_orsha-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ececa",
    like: false,
    name: "Скрябин",
    url: "https://str.pcradio.ru/skryabin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ececb",
    like: false,
    name: "Смысловые галлюцинации",
    url: "https://str.pcradio.ru/smyslovye_galuyc-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ececc",
    like: false,
    name: "Соликамск FM 100.5",
    url: "https://str.pcradio.ru/solikamsk_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ececd",
    like: false,
    name: "Соль FM (Соликамск)",
    url: "https://str.pcradio.ru/sol_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecece",
    like: false,
    name: "София Ротару",
    url: "https://str.pcradio.ru/sofia_rotaru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ececf",
    like: false,
    name: "Сплин",
    url: "https://str.pcradio.ru/Splin-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eced0",
    like: false,
    name: "Спокойное радио",
    url: "https://str.pcradio.ru/spokoinoeradioru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eced1",
    like: false,
    name: "Справедливая Россия",
    url: "https://str.pcradio.ru/spravedlivo-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eced2",
    like: false,
    name: "Спутник",
    url: "https://str.pcradio.ru/sputnik_ria_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eced3",
    like: false,
    name: "0 (Уфа)",
    url: "https://str.pcradio.ru/sputnik_ufa-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853eced6",
    like: false,
    name: "Старое Доброе Радио",
    url: "https://str.pcradio.ru/staroedobroe_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eced7",
    like: false,
    name: "Старое радио",
    url: "https://str.pcradio.ru/staroe_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eced8",
    like: false,
    name: "Старое радио - Детское",
    url: "https://str.pcradio.ru/staroe_deti-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eced9",
    like: false,
    name: "Старое радио - Музыка",
    url: "https://str.pcradio.ru/staroe_music-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eceda",
    like: false,
    name: "Старт FM 104.5",
    url: "https://str.pcradio.ru/start_saransk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecedb",
    like: false,
    name: "7 FM",
    url: "https://str.pcradio.ru/stvradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecedc",
    like: false,
    name: "Стимул",
    url: "https://str.pcradio.ru/stimul_yur-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecedd",
    like: false,
    name: "Страна FM 102.0 (Санкт-Петербург)",
    url: "https://str.pcradio.ru/strana_spb-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecedf",
    like: false,
    name: "Стрелки",
    url: "https://str.pcradio.ru/strelki-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecee1",
    like: false,
    name: "Стругацкие - Аудиоспектакли",
    url: "https://str.pcradio.ru/strugat_audioshows-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecee6",
    like: false,
    name: "Танцевальная Станция",
    url: "https://str.pcradio.ru/tds_my70_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecee7",
    like: false,
    name: "Танцевальный рай",
    url: "https://str.pcradio.ru/Tancevalnyj_raj-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecee8",
    like: false,
    name: "Танцы Минус",
    url: "https://str.pcradio.ru/tancy_minus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecee9",
    like: false,
    name: "Таня Буланова",
    url: "https://str.pcradio.ru/Bulanova-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eceea",
    like: false,
    name: "Тараканы!",
    url: "https://str.pcradio.ru/tarakany-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853eceec",
    like: false,
    name: "Тату (t.A.T.u.)",
    url: "https://str.pcradio.ru/Tatu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853eceee",
    like: false,
    name: "Твой день",
    url: "https://str.pcradio.ru/tvoyden_myrh-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853eceef",
    like: false,
    name: "Твоё радио",
    url: "https://str.pcradio.ru/clubraysl_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecef1",
    like: false,
    name: "Теос",
    url: "https://str.pcradio.ru/radioteos-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecef2",
    like: false,
    name: "Теплое Радио",
    url: "https://str.pcradio.ru/teploe_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecef3",
    like: false,
    name: "Технология",
    url: "https://str.pcradio.ru/tehnologia-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecef4",
    like: false,
    name: "Тимати",
    url: "https://str.pcradio.ru/Timati-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecef5",
    like: false,
    name: "Типичное FM",
    url: "https://str.pcradio.ru/tipichnoe-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecef6",
    like: false,
    name: "Топ40",
    url: "https://str.pcradio.ru/Top_40-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecef7",
    like: false,
    name: "ТрансМировое радио Беларусь (TWR)",
    url: "https://str.pcradio.ru/twr_belarus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecef9",
    like: false,
    name: " TWR)",
    url: "https://str.pcradio.ru/twr_ua-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853eceff",
    like: false,
    name: "Унесенные ветром",
    url: "https://str.pcradio.ru/Unesennye_vetrom-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecf01",
    like: false,
    name: "Фактор-2 18+",
    url: "https://str.pcradio.ru/Faktor_2-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf02",
    like: false,
    name: "Феникс FM",
    url: "https://str.pcradio.ru/phoenixfm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf03",
    like: false,
    name: "6 (Полезное радио)",
    url: "https://str.pcradio.ru/feo_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf04",
    like: false,
    name: "Филипп Киркоров",
    url: "https://str.pcradio.ru/Filpp_Kirkorov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf05",
    like: false,
    name: "ФМ-на-Дону",
    url: "https://str.pcradio.ru/fm_na_donu-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf06",
    like: false,
    name: "Форум",
    url: "https://str.pcradio.ru/Forum-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf07",
    like: false,
    name: "Французская музыка",
    url: "https://str.pcradio.ru/France-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf08",
    like: false,
    name: "Фристайл",
    url: "https://str.pcradio.ru/Fristajl-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf09",
    like: false,
    name: "Забей 18+",
    url: "https://str.pcradio.ru/Hui_Zabey-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf0a",
    like: false,
    name: "Хайп FM",
    url: "https://str.pcradio.ru/hypefm_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf0b",
    like: false,
    name: "Хамелеон",
    url: "https://str.pcradio.ru/Hameleon-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecf0e",
    like: false,
    name: "Хит FM (Москва)",
    url: "https://str.pcradio.ru/hitfmfeelgood-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecf10",
    like: false,
    name: "Хит FM (Сургут)",
    url: "https://str.pcradio.ru/hitfm_surgut-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecf15",
    like: false,
    name: "Хит плюс",
    url: "https://str.pcradio.ru/Hit_plus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf16",
    like: false,
    name: "Хит!",
    url: "https://str.pcradio.ru/Pop-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf17",
    like: false,
    name: "Хиты 90-х",
    url: "https://str.pcradio.ru/e_90-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf18",
    like: false,
    name: "2 FM",
    url: "https://str.pcradio.ru/hity_rossii-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf19",
    like: false,
    name: "Хиты шансона",
    url: "https://str.pcradio.ru/shanson_hits-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf1a",
    like: false,
    name: "Хорошее радио",
    url: "https://str.pcradio.ru/horoshee_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf1b",
    like: false,
    name: "Христианское радио 123",
    url: "https://str.pcradio.ru/radio123_by-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf1c",
    like: false,
    name: "Центр FM",
    url: "https://str.pcradio.ru/centerfm_by-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf1d",
    like: false,
    name: "Чайф",
    url: "https://str.pcradio.ru/Chaif-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf1e",
    like: false,
    name: "Черный Обелиск",
    url: "https://str.pcradio.ru/cherny_obelisk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf1f",
    like: false,
    name: "Чиж и Ко",
    url: "https://str.pcradio.ru/chizh_i_ko-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf20",
    like: false,
    name: "Чипльдук",
    url: "https://str.pcradio.ru/chipelduk-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecf2a",
    like: false,
    name: "Шансон Волна",
    url: "https://str.pcradio.ru/Shanson_volna-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf2b",
    like: false,
    name: "Шансон онлайн",
    url: "https://str.pcradio.ru/shanson_online-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf2c",
    like: false,
    name: "Шансон Плюс",
    url: "https://str.pcradio.ru/shanson_plus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecf2e",
    like: false,
    name: "Шансон Хит",
    url: "https://str.pcradio.ru/Shanson_hit-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecf30",
    like: false,
    name: "Шоколад",
    url: "https://str.pcradio.ru/chocoradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf31",
    like: false,
    name: "Шоу Голос",
    url: "https://str.pcradio.ru/Golos-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf32",
    like: false,
    name: "Шура",
    url: "https://str.pcradio.ru/Shura-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf33",
    like: false,
    name: "Шура Каретный 18+",
    url: "https://str.pcradio.ru/Shura_Karetniy-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf34",
    like: false,
    name: "ЭкоРадио",
    url: "https://str.pcradio.ru/ekoradio_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf35",
    like: false,
    name: "Экспресс Радио (Орел)",
    url: "https://str.pcradio.ru/express_radio_orel-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf36",
    like: false,
    name: "Электроклуб",
    url: "https://str.pcradio.ru/Jelektroklub-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf37",
    like: false,
    name: "Эльдорадио",
    url: "https://str.pcradio.ru/eldoradio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf38",
    like: false,
    name: "Этническая музыка",
    url: "https://str.pcradio.ru/Etno-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecf3c",
    like: false,
    name: "Югра",
    url: "https://str.pcradio.ru/ugra_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecf3e",
    like: false,
    name: "Юлдаш",
    url: "https://str.pcradio.ru/uldashfm_ru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf3f",
    like: false,
    name: "Юлдаш Plus",
    url: "https://str.pcradio.ru/uldash_plus-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf40",
    like: false,
    name: "Юлия Савичева",
    url: "https://str.pcradio.ru/Savicheva-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf41",
    like: false,
    name: "Юмор FM",
    url: "https://str.pcradio.ru/yumor_fm-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf42",
    like: false,
    name: "Юмор FM (Минск)",
    url: "https://str.pcradio.ru/humorfm_by-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf43",
    like: false,
    name: "Юмор FM (Рига)",
    url: "https://str.pcradio.ru/yumor_riga-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf44",
    like: false,
    name: "Юмор FM (Таллинн)",
    url: "https://str.pcradio.ru/jumorfm_ee-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf45",
    like: false,
    name: "Юнитон FM 100.7",
    url: "https://str.pcradio.ru/unitonru-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf46",
    like: false,
    name: "Юрий Антонов",
    url: "https://str.pcradio.ru/Jurij_Antonov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf47",
    like: false,
    name: "Юрий Визбор",
    url: "https://str.pcradio.ru/yuri_vizbor-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf48",
    like: false,
    name: "Юрий Лоза",
    url: "https://str.pcradio.ru/Loza-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf49",
    like: false,
    name: "Юрий Шатунов",
    url: "https://str.pcradio.ru/Jurij_Shatunov-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf4a",
    like: false,
    name: "Як 40",
    url: "https://str.pcradio.ru/Yak_40-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf4b",
    like: false,
    name: "ЯпаРадио",
    url: "https://str.pcradio.ru/yapa_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
  {
    id: "62ba0c283ca1f692853ecf4c",
    like: false,
    name: "ЯсенБит 18+",
    url: "https://str.pcradio.ru/yasenbit_net-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },

  {
    id: "62ba0c283ca1f692853ecf4e",
    like: false,
    name: "Яхт-Радио",
    url: "https://str.pcradio.ru/yacht_radio-hi",
    img: "https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/ba/9d/2f/ba9d2fde-8269-34bf-bc98-3b14d0257e7a/AppIcon-85-220-4-2x.png/1200x630bb.png",
  },
];
